//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ApiBaseUrl = new InjectionToken<string>('ApiBaseUrl');

@Injectable({
    providedIn: 'root'
})
export class AssessmentResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(resultId?: string | null | undefined): Observable<GetAssessmentResultResponse> {
        let url_ = this.baseUrl + "/AssessmentResult/Get?";
        if (resultId !== undefined && resultId !== null)
            url_ += "resultId=" + encodeURIComponent("" + resultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssessmentResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssessmentResultResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAssessmentResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssessmentResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssessmentResultResponse>(null as any);
    }

    save(request: SaveAssessmentResultRequest): Observable<SaveAssessmentResultResponse> {
        let url_ = this.baseUrl + "/AssessmentResult/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveAssessmentResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveAssessmentResultResponse>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<SaveAssessmentResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveAssessmentResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveAssessmentResultResponse>(null as any);
    }

    saveCounselorInput(request: SaveCounselorInputRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/AssessmentResult/SaveCounselorInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCounselorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCounselorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveCounselorInput(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getStudentAssessments(id: string | null): Observable<GetStudentAssessmentsResponse> {
        let url_ = this.baseUrl + "/AssessmentResult/GetStudentAssessments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentAssessments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentAssessments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStudentAssessmentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStudentAssessmentsResponse>;
        }));
    }

    protected processGetStudentAssessments(response: HttpResponseBase): Observable<GetStudentAssessmentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStudentAssessmentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStudentAssessmentsResponse>(null as any);
    }

    getFirstRespondersSelfScreeningHistoryPreviews(id?: string | null | undefined): Observable<GetFirstRespondersSelfScreeningHistoryPreviewResponse> {
        let url_ = this.baseUrl + "/AssessmentResult/GetFirstRespondersSelfScreeningHistoryPreviews?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstRespondersSelfScreeningHistoryPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstRespondersSelfScreeningHistoryPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFirstRespondersSelfScreeningHistoryPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFirstRespondersSelfScreeningHistoryPreviewResponse>;
        }));
    }

    protected processGetFirstRespondersSelfScreeningHistoryPreviews(response: HttpResponseBase): Observable<GetFirstRespondersSelfScreeningHistoryPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFirstRespondersSelfScreeningHistoryPreviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFirstRespondersSelfScreeningHistoryPreviewResponse>(null as any);
    }

    getFirstRespondersSelfScreeningAssessmentResult(id?: string | null | undefined): Observable<GetFirstRespondersSelfScreeningAssessmentResultResponse> {
        let url_ = this.baseUrl + "/AssessmentResult/GetFirstRespondersSelfScreeningAssessmentResult?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstRespondersSelfScreeningAssessmentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstRespondersSelfScreeningAssessmentResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFirstRespondersSelfScreeningAssessmentResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFirstRespondersSelfScreeningAssessmentResultResponse>;
        }));
    }

    protected processGetFirstRespondersSelfScreeningAssessmentResult(response: HttpResponseBase): Observable<GetFirstRespondersSelfScreeningAssessmentResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFirstRespondersSelfScreeningAssessmentResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFirstRespondersSelfScreeningAssessmentResultResponse>(null as any);
    }

    getNewAssessmentResultsCount(): Observable<GetNewAssessmentResultsCountResponse> {
        let url_ = this.baseUrl + "/AssessmentResult/GetNewAssessmentResultsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewAssessmentResultsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewAssessmentResultsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewAssessmentResultsCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewAssessmentResultsCountResponse>;
        }));
    }

    protected processGetNewAssessmentResultsCount(response: HttpResponseBase): Observable<GetNewAssessmentResultsCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewAssessmentResultsCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewAssessmentResultsCountResponse>(null as any);
    }

    getSchoolAssessmentResultsDemographicStats(riskLevel?: string | null | undefined): Observable<GetSchoolAssessmentResultsDemographicStatsResponse> {
        let url_ = this.baseUrl + "/AssessmentResult/GetSchoolAssessmentResultsDemographicStats?";
        if (riskLevel !== undefined && riskLevel !== null)
            url_ += "riskLevel=" + encodeURIComponent("" + riskLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchoolAssessmentResultsDemographicStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchoolAssessmentResultsDemographicStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSchoolAssessmentResultsDemographicStatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSchoolAssessmentResultsDemographicStatsResponse>;
        }));
    }

    protected processGetSchoolAssessmentResultsDemographicStats(response: HttpResponseBase): Observable<GetSchoolAssessmentResultsDemographicStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSchoolAssessmentResultsDemographicStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSchoolAssessmentResultsDemographicStatsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BranchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getAll(): Observable<GetAllBranchesResponse> {
        let url_ = this.baseUrl + "/Branch/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllBranchesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllBranchesResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetAllBranchesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllBranchesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllBranchesResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(id?: string | null | undefined): Observable<GetCaseResponse> {
        let url_ = this.baseUrl + "/Case/Get?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaseResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCaseResponse>(null as any);
    }

    getFirstRespondersAssessmentsCase(id?: string | null | undefined): Observable<GetAssessmentsForCaseResponse> {
        let url_ = this.baseUrl + "/Case/GetFirstRespondersAssessmentsCase?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstRespondersAssessmentsCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstRespondersAssessmentsCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssessmentsForCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssessmentsForCaseResponse>;
        }));
    }

    protected processGetFirstRespondersAssessmentsCase(response: HttpResponseBase): Observable<GetAssessmentsForCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssessmentsForCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssessmentsForCaseResponse>(null as any);
    }

    saveAssessmentsCase(request: SaveFrHcwCaseRequest): Observable<SaveFrHcwCaseResponse> {
        let url_ = this.baseUrl + "/Case/SaveAssessmentsCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAssessmentsCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAssessmentsCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveFrHcwCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveFrHcwCaseResponse>;
        }));
    }

    protected processSaveAssessmentsCase(response: HttpResponseBase): Observable<SaveFrHcwCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveFrHcwCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveFrHcwCaseResponse>(null as any);
    }

    updateCaseNotes(request: UpdateCaseNotesRequest): Observable<UpdateCaseNotesResponse> {
        let url_ = this.baseUrl + "/Case/UpdateCaseNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCaseNotesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCaseNotesResponse>;
        }));
    }

    protected processUpdateCaseNotes(response: HttpResponseBase): Observable<UpdateCaseNotesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCaseNotesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCaseNotesResponse>(null as any);
    }

    getCaseNotes(caseId?: string | null | undefined): Observable<GetCaseNotesResponse> {
        let url_ = this.baseUrl + "/Case/GetCaseNotes?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaseNotesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaseNotesResponse>;
        }));
    }

    protected processGetCaseNotes(response: HttpResponseBase): Observable<GetCaseNotesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseNotesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCaseNotesResponse>(null as any);
    }

    updateCaseStatusWithNote(request: UpdateCaseStatusWithNoteRequest): Observable<UpdateCaseStatusWithNoteResponse> {
        let url_ = this.baseUrl + "/Case/UpdateCaseStatusWithNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseStatusWithNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseStatusWithNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCaseStatusWithNoteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCaseStatusWithNoteResponse>;
        }));
    }

    protected processUpdateCaseStatusWithNote(response: HttpResponseBase): Observable<UpdateCaseStatusWithNoteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCaseStatusWithNoteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCaseStatusWithNoteResponse>(null as any);
    }

    uploadDocument(caseId: string | null, fileType: string | null, isValid?: boolean | null | undefined, file?: FileParameter[] | null | undefined): Observable<UploadCaseDocumentsResponse> {
        let url_ = this.baseUrl + "/Case/{caseId}/UploadDocument/{fileType}?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        if (isValid !== undefined && isValid !== null)
            url_ += "isValid=" + encodeURIComponent("" + isValid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            file.forEach(item_ => content_.append("file", item_.data, item_.fileName ? item_.fileName : "file") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadCaseDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadCaseDocumentsResponse>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<UploadCaseDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadCaseDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadCaseDocumentsResponse>(null as any);
    }

    downloadFile(caseId: string | null, fileName: string | null): Observable<DownloadCaseDocumentResponse> {
        let url_ = this.baseUrl + "/Case/{caseId}/DownloadFile/{fileName}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadCaseDocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadCaseDocumentResponse>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<DownloadCaseDocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadCaseDocumentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadCaseDocumentResponse>(null as any);
    }

    updateCaseStatus(request: UpdateCaseStatusRequest): Observable<UpdateCaseStatusResponse> {
        let url_ = this.baseUrl + "/Case/UpdateCaseStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCaseStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCaseStatusResponse>;
        }));
    }

    protected processUpdateCaseStatus(response: HttpResponseBase): Observable<UpdateCaseStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCaseStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCaseStatusResponse>(null as any);
    }

    getCasesByCounselor(id?: string | null | undefined): Observable<GetCasesByCounselorResponse> {
        let url_ = this.baseUrl + "/Case/GetCasesByCounselor?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCasesByCounselor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCasesByCounselor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCasesByCounselorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCasesByCounselorResponse>;
        }));
    }

    protected processGetCasesByCounselor(response: HttpResponseBase): Observable<GetCasesByCounselorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCasesByCounselorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCasesByCounselorResponse>(null as any);
    }

    canAccessCase(counselorId?: string | null | undefined, caseId?: string | null | undefined): Observable<CanAccessCaseResponse> {
        let url_ = this.baseUrl + "/Case/CanAccessCase?";
        if (counselorId !== undefined && counselorId !== null)
            url_ += "counselorId=" + encodeURIComponent("" + counselorId) + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanAccessCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanAccessCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanAccessCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanAccessCaseResponse>;
        }));
    }

    protected processCanAccessCase(response: HttpResponseBase): Observable<CanAccessCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanAccessCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CanAccessCaseResponse>(null as any);
    }

    getPreviews(participantId?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<GetCasePreviewsResponse> {
        let url_ = this.baseUrl + "/Case/GetPreviews?";
        if (participantId !== undefined && participantId !== null)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCasePreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCasePreviewsResponse>;
        }));
    }

    protected processGetPreviews(response: HttpResponseBase): Observable<GetCasePreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCasePreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCasePreviewsResponse>(null as any);
    }

    createSchoolCase(request: CreateSchoolCaseRequest): Observable<CreateSchoolCaseResponse> {
        let url_ = this.baseUrl + "/Case/CreateSchoolCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSchoolCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSchoolCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSchoolCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSchoolCaseResponse>;
        }));
    }

    protected processCreateSchoolCase(response: HttpResponseBase): Observable<CreateSchoolCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSchoolCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSchoolCaseResponse>(null as any);
    }

    getSchoolCaseById(id: string | null): Observable<GetSchoolCaseByIdResponse> {
        let url_ = this.baseUrl + "/Case/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchoolCaseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchoolCaseById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSchoolCaseByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSchoolCaseByIdResponse>;
        }));
    }

    protected processGetSchoolCaseById(response: HttpResponseBase): Observable<GetSchoolCaseByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSchoolCaseByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSchoolCaseByIdResponse>(null as any);
    }

    getSchoolCasesByOrganization(request: GetSchoolCasesByOrganizationRequest): Observable<GetSchoolCasesByOrganizationResponse> {
        let url_ = this.baseUrl + "/Case/GetSchoolCasesByOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchoolCasesByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchoolCasesByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSchoolCasesByOrganizationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSchoolCasesByOrganizationResponse>;
        }));
    }

    protected processGetSchoolCasesByOrganization(response: HttpResponseBase): Observable<GetSchoolCasesByOrganizationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSchoolCasesByOrganizationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSchoolCasesByOrganizationResponse>(null as any);
    }

    getHotlinePreviewsForCurrentUser(page?: number | undefined, pageSize?: number | undefined): Observable<GetHotlineCasesForCurrentUserResponse> {
        let url_ = this.baseUrl + "/Case/GetHotlinePreviewsForCurrentUser?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotlinePreviewsForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotlinePreviewsForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHotlineCasesForCurrentUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHotlineCasesForCurrentUserResponse>;
        }));
    }

    protected processGetHotlinePreviewsForCurrentUser(response: HttpResponseBase): Observable<GetHotlineCasesForCurrentUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHotlineCasesForCurrentUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHotlineCasesForCurrentUserResponse>(null as any);
    }

    dismissCase(caseId?: string | null | undefined, userId?: string | null | undefined): Observable<DismissCaseResponse> {
        let url_ = this.baseUrl + "/Case/DismissCase?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DismissCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DismissCaseResponse>;
        }));
    }

    protected processDismissCase(response: HttpResponseBase): Observable<DismissCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DismissCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DismissCaseResponse>(null as any);
    }

    updateSchoolAssignee(caseId?: string | null | undefined, userObjectId?: string | null | undefined, userType?: string | null | undefined): Observable<UpdateSchoolAssigneeResponse> {
        let url_ = this.baseUrl + "/Case/UpdateSchoolAssignee?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (userObjectId !== undefined && userObjectId !== null)
            url_ += "userObjectId=" + encodeURIComponent("" + userObjectId) + "&";
        if (userType !== undefined && userType !== null)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSchoolAssignee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSchoolAssignee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSchoolAssigneeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSchoolAssigneeResponse>;
        }));
    }

    protected processUpdateSchoolAssignee(response: HttpResponseBase): Observable<UpdateSchoolAssigneeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSchoolAssigneeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSchoolAssigneeResponse>(null as any);
    }

    quickSearchCases(search?: string | null | undefined, limit?: number | undefined): Observable<QuickSearchCasesResponse> {
        let url_ = this.baseUrl + "/Case/QuickSearchCases?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickSearchCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickSearchCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuickSearchCasesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuickSearchCasesResponse>;
        }));
    }

    protected processQuickSearchCases(response: HttpResponseBase): Observable<QuickSearchCasesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuickSearchCasesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuickSearchCasesResponse>(null as any);
    }

    updateParticipantId(caseId?: string | null | undefined, participantId?: string | null | undefined): Observable<UpdateParticipantIdResponse> {
        let url_ = this.baseUrl + "/Case/UpdateParticipantId?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (participantId !== undefined && participantId !== null)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParticipantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParticipantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateParticipantIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateParticipantIdResponse>;
        }));
    }

    protected processUpdateParticipantId(response: HttpResponseBase): Observable<UpdateParticipantIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateParticipantIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateParticipantIdResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    updateHotlineSchedule(request: UpdateScheduleRequest): Observable<UpdateScheduleResponse> {
        let url_ = this.baseUrl + "/Configuration/UpdateHotlineSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHotlineSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHotlineSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateScheduleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateScheduleResponse>;
        }));
    }

    protected processUpdateHotlineSchedule(response: HttpResponseBase): Observable<UpdateScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateScheduleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateScheduleResponse>(null as any);
    }

    getHotlineSchedule(): Observable<GetHotlineScheduleResponse> {
        let url_ = this.baseUrl + "/Configuration/GetHotlineSchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotlineSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotlineSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHotlineScheduleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHotlineScheduleResponse>;
        }));
    }

    protected processGetHotlineSchedule(response: HttpResponseBase): Observable<GetHotlineScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHotlineScheduleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHotlineScheduleResponse>(null as any);
    }

    getIncidentResponseTypes(): Observable<GetIncidentResponseTypesResponse> {
        let url_ = this.baseUrl + "/Configuration/GetIncidentResponseTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentResponseTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentResponseTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncidentResponseTypesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncidentResponseTypesResponse>;
        }));
    }

    protected processGetIncidentResponseTypes(response: HttpResponseBase): Observable<GetIncidentResponseTypesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncidentResponseTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncidentResponseTypesResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CounselorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getCounselor(): Observable<GetCounselorResponse> {
        let url_ = this.baseUrl + "/Counselor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounselor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounselor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCounselorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCounselorResponse>;
        }));
    }

    protected processGetCounselor(response: HttpResponseBase): Observable<GetCounselorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCounselorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCounselorResponse>(null as any);
    }

    getCounselorByUserId(userId: string | null): Observable<GetCounselorByUserIdResponse> {
        let url_ = this.baseUrl + "/Counselor/GetCounselorByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounselorByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounselorByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCounselorByUserIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCounselorByUserIdResponse>;
        }));
    }

    protected processGetCounselorByUserId(response: HttpResponseBase): Observable<GetCounselorByUserIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCounselorByUserIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCounselorByUserIdResponse>(null as any);
    }

    canAccessSchoolCase(counselorId?: string | null | undefined, caseId?: string | null | undefined): Observable<CanAccessSchoolCaseResponse> {
        let url_ = this.baseUrl + "/Counselor/CanAccessSchoolCase?";
        if (counselorId !== undefined && counselorId !== null)
            url_ += "counselorId=" + encodeURIComponent("" + counselorId) + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanAccessSchoolCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanAccessSchoolCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanAccessSchoolCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanAccessSchoolCaseResponse>;
        }));
    }

    protected processCanAccessSchoolCase(response: HttpResponseBase): Observable<CanAccessSchoolCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanAccessSchoolCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CanAccessSchoolCaseResponse>(null as any);
    }

    updateNotificationSettings(request: UpdateNotificationSettingsRequest): Observable<UpdateNotificationSettingsResponse> {
        let url_ = this.baseUrl + "/Counselor/notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateNotificationSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateNotificationSettingsResponse>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<UpdateNotificationSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateNotificationSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateNotificationSettingsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DistrictClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getAll(branchId?: string | null | undefined): Observable<GetDistrictsResponse> {
        let url_ = this.baseUrl + "/District?";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDistrictsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDistrictsResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetDistrictsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDistrictsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDistrictsResponse>(null as any);
    }

    getById(id: string | null): Observable<GetDistrictResponse> {
        let url_ = this.baseUrl + "/District/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDistrictResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDistrictResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetDistrictResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDistrictResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDistrictResponse>(null as any);
    }

    getDistrictsByRegion(regionId?: string | null | undefined): Observable<GetRegionDistrictsResponse> {
        let url_ = this.baseUrl + "/District/GetDistrictsByRegion?";
        if (regionId !== undefined && regionId !== null)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistrictsByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistrictsByRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionDistrictsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionDistrictsResponse>;
        }));
    }

    protected processGetDistrictsByRegion(response: HttpResponseBase): Observable<GetRegionDistrictsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionDistrictsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegionDistrictsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IncidentReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(id?: string | null | undefined): Observable<GetIncidentReportResponse> {
        let url_ = this.baseUrl + "/IncidentReport?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncidentReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncidentReportResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetIncidentReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncidentReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncidentReportResponse>(null as any);
    }

    create(request: CreateIncidentReportRequest): Observable<CreateIncidentReportResponse> {
        let url_ = this.baseUrl + "/IncidentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateIncidentReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateIncidentReportResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateIncidentReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIncidentReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateIncidentReportResponse>(null as any);
    }

    update(request: UpdateIncidentReportRequest): Observable<UpdateIncidentReportResponse> {
        let url_ = this.baseUrl + "/IncidentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateIncidentReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateIncidentReportResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateIncidentReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateIncidentReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateIncidentReportResponse>(null as any);
    }

    updateAccess(request: UpdateIncidentReportAccessRequest): Observable<UpdateIncidentReportAccessResponse> {
        let url_ = this.baseUrl + "/IncidentReport/Status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateIncidentReportAccessResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateIncidentReportAccessResponse>;
        }));
    }

    protected processUpdateAccess(response: HttpResponseBase): Observable<UpdateIncidentReportAccessResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateIncidentReportAccessResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateIncidentReportAccessResponse>(null as any);
    }

    getPreviews(): Observable<GetIncidentReportPreviewsResponse> {
        let url_ = this.baseUrl + "/IncidentReport/GetPreviews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncidentReportPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncidentReportPreviewsResponse>;
        }));
    }

    protected processGetPreviews(response: HttpResponseBase): Observable<GetIncidentReportPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncidentReportPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncidentReportPreviewsResponse>(null as any);
    }

    createEvent(incidentReportId: string | null, request: CreateIncidentEventRequest): Observable<CreateIncidentEventResponse> {
        let url_ = this.baseUrl + "/{incidentReportId}/Event";
        if (incidentReportId === undefined || incidentReportId === null)
            throw new Error("The parameter 'incidentReportId' must be defined.");
        url_ = url_.replace("{incidentReportId}", encodeURIComponent("" + incidentReportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateIncidentEventResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateIncidentEventResponse>;
        }));
    }

    protected processCreateEvent(response: HttpResponseBase): Observable<CreateIncidentEventResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIncidentEventResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateIncidentEventResponse>(null as any);
    }

    updateEvent(request: UpdateIncidentEventRequest): Observable<UpdateIncidentEventResponse> {
        let url_ = this.baseUrl + "/IncidentReport/UpdateEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateIncidentEventResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateIncidentEventResponse>;
        }));
    }

    protected processUpdateEvent(response: HttpResponseBase): Observable<UpdateIncidentEventResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateIncidentEventResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateIncidentEventResponse>(null as any);
    }

    getEvent(reportId?: string | null | undefined, eventId?: string | null | undefined): Observable<GetIncidentEventResponse> {
        let url_ = this.baseUrl + "/IncidentReport/GetEvent?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (eventId !== undefined && eventId !== null)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncidentEventResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncidentEventResponse>;
        }));
    }

    protected processGetEvent(response: HttpResponseBase): Observable<GetIncidentEventResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncidentEventResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncidentEventResponse>(null as any);
    }

    deleteEvent(reportId?: string | null | undefined, eventId?: string | null | undefined): Observable<DeleteIncidentEventResponse> {
        let url_ = this.baseUrl + "/IncidentReport/DeleteEvent?";
        if (reportId !== undefined && reportId !== null)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (eventId !== undefined && eventId !== null)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteIncidentEventResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteIncidentEventResponse>;
        }));
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<DeleteIncidentEventResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteIncidentEventResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteIncidentEventResponse>(null as any);
    }

    assignUserToEventResource(request: AssignUserToResourceRequest): Observable<AssignUserToResourceResponse> {
        let url_ = this.baseUrl + "/IncidentReport/AssignUserToEventResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToEventResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToEventResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignUserToResourceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignUserToResourceResponse>;
        }));
    }

    protected processAssignUserToEventResource(response: HttpResponseBase): Observable<AssignUserToResourceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignUserToResourceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssignUserToResourceResponse>(null as any);
    }

    unAssignUserToEventResource(request: UnassignUserToResourceRequest): Observable<UnassignUserToResourceResponse> {
        let url_ = this.baseUrl + "/IncidentReport/UnAssignUserToEventResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnAssignUserToEventResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnAssignUserToEventResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnassignUserToResourceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnassignUserToResourceResponse>;
        }));
    }

    protected processUnAssignUserToEventResource(response: HttpResponseBase): Observable<UnassignUserToResourceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnassignUserToResourceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnassignUserToResourceResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InsuranceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getAll(includeUsageCount?: boolean | undefined): Observable<GetInsurancesResponse> {
        let url_ = this.baseUrl + "/Insurance/GetAll?";
        if (includeUsageCount === null)
            throw new Error("The parameter 'includeUsageCount' cannot be null.");
        else if (includeUsageCount !== undefined)
            url_ += "includeUsageCount=" + encodeURIComponent("" + includeUsageCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInsurancesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInsurancesResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetInsurancesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInsurancesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInsurancesResponse>(null as any);
    }

    create(name?: string | null | undefined): Observable<AddInsuranceResponse> {
        let url_ = this.baseUrl + "/Insurance/Create?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddInsuranceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddInsuranceResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AddInsuranceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddInsuranceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddInsuranceResponse>(null as any);
    }

    update(id?: string | null | undefined, name?: string | null | undefined): Observable<UpdateInsuranceResponse> {
        let url_ = this.baseUrl + "/Insurance/Update?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateInsuranceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateInsuranceResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateInsuranceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateInsuranceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateInsuranceResponse>(null as any);
    }

    delete(id?: string | null | undefined): Observable<DeleteInsuranceResponse> {
        let url_ = this.baseUrl + "/Insurance/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteInsuranceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteInsuranceResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteInsuranceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteInsuranceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteInsuranceResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    geocode(address?: string | null | undefined): Observable<GeocodeResponse> {
        let url_ = this.baseUrl + "/Location?";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeocode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeocode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeocodeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeocodeResponse>;
        }));
    }

    protected processGeocode(response: HttpResponseBase): Observable<GeocodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeocodeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeocodeResponse>(null as any);
    }

    updateAll(): Observable<boolean> {
        let url_ = this.baseUrl + "/Location/update-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateAll(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NeedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(needCode?: string | null | undefined, includeUsageCount?: boolean | undefined, includeEmptySubneeds?: boolean | undefined): Observable<NeedViewModel[]> {
        let url_ = this.baseUrl + "/Need/Get?";
        if (needCode !== undefined && needCode !== null)
            url_ += "needCode=" + encodeURIComponent("" + needCode) + "&";
        if (includeUsageCount === null)
            throw new Error("The parameter 'includeUsageCount' cannot be null.");
        else if (includeUsageCount !== undefined)
            url_ += "includeUsageCount=" + encodeURIComponent("" + includeUsageCount) + "&";
        if (includeEmptySubneeds === null)
            throw new Error("The parameter 'includeEmptySubneeds' cannot be null.");
        else if (includeEmptySubneeds !== undefined)
            url_ += "includeEmptySubneeds=" + encodeURIComponent("" + includeEmptySubneeds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NeedViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NeedViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NeedViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeedViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NeedViewModel[]>(null as any);
    }

    needCodeInUse(code?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/Need/NeedCodeInUse?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNeedCodeInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNeedCodeInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processNeedCodeInUse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    create(request: CreateNeedRequest): Observable<CreateNeedResponse> {
        let url_ = this.baseUrl + "/Need";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateNeedResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateNeedResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateNeedResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateNeedResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateNeedResponse>(null as any);
    }

    deleteNeed(needCode?: string | null | undefined, isSubNeed?: boolean | undefined): Observable<DeleteNeedResponse> {
        let url_ = this.baseUrl + "/Need?";
        if (needCode !== undefined && needCode !== null)
            url_ += "needCode=" + encodeURIComponent("" + needCode) + "&";
        if (isSubNeed === null)
            throw new Error("The parameter 'isSubNeed' cannot be null.");
        else if (isSubNeed !== undefined)
            url_ += "isSubNeed=" + encodeURIComponent("" + isSubNeed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNeed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNeed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteNeedResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteNeedResponse>;
        }));
    }

    protected processDeleteNeed(response: HttpResponseBase): Observable<DeleteNeedResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteNeedResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteNeedResponse>(null as any);
    }

    updateName(request: UpdateNeedNameRequest): Observable<UpdateNeedNameResponse> {
        let url_ = this.baseUrl + "/Need/UpdateName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateNeedNameResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateNeedNameResponse>;
        }));
    }

    protected processUpdateName(response: HttpResponseBase): Observable<UpdateNeedNameResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateNeedNameResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateNeedNameResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getAll(districtId?: string | null | undefined, branchId?: string | null | undefined): Observable<GetOrganizationsResponse> {
        let url_ = this.baseUrl + "/Organization?";
        if (districtId !== undefined && districtId !== null)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationsResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetOrganizationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrganizationsResponse>(null as any);
    }

    create(request: AddNewLocationRequest): Observable<AddNewLocationResponse> {
        let url_ = this.baseUrl + "/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddNewLocationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddNewLocationResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AddNewLocationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewLocationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddNewLocationResponse>(null as any);
    }

    getAllLocations(districtId?: string | null | undefined, branchId?: string | null | undefined): Observable<GetLocationsResponse> {
        let url_ = this.baseUrl + "/Organization/GetAllLocations?";
        if (districtId !== undefined && districtId !== null)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationsResponse>;
        }));
    }

    protected processGetAllLocations(response: HttpResponseBase): Observable<GetLocationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationsResponse>(null as any);
    }

    disable(organizationId?: string | null | undefined): Observable<DisableOrganizationResponse> {
        let url_ = this.baseUrl + "/Organization/Disable?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisableOrganizationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisableOrganizationResponse>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<DisableOrganizationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableOrganizationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DisableOrganizationResponse>(null as any);
    }

    getOptions(branchId?: string | null | undefined): Observable<GetOrganizationOptionsResponse> {
        let url_ = this.baseUrl + "/Organization/GetOptions?";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationOptionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationOptionsResponse>;
        }));
    }

    protected processGetOptions(response: HttpResponseBase): Observable<GetOrganizationOptionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationOptionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrganizationOptionsResponse>(null as any);
    }

    updateEnabledAssessments(request: UpdateEnabledAssessmentsRequest): Observable<UpdateEnabledAssessmentsResponse> {
        let url_ = this.baseUrl + "/Organization/UpdateEnabledAssessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEnabledAssessments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEnabledAssessments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateEnabledAssessmentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateEnabledAssessmentsResponse>;
        }));
    }

    protected processUpdateEnabledAssessments(response: HttpResponseBase): Observable<UpdateEnabledAssessmentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateEnabledAssessmentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateEnabledAssessmentsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ParticipantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    create(request: CreateParticipantRequest): Observable<CreateParticipantResponse> {
        let url_ = this.baseUrl + "/Participant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateParticipantResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateParticipantResponse>(null as any);
    }

    register(request: RegisterParticipantRequest): Observable<RegisterParticipantResponse> {
        let url_ = this.baseUrl + "/Participant/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterParticipantResponse>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ParticipantExistsException.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterParticipantResponse>(null as any);
    }

    updateParticipantProfile(request: UpdateParticipantProfileRequest): Observable<UpdateParticipantProfileResponse> {
        let url_ = this.baseUrl + "/Participant/UpdateParticipantProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParticipantProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParticipantProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateParticipantProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateParticipantProfileResponse>;
        }));
    }

    protected processUpdateParticipantProfile(response: HttpResponseBase): Observable<UpdateParticipantProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateParticipantProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ParticipantDoesNotExistException.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateParticipantProfileResponse>(null as any);
    }

    update(request: UpdateParticipantRequest): Observable<UpdateParticipantResponse> {
        let url_ = this.baseUrl + "/Participant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateParticipantResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateParticipantResponse>(null as any);
    }

    get(firstName?: string | null | undefined, lastName?: string | null | undefined, dateOfBirth?: string | null | undefined, externalId?: string | null | undefined, emailAddress?: string | null | undefined, organizationIds?: string[] | null | undefined, districtIds?: string[] | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, limit?: number | undefined): Observable<GetParticipantsResponse> {
        let url_ = this.baseUrl + "/Participant?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "DateOfBirth=" + encodeURIComponent("" + dateOfBirth) + "&";
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (organizationIds !== undefined && organizationIds !== null)
            organizationIds && organizationIds.forEach(item => { url_ += "OrganizationIds=" + encodeURIComponent("" + item) + "&"; });
        if (districtIds !== undefined && districtIds !== null)
            districtIds && districtIds.forEach(item => { url_ += "DistrictIds=" + encodeURIComponent("" + item) + "&"; });
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParticipantsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParticipantsResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetParticipantsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParticipantsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetParticipantsResponse>(null as any);
    }

    getById(id: string | null): Observable<GetParticipantResponse> {
        let url_ = this.baseUrl + "/Participant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParticipantResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetParticipantResponse>(null as any);
    }

    quickSearch(search?: string | null | undefined, counselorOrganizationIds?: string[] | null | undefined, counselorDistrictIds?: string[] | null | undefined, limit?: number | undefined): Observable<QuickSearchParticipantsResponse> {
        let url_ = this.baseUrl + "/Participant/quick-search-participant?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (counselorOrganizationIds !== undefined && counselorOrganizationIds !== null)
            counselorOrganizationIds && counselorOrganizationIds.forEach(item => { url_ += "CounselorOrganizationIds=" + encodeURIComponent("" + item) + "&"; });
        if (counselorDistrictIds !== undefined && counselorDistrictIds !== null)
            counselorDistrictIds && counselorDistrictIds.forEach(item => { url_ += "CounselorDistrictIds=" + encodeURIComponent("" + item) + "&"; });
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuickSearchParticipantsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuickSearchParticipantsResponse>;
        }));
    }

    protected processQuickSearch(response: HttpResponseBase): Observable<QuickSearchParticipantsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuickSearchParticipantsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuickSearchParticipantsResponse>(null as any);
    }

    uploadDocument(userId: string | null, fileType: string | null, isValid?: boolean | null | undefined, file?: FileParameter[] | null | undefined): Observable<UploadDocumentsResponse> {
        let url_ = this.baseUrl + "/Participant/{userId}/UploadDocument/{fileType}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        if (isValid !== undefined && isValid !== null)
            url_ += "isValid=" + encodeURIComponent("" + isValid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            file.forEach(item_ => content_.append("file", item_.data, item_.fileName ? item_.fileName : "file") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadDocumentsResponse>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<UploadDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadDocumentsResponse>(null as any);
    }

    updateStudentProfile(profileRequest: UpdateStudentProfileRequest): Observable<UpdateStudentProfileResponse> {
        let url_ = this.baseUrl + "/Participant/UpdateStudentProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStudentProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStudentProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateStudentProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateStudentProfileResponse>;
        }));
    }

    protected processUpdateStudentProfile(response: HttpResponseBase): Observable<UpdateStudentProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateStudentProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateStudentProfileResponse>(null as any);
    }

    downloadFile(userId: string | null, fileName: string | null): Observable<DownloadDocumentResponse> {
        let url_ = this.baseUrl + "/Participant/{userId}/DownloadFile/{fileName}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadDocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadDocumentResponse>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<DownloadDocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadDocumentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadDocumentResponse>(null as any);
    }

    getMe(): Observable<GetParticipantByUserIdResponse> {
        let url_ = this.baseUrl + "/Participant/GetMe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParticipantByUserIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParticipantByUserIdResponse>;
        }));
    }

    protected processGetMe(response: HttpResponseBase): Observable<GetParticipantByUserIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParticipantByUserIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetParticipantByUserIdResponse>(null as any);
    }

    getByUserId(id: string | null): Observable<GetParticipantByUserIdResponse> {
        let url_ = this.baseUrl + "/Participant/GetByUserId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParticipantByUserIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParticipantByUserIdResponse>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<GetParticipantByUserIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParticipantByUserIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetParticipantByUserIdResponse>(null as any);
    }

    updateParticipantBooleanAttribute(request: UpdateParticipantAttributeRequest): Observable<UpdateParticipantAttributeResponse> {
        let url_ = this.baseUrl + "/Participant/UpdateParticipantBooleanAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParticipantBooleanAttribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParticipantBooleanAttribute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateParticipantAttributeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateParticipantAttributeResponse>;
        }));
    }

    protected processUpdateParticipantBooleanAttribute(response: HttpResponseBase): Observable<UpdateParticipantAttributeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateParticipantAttributeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateParticipantAttributeResponse>(null as any);
    }

    optOut(request: OptOutRequest): Observable<UpdateParticipantAttributeResponse> {
        let url_ = this.baseUrl + "/Participant/OptOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOptOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOptOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateParticipantAttributeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateParticipantAttributeResponse>;
        }));
    }

    protected processOptOut(response: HttpResponseBase): Observable<UpdateParticipantAttributeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateParticipantAttributeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateParticipantAttributeResponse>(null as any);
    }

    getHotlineAndCounselorUsersForParticipant(participantId?: string | null | undefined): Observable<GetHotlineAndCounselorUsersForParticipantResponse> {
        let url_ = this.baseUrl + "/Participant/GetHotlineAndCounselorUsersForParticipant?";
        if (participantId !== undefined && participantId !== null)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotlineAndCounselorUsersForParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotlineAndCounselorUsersForParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHotlineAndCounselorUsersForParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHotlineAndCounselorUsersForParticipantResponse>;
        }));
    }

    protected processGetHotlineAndCounselorUsersForParticipant(response: HttpResponseBase): Observable<GetHotlineAndCounselorUsersForParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHotlineAndCounselorUsersForParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHotlineAndCounselorUsersForParticipantResponse>(null as any);
    }

    counselorRegisterParticipant(request: CounselorRegisterSchoolParticipantRequest): Observable<CounselorRegisterSchoolParticipantResponse> {
        let url_ = this.baseUrl + "/Participant/CounselorRegisterParticipant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCounselorRegisterParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCounselorRegisterParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CounselorRegisterSchoolParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CounselorRegisterSchoolParticipantResponse>;
        }));
    }

    protected processCounselorRegisterParticipant(response: HttpResponseBase): Observable<CounselorRegisterSchoolParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CounselorRegisterSchoolParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CounselorRegisterSchoolParticipantResponse>(null as any);
    }

    sendWaiverNotification(participantId?: string | null | undefined): Observable<SendWaiverNotificationResponse> {
        let url_ = this.baseUrl + "/Participant/SendWaiverNotification?";
        if (participantId !== undefined && participantId !== null)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWaiverNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWaiverNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendWaiverNotificationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendWaiverNotificationResponse>;
        }));
    }

    protected processSendWaiverNotification(response: HttpResponseBase): Observable<SendWaiverNotificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendWaiverNotificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendWaiverNotificationResponse>(null as any);
    }

    sendRegistrationEmail(email?: string | null | undefined): Observable<SendRegistrationEmailResponse> {
        let url_ = this.baseUrl + "/Participant/SendRegistrationEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRegistrationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRegistrationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendRegistrationEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendRegistrationEmailResponse>;
        }));
    }

    protected processSendRegistrationEmail(response: HttpResponseBase): Observable<SendRegistrationEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendRegistrationEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendRegistrationEmailResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PartnerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(id: string | null): Observable<PartnerViewModel> {
        let url_ = this.baseUrl + "/Partner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PartnerViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerViewModel>(null as any);
    }

    search(request: GetPartnersRequest): Observable<GetPartnersResponse> {
        let url_ = this.baseUrl + "/Partner/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnersResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetPartnersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPartnersResponse>(null as any);
    }

    create(request: CreatePartnerRequest): Observable<CreatePartnerResponse> {
        let url_ = this.baseUrl + "/Partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePartnerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePartnerResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePartnerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePartnerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePartnerResponse>(null as any);
    }

    update(request: UpdatePartnerRequest): Observable<UpdatePartnerResponse> {
        let url_ = this.baseUrl + "/Partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePartnerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePartnerResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePartnerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePartnerResponse>(null as any);
    }

    addLocations(request: AddLocationsRequest): Observable<AddLocationsResponse> {
        let url_ = this.baseUrl + "/Partner/AddLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddLocationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddLocationsResponse>;
        }));
    }

    protected processAddLocations(response: HttpResponseBase): Observable<AddLocationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddLocationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddLocationsResponse>(null as any);
    }

    delete(request: DeletePartnerRequest): Observable<DeletePartnerResponse> {
        let url_ = this.baseUrl + "/Partner/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePartnerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePartnerResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePartnerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = DeletePartnerResponse.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePartnerResponse>(null as any);
    }

    quickSearch(search?: string | null | undefined, limit?: number | undefined): Observable<QuickSearchPartnersResponse> {
        let url_ = this.baseUrl + "/Partner/QuickSearch?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuickSearchPartnersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuickSearchPartnersResponse>;
        }));
    }

    protected processQuickSearch(response: HttpResponseBase): Observable<QuickSearchPartnersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuickSearchPartnersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuickSearchPartnersResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProviderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(id: string | null): Observable<ProviderViewModel> {
        let url_ = this.baseUrl + "/Provider/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProviderViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderViewModel>(null as any);
    }

    getMany(request: GetProvidersRequest): Observable<GetProvidersResponse> {
        let url_ = this.baseUrl + "/Provider/GetMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProvidersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProvidersResponse>;
        }));
    }

    protected processGetMany(response: HttpResponseBase): Observable<GetProvidersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProvidersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProvidersResponse>(null as any);
    }

    search(request: SearchProvidersRequest): Observable<SearchProvidersResponse> {
        let url_ = this.baseUrl + "/Provider/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchProvidersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchProvidersResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchProvidersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchProvidersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchProvidersResponse>(null as any);
    }

    create(request: CreateProviderRequest): Observable<CreateProviderResponse> {
        let url_ = this.baseUrl + "/Provider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProviderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProviderResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateProviderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateProviderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateProviderResponse>(null as any);
    }

    update(request: UpdateProviderRequest): Observable<UpdateProviderResponse> {
        let url_ = this.baseUrl + "/Provider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateProviderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateProviderResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateProviderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProviderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateProviderResponse>(null as any);
    }

    delete(request: DeleteProviderRequest): Observable<DeleteProviderResponse> {
        let url_ = this.baseUrl + "/Provider/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteProviderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteProviderResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteProviderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = DeleteProviderResponse.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteProviderResponse>(null as any);
    }

    quickSearchAdmin(search?: string | null | undefined, limit?: number | undefined): Observable<QuickSearchProvidersPartnersResponse> {
        let url_ = this.baseUrl + "/Provider/QuickSearchAdmin?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickSearchAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickSearchAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuickSearchProvidersPartnersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuickSearchProvidersPartnersResponse>;
        }));
    }

    protected processQuickSearchAdmin(response: HttpResponseBase): Observable<QuickSearchProvidersPartnersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuickSearchProvidersPartnersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuickSearchProvidersPartnersResponse>(null as any);
    }

    getProvidersAndPartners(id?: string | null | undefined, name?: string | null | undefined, areasOfNeed?: string[] | null | undefined, phone?: string | null | undefined, representatives?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, limit?: number | undefined): Observable<GetProvidersAndPartnersResponse> {
        let url_ = this.baseUrl + "/Provider/GetProvidersAndPartners?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (areasOfNeed !== undefined && areasOfNeed !== null)
            areasOfNeed && areasOfNeed.forEach(item => { url_ += "AreasOfNeed=" + encodeURIComponent("" + item) + "&"; });
        if (phone !== undefined && phone !== null)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (representatives !== undefined && representatives !== null)
            url_ += "Representatives=" + encodeURIComponent("" + representatives) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidersAndPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidersAndPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProvidersAndPartnersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProvidersAndPartnersResponse>;
        }));
    }

    protected processGetProvidersAndPartners(response: HttpResponseBase): Observable<GetProvidersAndPartnersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProvidersAndPartnersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProvidersAndPartnersResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RegionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getRegionsByBranch(branchId?: string | null | undefined): Observable<GetBranchRegionsResponse> {
        let url_ = this.baseUrl + "/Region/GetRegionsByBranch?";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionsByBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionsByBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBranchRegionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBranchRegionsResponse>;
        }));
    }

    protected processGetRegionsByBranch(response: HttpResponseBase): Observable<GetBranchRegionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchRegionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchRegionsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResourceDirectoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    search(request: SearchResourceDirectoryEntriesRequest): Observable<SearchResourceDirectoryEntriesResponse> {
        let url_ = this.baseUrl + "/ResourceDirectory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResourceDirectoryEntriesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResourceDirectoryEntriesResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchResourceDirectoryEntriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResourceDirectoryEntriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchResourceDirectoryEntriesResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StatsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getAspenAnalytics(): Observable<GetAspenAnalyticsResponse> {
        let url_ = this.baseUrl + "/Stats/GetAspenAnalytics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAspenAnalytics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAspenAnalytics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAspenAnalyticsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAspenAnalyticsResponse>;
        }));
    }

    protected processGetAspenAnalytics(response: HttpResponseBase): Observable<GetAspenAnalyticsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAspenAnalyticsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAspenAnalyticsResponse>(null as any);
    }

    getDistrictStats(districtIds?: string[] | null | undefined): Observable<GetStatsResponse> {
        let url_ = this.baseUrl + "/Stats/GetDistrictStats?";
        if (districtIds !== undefined && districtIds !== null)
            districtIds && districtIds.forEach(item => { url_ += "districtIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistrictStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistrictStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStatsResponse>;
        }));
    }

    protected processGetDistrictStats(response: HttpResponseBase): Observable<GetStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStatsResponse>(null as any);
    }

    getOrganizationStats(organizationIds?: string[] | null | undefined): Observable<GetStatsResponse> {
        let url_ = this.baseUrl + "/Stats/GetOrganizationStats?";
        if (organizationIds !== undefined && organizationIds !== null)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStatsResponse>;
        }));
    }

    protected processGetOrganizationStats(response: HttpResponseBase): Observable<GetStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStatsResponse>(null as any);
    }

    getAllDistrictStats(): Observable<GetStatsResponse> {
        let url_ = this.baseUrl + "/Stats/GetAllDistrictStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistrictStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistrictStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStatsResponse>;
        }));
    }

    protected processGetAllDistrictStats(response: HttpResponseBase): Observable<GetStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStatsResponse>(null as any);
    }

    getAllOrganizationStats(): Observable<GetStatsResponse> {
        let url_ = this.baseUrl + "/Stats/GetAllOrganizationStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStatsResponse>;
        }));
    }

    protected processGetAllOrganizationStats(response: HttpResponseBase): Observable<GetStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStatsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getUserPreviews(pageIndex?: number | undefined, pageSize?: number | undefined, sortBy?: string | null | undefined, sortDirection?: SortDirection | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, roles?: string[] | null | undefined, branchIds?: string[] | null | undefined): Observable<GetUserPreviewsResponse> {
        let url_ = this.baseUrl + "/User?";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
        if (branchIds !== undefined && branchIds !== null)
            branchIds && branchIds.forEach(item => { url_ += "BranchIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPreviewsResponse>;
        }));
    }

    protected processGetUserPreviews(response: HttpResponseBase): Observable<GetUserPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPreviewsResponse>(null as any);
    }

    delete(id?: string | null | undefined): Observable<GetByUserIdResponse> {
        let url_ = this.baseUrl + "/User?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetByUserIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetByUserIdResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<GetByUserIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetByUserIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetByUserIdResponse>(null as any);
    }

    getIncidentResponseUsers(request: GetIncidentResponseUsersRequest): Observable<GetIncidentResponseUsersResponse> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentResponseUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentResponseUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncidentResponseUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncidentResponseUsersResponse>;
        }));
    }

    protected processGetIncidentResponseUsers(response: HttpResponseBase): Observable<GetIncidentResponseUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncidentResponseUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncidentResponseUsersResponse>(null as any);
    }

    create(request: CreateUserRequest): Observable<CreateUserResponse> {
        let url_ = this.baseUrl + "/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateUserResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateUserResponse>(null as any);
    }

    getByUserId(userId?: string | null | undefined, includeCurrentProfileData?: boolean | undefined): Observable<GetByUserIdResponse> {
        let url_ = this.baseUrl + "/User/GetByUserId?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (includeCurrentProfileData === null)
            throw new Error("The parameter 'includeCurrentProfileData' cannot be null.");
        else if (includeCurrentProfileData !== undefined)
            url_ += "includeCurrentProfileData=" + encodeURIComponent("" + includeCurrentProfileData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetByUserIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetByUserIdResponse>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<GetByUserIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetByUserIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetByUserIdResponse>(null as any);
    }

    update(request: UpdateUserRequest): Observable<UpdateUserResponse> {
        let url_ = this.baseUrl + "/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WaiverClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    searchJotformSubmissions(request: SearchJotformSubmissionsRequest): Observable<SearchJotformSubmissionsResponse> {
        let url_ = this.baseUrl + "/Waiver/SearchJotformSubmissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchJotformSubmissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchJotformSubmissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchJotformSubmissionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchJotformSubmissionsResponse>;
        }));
    }

    protected processSearchJotformSubmissions(response: HttpResponseBase): Observable<SearchJotformSubmissionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchJotformSubmissionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchJotformSubmissionsResponse>(null as any);
    }

    getJotformSubmissionRawDataById(id?: string | null | undefined, submissionId?: string | null | undefined): Observable<GetJotformSubmissionRawDataByIdResponse> {
        let url_ = this.baseUrl + "/Waiver/GetJotformSubmissionRawDataById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (submissionId !== undefined && submissionId !== null)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJotformSubmissionRawDataById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJotformSubmissionRawDataById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJotformSubmissionRawDataByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJotformSubmissionRawDataByIdResponse>;
        }));
    }

    protected processGetJotformSubmissionRawDataById(response: HttpResponseBase): Observable<GetJotformSubmissionRawDataByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJotformSubmissionRawDataByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJotformSubmissionRawDataByIdResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(): Observable<Feature[]> {
        let url_ = this.baseUrl + "/FeatureFlags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Feature[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Feature[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Feature[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Feature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Feature[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    save(request: SaveAssessmentResultRequest): Observable<SaveAssessmentResultResponse> {
        let url_ = this.baseUrl + "/Public/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveAssessmentResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveAssessmentResultResponse>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<SaveAssessmentResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveAssessmentResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveAssessmentResultResponse>(null as any);
    }

    getAssessmentResult(resultId?: string | null | undefined, assessmentResultKey?: string | null | undefined): Observable<GetAssessmentResultResponse> {
        let url_ = this.baseUrl + "/Public/GetAssessmentResult?";
        if (resultId !== undefined && resultId !== null)
            url_ += "resultId=" + encodeURIComponent("" + resultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-assessment-result-key": assessmentResultKey !== undefined && assessmentResultKey !== null ? "" + assessmentResultKey : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssessmentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssessmentResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssessmentResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssessmentResultResponse>;
        }));
    }

    protected processGetAssessmentResult(response: HttpResponseBase): Observable<GetAssessmentResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssessmentResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssessmentResultResponse>(null as any);
    }

    getSchoolDistricts(): Observable<GetSchoolDistrictsResponse> {
        let url_ = this.baseUrl + "/Public/GetSchoolDistricts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchoolDistricts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchoolDistricts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSchoolDistrictsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSchoolDistrictsResponse>;
        }));
    }

    protected processGetSchoolDistricts(response: HttpResponseBase): Observable<GetSchoolDistrictsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSchoolDistrictsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSchoolDistrictsResponse>(null as any);
    }

    getSchoolOrganizations(districtId?: string | null | undefined): Observable<GetSchoolOrganizationsResponse> {
        let url_ = this.baseUrl + "/Public/GetSchoolOrganizations?";
        if (districtId !== undefined && districtId !== null)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchoolOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchoolOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSchoolOrganizationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSchoolOrganizationsResponse>;
        }));
    }

    protected processGetSchoolOrganizations(response: HttpResponseBase): Observable<GetSchoolOrganizationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSchoolOrganizationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSchoolOrganizationsResponse>(null as any);
    }

    getDistricts(branchId?: string | null | undefined): Observable<GetDistrictsResponse2> {
        let url_ = this.baseUrl + "/Public/GetDistricts?";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistricts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistricts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDistrictsResponse2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDistrictsResponse2>;
        }));
    }

    protected processGetDistricts(response: HttpResponseBase): Observable<GetDistrictsResponse2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDistrictsResponse2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDistrictsResponse2>(null as any);
    }

    getOrganizations(branchId?: string | null | undefined, districtId?: string | null | undefined): Observable<GetOrganizationsResponse2> {
        let url_ = this.baseUrl + "/Public/GetOrganizations?";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (districtId !== undefined && districtId !== null)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationsResponse2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationsResponse2>;
        }));
    }

    protected processGetOrganizations(response: HttpResponseBase): Observable<GetOrganizationsResponse2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationsResponse2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrganizationsResponse2>(null as any);
    }

    getNeeds(needCode?: string | null | undefined, includeUsageCount?: boolean | undefined, includeEmptySubneeds?: boolean | undefined): Observable<NeedViewModel[]> {
        let url_ = this.baseUrl + "/Public/GetNeeds?";
        if (needCode !== undefined && needCode !== null)
            url_ += "needCode=" + encodeURIComponent("" + needCode) + "&";
        if (includeUsageCount === null)
            throw new Error("The parameter 'includeUsageCount' cannot be null.");
        else if (includeUsageCount !== undefined)
            url_ += "includeUsageCount=" + encodeURIComponent("" + includeUsageCount) + "&";
        if (includeEmptySubneeds === null)
            throw new Error("The parameter 'includeEmptySubneeds' cannot be null.");
        else if (includeEmptySubneeds !== undefined)
            url_ += "includeEmptySubneeds=" + encodeURIComponent("" + includeEmptySubneeds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNeeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNeeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NeedViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NeedViewModel[]>;
        }));
    }

    protected processGetNeeds(response: HttpResponseBase): Observable<NeedViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeedViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NeedViewModel[]>(null as any);
    }

    saveSecondaryAssessmentData(request: SaveSecondaryAssessmentDataRequest): Observable<SaveSecondaryAssessmentDataResponse> {
        let url_ = this.baseUrl + "/Public/SaveSecondaryAssessmentData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSecondaryAssessmentData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSecondaryAssessmentData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveSecondaryAssessmentDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveSecondaryAssessmentDataResponse>;
        }));
    }

    protected processSaveSecondaryAssessmentData(response: HttpResponseBase): Observable<SaveSecondaryAssessmentDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveSecondaryAssessmentDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveSecondaryAssessmentDataResponse>(null as any);
    }

    getDemographicData(assessmentId?: string | null | undefined): Observable<GetDemographicDataResponse> {
        let url_ = this.baseUrl + "/Public/GetDemographicData?";
        if (assessmentId !== undefined && assessmentId !== null)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDemographicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDemographicData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDemographicDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDemographicDataResponse>;
        }));
    }

    protected processGetDemographicData(response: HttpResponseBase): Observable<GetDemographicDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDemographicDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDemographicDataResponse>(null as any);
    }

    getAuthUser(userId?: string | null | undefined, profileType?: ProfileType | null | undefined): Observable<GetAuthUserResponse> {
        let url_ = this.baseUrl + "/Public/GetAuthUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (profileType !== undefined && profileType !== null)
            url_ += "profileType=" + encodeURIComponent("" + profileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAuthUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAuthUserResponse>;
        }));
    }

    protected processGetAuthUser(response: HttpResponseBase): Observable<GetAuthUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAuthUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAuthUserResponse>(null as any);
    }

    createPlaceholderParticipant(request: CreatePlaceholderParticipantRequest): Observable<CreatePlaceholderParticipantResponse> {
        let url_ = this.baseUrl + "/Public/CreatePlaceholderParticipant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePlaceholderParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePlaceholderParticipantResponse>;
        }));
    }

    protected processCreatePlaceholderParticipant(response: HttpResponseBase): Observable<CreatePlaceholderParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePlaceholderParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePlaceholderParticipantResponse>(null as any);
    }

    linkParticipantIfExists(request: LinkPlaceholderToUserRequest): Observable<LinkPlaceholderToUserResponse> {
        let url_ = this.baseUrl + "/Public/LinkParticipantIfExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkParticipantIfExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkParticipantIfExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkPlaceholderToUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkPlaceholderToUserResponse>;
        }));
    }

    protected processLinkParticipantIfExists(response: HttpResponseBase): Observable<LinkPlaceholderToUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkPlaceholderToUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LinkPlaceholderToUserResponse>(null as any);
    }

    getDepartments(): Observable<GetDepartmentsResponse> {
        let url_ = this.baseUrl + "/Public/GetDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentsResponse>;
        }));
    }

    protected processGetDepartments(response: HttpResponseBase): Observable<GetDepartmentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentsResponse>(null as any);
    }

    checkIfUserEmailExists(email?: string | null | undefined): Observable<CheckIfUserEmailExistsResponse> {
        let url_ = this.baseUrl + "/Public/CheckIfUserEmailExists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfUserEmailExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfUserEmailExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckIfUserEmailExistsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckIfUserEmailExistsResponse>;
        }));
    }

    protected processCheckIfUserEmailExists(response: HttpResponseBase): Observable<CheckIfUserEmailExistsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckIfUserEmailExistsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckIfUserEmailExistsResponse>(null as any);
    }

    getAssessmentBranch(assessmentId?: string | null | undefined): Observable<GetAssessmentBranchResponse> {
        let url_ = this.baseUrl + "/Public/GetAssessmentBranch?";
        if (assessmentId !== undefined && assessmentId !== null)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssessmentBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssessmentBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssessmentBranchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssessmentBranchResponse>;
        }));
    }

    protected processGetAssessmentBranch(response: HttpResponseBase): Observable<GetAssessmentBranchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssessmentBranchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssessmentBranchResponse>(null as any);
    }

    getAllInsurances(): Observable<GetInsurancesResponse> {
        let url_ = this.baseUrl + "/Public/GetAllInsurances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInsurances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInsurances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInsurancesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInsurancesResponse>;
        }));
    }

    protected processGetAllInsurances(response: HttpResponseBase): Observable<GetInsurancesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInsurancesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInsurancesResponse>(null as any);
    }
}

export class GetAssessmentResultResponse implements IGetAssessmentResultResponse {
    results?: AssessmentResultViewModel | null;
    canAccess?: boolean;

    constructor(data?: IGetAssessmentResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.results = _data["results"] ? AssessmentResultViewModel.fromJS(_data["results"]) : <any>null;
            this.canAccess = _data["canAccess"] !== undefined ? _data["canAccess"] : <any>null;
        }
    }

    static fromJS(data: any): GetAssessmentResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssessmentResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["results"] = this.results ? this.results.toJSON() : <any>null;
        data["canAccess"] = this.canAccess !== undefined ? this.canAccess : <any>null;
        return data;
    }

    clone(): GetAssessmentResultResponse {
        const json = this.toJSON();
        let result = new GetAssessmentResultResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAssessmentResultResponse {
    results?: AssessmentResultViewModel | null;
    canAccess?: boolean;
}

export class AssessmentResultViewModel implements IAssessmentResultViewModel {
    id?: string | null;
    branchId?: string | null;
    branchName?: BranchName | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus;
    assessment?: any | null;
    participant?: ParticipantDto | null;
    counselorInput?: CounselorInputViewModel | null;
    demographics?: DemographicDataViewModel | null;
    secondaryAssessment?: SecondaryAssessmentViewModel | null;
    subScore?: SubScoreViewModel[] | null;

    constructor(data?: IAssessmentResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.assessment = _data["assessment"] !== undefined ? _data["assessment"] : <any>null;
            this.participant = _data["participant"] ? ParticipantDto.fromJS(_data["participant"]) : <any>null;
            this.counselorInput = _data["counselorInput"] ? CounselorInputViewModel.fromJS(_data["counselorInput"]) : <any>null;
            this.demographics = _data["demographics"] ? DemographicDataViewModel.fromJS(_data["demographics"]) : <any>null;
            this.secondaryAssessment = _data["secondaryAssessment"] ? SecondaryAssessmentViewModel.fromJS(_data["secondaryAssessment"]) : <any>null;
            if (Array.isArray(_data["subScore"])) {
                this.subScore = [] as any;
                for (let item of _data["subScore"])
                    this.subScore!.push(SubScoreViewModel.fromJS(item));
            }
            else {
                this.subScore = <any>null;
            }
        }
    }

    static fromJS(data: any): AssessmentResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["branchName"] = this.branchName !== undefined ? this.branchName : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["assessment"] = this.assessment !== undefined ? this.assessment : <any>null;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        data["counselorInput"] = this.counselorInput ? this.counselorInput.toJSON() : <any>null;
        data["demographics"] = this.demographics ? this.demographics.toJSON() : <any>null;
        data["secondaryAssessment"] = this.secondaryAssessment ? this.secondaryAssessment.toJSON() : <any>null;
        if (Array.isArray(this.subScore)) {
            data["subScore"] = [];
            for (let item of this.subScore)
                data["subScore"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssessmentResultViewModel {
        const json = this.toJSON();
        let result = new AssessmentResultViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssessmentResultViewModel {
    id?: string | null;
    branchId?: string | null;
    branchName?: BranchName | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus;
    assessment?: any | null;
    participant?: ParticipantDto | null;
    counselorInput?: CounselorInputViewModel | null;
    demographics?: DemographicDataViewModel | null;
    secondaryAssessment?: SecondaryAssessmentViewModel | null;
    subScore?: SubScoreViewModel[] | null;
}

export enum BranchName {
    Schools = "Schools",
    FirstResponders = "FirstResponders",
    HealthcareWorkers = "HealthcareWorkers",
}

export enum AssessmentStatus {
    Initiated = "Initiated",
    InProgress = "InProgress",
    Complete = "Complete",
    Transferred = "Transferred",
}

export class ParticipantDto implements IParticipantDto {
    id?: string | null;
    branchId?: string | null;
    user?: ParticipantUserDto | null;
    organizations?: ParticipantOrganizationDto[] | null;
    contact?: Contact | null;
    counselorId?: string | null;
    waiverUploaded?: boolean | null;
    branchName?: BranchName | null;

    constructor(data?: IParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.user = _data["user"] ? ParticipantUserDto.fromJS(_data["user"]) : <any>null;
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(ParticipantOrganizationDto.fromJS(item));
            }
            else {
                this.organizations = <any>null;
            }
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>null;
            this.counselorId = _data["counselorId"] !== undefined ? _data["counselorId"] : <any>null;
            this.waiverUploaded = _data["waiverUploaded"] !== undefined ? _data["waiverUploaded"] : <any>null;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : <any>null;
        }
    }

    static fromJS(data: any): ParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        data["contact"] = this.contact ? this.contact.toJSON() : <any>null;
        data["counselorId"] = this.counselorId !== undefined ? this.counselorId : <any>null;
        data["waiverUploaded"] = this.waiverUploaded !== undefined ? this.waiverUploaded : <any>null;
        data["branchName"] = this.branchName !== undefined ? this.branchName : <any>null;
        return data;
    }

    clone(): ParticipantDto {
        const json = this.toJSON();
        let result = new ParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IParticipantDto {
    id?: string | null;
    branchId?: string | null;
    user?: ParticipantUserDto | null;
    organizations?: ParticipantOrganizationDto[] | null;
    contact?: Contact | null;
    counselorId?: string | null;
    waiverUploaded?: boolean | null;
    branchName?: BranchName | null;
}

export class ParticipantUserDto implements IParticipantUserDto {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    preferredName?: string | null;
    sex?: string | null;
    gender?: string | null;
    pronoun?: string | null;
    race?: string[] | null;
    dateOfBirth?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    userId?: string | null;

    constructor(data?: IParticipantUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.preferredName = _data["preferredName"] !== undefined ? _data["preferredName"] : <any>null;
            this.sex = _data["sex"] !== undefined ? _data["sex"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.pronoun = _data["pronoun"] !== undefined ? _data["pronoun"] : <any>null;
            if (Array.isArray(_data["race"])) {
                this.race = [] as any;
                for (let item of _data["race"])
                    this.race!.push(item);
            }
            else {
                this.race = <any>null;
            }
            this.dateOfBirth = _data["dateOfBirth"] !== undefined ? _data["dateOfBirth"] : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): ParticipantUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["preferredName"] = this.preferredName !== undefined ? this.preferredName : <any>null;
        data["sex"] = this.sex !== undefined ? this.sex : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["pronoun"] = this.pronoun !== undefined ? this.pronoun : <any>null;
        if (Array.isArray(this.race)) {
            data["race"] = [];
            for (let item of this.race)
                data["race"].push(item);
        }
        data["dateOfBirth"] = this.dateOfBirth !== undefined ? this.dateOfBirth : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }

    clone(): ParticipantUserDto {
        const json = this.toJSON();
        let result = new ParticipantUserDto();
        result.init(json);
        return result;
    }
}

export interface IParticipantUserDto {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    preferredName?: string | null;
    sex?: string | null;
    gender?: string | null;
    pronoun?: string | null;
    race?: string[] | null;
    dateOfBirth?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    userId?: string | null;
}

export class MailingAddress implements IMailingAddress {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    county?: string | null;
    isComplete?: boolean;

    constructor(data?: IMailingAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.isComplete = _data["isComplete"] !== undefined ? _data["isComplete"] : <any>null;
        }
    }

    static fromJS(data: any): MailingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new MailingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["isComplete"] = this.isComplete !== undefined ? this.isComplete : <any>null;
        return data;
    }

    clone(): MailingAddress {
        const json = this.toJSON();
        let result = new MailingAddress();
        result.init(json);
        return result;
    }
}

export interface IMailingAddress {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    county?: string | null;
    isComplete?: boolean;
}

export class ParticipantOrganizationDto implements IParticipantOrganizationDto {
    organizationId?: string | null;
    districtId?: string | null;
    organizationName?: string | null;
    districtName?: string | null;

    constructor(data?: IParticipantOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
        }
    }

    static fromJS(data: any): ParticipantOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        return data;
    }

    clone(): ParticipantOrganizationDto {
        const json = this.toJSON();
        let result = new ParticipantOrganizationDto();
        result.init(json);
        return result;
    }
}

export interface IParticipantOrganizationDto {
    organizationId?: string | null;
    districtId?: string | null;
    organizationName?: string | null;
    districtName?: string | null;
}

export class Contact implements IContact {
    fullName?: string | null;
    phone?: string | null;
    alternatePhone?: string | null;
    emailAddress?: string | null;
    isPrimary?: boolean;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.alternatePhone = _data["alternatePhone"] !== undefined ? _data["alternatePhone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.isPrimary = _data["isPrimary"] !== undefined ? _data["isPrimary"] : <any>null;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["alternatePhone"] = this.alternatePhone !== undefined ? this.alternatePhone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["isPrimary"] = this.isPrimary !== undefined ? this.isPrimary : <any>null;
        return data;
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    fullName?: string | null;
    phone?: string | null;
    alternatePhone?: string | null;
    emailAddress?: string | null;
    isPrimary?: boolean;
}

export class CounselorInputViewModel implements ICounselorInputViewModel {
    counselorId?: string | null;
    counselorName?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    needs?: NeedViewModel[] | null;
    additionalDetails?: string | null;
    privateNotes?: string | null;
    counselorInputComplete?: boolean;

    constructor(data?: ICounselorInputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselorId = _data["counselorId"] !== undefined ? _data["counselorId"] : <any>null;
            this.counselorName = _data["counselorName"] !== undefined ? _data["counselorName"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.priorityLevel = _data["priorityLevel"] !== undefined ? _data["priorityLevel"] : <any>null;
            if (Array.isArray(_data["needs"])) {
                this.needs = [] as any;
                for (let item of _data["needs"])
                    this.needs!.push(NeedViewModel.fromJS(item));
            }
            else {
                this.needs = <any>null;
            }
            this.additionalDetails = _data["additionalDetails"] !== undefined ? _data["additionalDetails"] : <any>null;
            this.privateNotes = _data["privateNotes"] !== undefined ? _data["privateNotes"] : <any>null;
            this.counselorInputComplete = _data["counselorInputComplete"] !== undefined ? _data["counselorInputComplete"] : <any>null;
        }
    }

    static fromJS(data: any): CounselorInputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CounselorInputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselorId"] = this.counselorId !== undefined ? this.counselorId : <any>null;
        data["counselorName"] = this.counselorName !== undefined ? this.counselorName : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["priorityLevel"] = this.priorityLevel !== undefined ? this.priorityLevel : <any>null;
        if (Array.isArray(this.needs)) {
            data["needs"] = [];
            for (let item of this.needs)
                data["needs"].push(item.toJSON());
        }
        data["additionalDetails"] = this.additionalDetails !== undefined ? this.additionalDetails : <any>null;
        data["privateNotes"] = this.privateNotes !== undefined ? this.privateNotes : <any>null;
        data["counselorInputComplete"] = this.counselorInputComplete !== undefined ? this.counselorInputComplete : <any>null;
        return data;
    }

    clone(): CounselorInputViewModel {
        const json = this.toJSON();
        let result = new CounselorInputViewModel();
        result.init(json);
        return result;
    }
}

export interface ICounselorInputViewModel {
    counselorId?: string | null;
    counselorName?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    needs?: NeedViewModel[] | null;
    additionalDetails?: string | null;
    privateNotes?: string | null;
    counselorInputComplete?: boolean;
}

export class NeedViewModel implements INeedViewModel {
    id?: string | null;
    code?: string | null;
    needsName?: string | null;
    parentNeed?: string | null;
    parentNeedCode?: string | null;
    usageCount?: number | null;
    subNeeds?: NeedViewModel[] | null;

    constructor(data?: INeedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.needsName = _data["needsName"] !== undefined ? _data["needsName"] : <any>null;
            this.parentNeed = _data["parentNeed"] !== undefined ? _data["parentNeed"] : <any>null;
            this.parentNeedCode = _data["parentNeedCode"] !== undefined ? _data["parentNeedCode"] : <any>null;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : <any>null;
            if (Array.isArray(_data["subNeeds"])) {
                this.subNeeds = [] as any;
                for (let item of _data["subNeeds"])
                    this.subNeeds!.push(NeedViewModel.fromJS(item));
            }
            else {
                this.subNeeds = <any>null;
            }
        }
    }

    static fromJS(data: any): NeedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NeedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["needsName"] = this.needsName !== undefined ? this.needsName : <any>null;
        data["parentNeed"] = this.parentNeed !== undefined ? this.parentNeed : <any>null;
        data["parentNeedCode"] = this.parentNeedCode !== undefined ? this.parentNeedCode : <any>null;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : <any>null;
        if (Array.isArray(this.subNeeds)) {
            data["subNeeds"] = [];
            for (let item of this.subNeeds)
                data["subNeeds"].push(item.toJSON());
        }
        return data;
    }

    clone(): NeedViewModel {
        const json = this.toJSON();
        let result = new NeedViewModel();
        result.init(json);
        return result;
    }
}

export interface INeedViewModel {
    id?: string | null;
    code?: string | null;
    needsName?: string | null;
    parentNeed?: string | null;
    parentNeedCode?: string | null;
    usageCount?: number | null;
    subNeeds?: NeedViewModel[] | null;
}

export class DemographicDataViewModel implements IDemographicDataViewModel {
    age?: number;
    race?: RaceViewModel | null;
    ethnicity?: string | null;
    biologicalSex?: string | null;
    genderIdentity?: GenderIdentityViewModel | null;
    religiousPreference?: string | null;

    constructor(data?: IDemographicDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.race = _data["race"] ? RaceViewModel.fromJS(_data["race"]) : <any>null;
            this.ethnicity = _data["ethnicity"] !== undefined ? _data["ethnicity"] : <any>null;
            this.biologicalSex = _data["biologicalSex"] !== undefined ? _data["biologicalSex"] : <any>null;
            this.genderIdentity = _data["genderIdentity"] ? GenderIdentityViewModel.fromJS(_data["genderIdentity"]) : <any>null;
            this.religiousPreference = _data["religiousPreference"] !== undefined ? _data["religiousPreference"] : <any>null;
        }
    }

    static fromJS(data: any): DemographicDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DemographicDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["race"] = this.race ? this.race.toJSON() : <any>null;
        data["ethnicity"] = this.ethnicity !== undefined ? this.ethnicity : <any>null;
        data["biologicalSex"] = this.biologicalSex !== undefined ? this.biologicalSex : <any>null;
        data["genderIdentity"] = this.genderIdentity ? this.genderIdentity.toJSON() : <any>null;
        data["religiousPreference"] = this.religiousPreference !== undefined ? this.religiousPreference : <any>null;
        return data;
    }

    clone(): DemographicDataViewModel {
        const json = this.toJSON();
        let result = new DemographicDataViewModel();
        result.init(json);
        return result;
    }
}

export interface IDemographicDataViewModel {
    age?: number;
    race?: RaceViewModel | null;
    ethnicity?: string | null;
    biologicalSex?: string | null;
    genderIdentity?: GenderIdentityViewModel | null;
    religiousPreference?: string | null;
}

export class RaceViewModel implements IRaceViewModel {
    americanIndianOrAlaskaNative?: boolean | null;
    asian?: boolean | null;
    blackOrAfricanAmerican?: boolean | null;
    nativeHawaiianOrOtherPacificIslander?: boolean | null;
    white?: boolean | null;
    other?: string | null;

    constructor(data?: IRaceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.americanIndianOrAlaskaNative = _data["americanIndianOrAlaskaNative"] !== undefined ? _data["americanIndianOrAlaskaNative"] : <any>null;
            this.asian = _data["asian"] !== undefined ? _data["asian"] : <any>null;
            this.blackOrAfricanAmerican = _data["blackOrAfricanAmerican"] !== undefined ? _data["blackOrAfricanAmerican"] : <any>null;
            this.nativeHawaiianOrOtherPacificIslander = _data["nativeHawaiianOrOtherPacificIslander"] !== undefined ? _data["nativeHawaiianOrOtherPacificIslander"] : <any>null;
            this.white = _data["white"] !== undefined ? _data["white"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
        }
    }

    static fromJS(data: any): RaceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RaceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["americanIndianOrAlaskaNative"] = this.americanIndianOrAlaskaNative !== undefined ? this.americanIndianOrAlaskaNative : <any>null;
        data["asian"] = this.asian !== undefined ? this.asian : <any>null;
        data["blackOrAfricanAmerican"] = this.blackOrAfricanAmerican !== undefined ? this.blackOrAfricanAmerican : <any>null;
        data["nativeHawaiianOrOtherPacificIslander"] = this.nativeHawaiianOrOtherPacificIslander !== undefined ? this.nativeHawaiianOrOtherPacificIslander : <any>null;
        data["white"] = this.white !== undefined ? this.white : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        return data;
    }

    clone(): RaceViewModel {
        const json = this.toJSON();
        let result = new RaceViewModel();
        result.init(json);
        return result;
    }
}

export interface IRaceViewModel {
    americanIndianOrAlaskaNative?: boolean | null;
    asian?: boolean | null;
    blackOrAfricanAmerican?: boolean | null;
    nativeHawaiianOrOtherPacificIslander?: boolean | null;
    white?: boolean | null;
    other?: string | null;
}

export class GenderIdentityViewModel implements IGenderIdentityViewModel {
    genderNonConforming?: boolean | null;
    intersex?: boolean | null;
    transgenderWoman?: boolean | null;
    transgenderMan?: boolean | null;
    cisgenderWoman?: boolean | null;
    cisgenderMan?: boolean | null;
    nonBinary?: boolean | null;
    genderqueer?: boolean | null;
    twoSpirit?: boolean | null;
    noAnswer?: boolean | null;
    other?: string | null;

    constructor(data?: IGenderIdentityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.genderNonConforming = _data["genderNonConforming"] !== undefined ? _data["genderNonConforming"] : <any>null;
            this.intersex = _data["intersex"] !== undefined ? _data["intersex"] : <any>null;
            this.transgenderWoman = _data["transgenderWoman"] !== undefined ? _data["transgenderWoman"] : <any>null;
            this.transgenderMan = _data["transgenderMan"] !== undefined ? _data["transgenderMan"] : <any>null;
            this.cisgenderWoman = _data["cisgenderWoman"] !== undefined ? _data["cisgenderWoman"] : <any>null;
            this.cisgenderMan = _data["cisgenderMan"] !== undefined ? _data["cisgenderMan"] : <any>null;
            this.nonBinary = _data["nonBinary"] !== undefined ? _data["nonBinary"] : <any>null;
            this.genderqueer = _data["genderqueer"] !== undefined ? _data["genderqueer"] : <any>null;
            this.twoSpirit = _data["twoSpirit"] !== undefined ? _data["twoSpirit"] : <any>null;
            this.noAnswer = _data["noAnswer"] !== undefined ? _data["noAnswer"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
        }
    }

    static fromJS(data: any): GenderIdentityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenderIdentityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genderNonConforming"] = this.genderNonConforming !== undefined ? this.genderNonConforming : <any>null;
        data["intersex"] = this.intersex !== undefined ? this.intersex : <any>null;
        data["transgenderWoman"] = this.transgenderWoman !== undefined ? this.transgenderWoman : <any>null;
        data["transgenderMan"] = this.transgenderMan !== undefined ? this.transgenderMan : <any>null;
        data["cisgenderWoman"] = this.cisgenderWoman !== undefined ? this.cisgenderWoman : <any>null;
        data["cisgenderMan"] = this.cisgenderMan !== undefined ? this.cisgenderMan : <any>null;
        data["nonBinary"] = this.nonBinary !== undefined ? this.nonBinary : <any>null;
        data["genderqueer"] = this.genderqueer !== undefined ? this.genderqueer : <any>null;
        data["twoSpirit"] = this.twoSpirit !== undefined ? this.twoSpirit : <any>null;
        data["noAnswer"] = this.noAnswer !== undefined ? this.noAnswer : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        return data;
    }

    clone(): GenderIdentityViewModel {
        const json = this.toJSON();
        let result = new GenderIdentityViewModel();
        result.init(json);
        return result;
    }
}

export interface IGenderIdentityViewModel {
    genderNonConforming?: boolean | null;
    intersex?: boolean | null;
    transgenderWoman?: boolean | null;
    transgenderMan?: boolean | null;
    cisgenderWoman?: boolean | null;
    cisgenderMan?: boolean | null;
    nonBinary?: boolean | null;
    genderqueer?: boolean | null;
    twoSpirit?: boolean | null;
    noAnswer?: boolean | null;
    other?: string | null;
}

export class SecondaryAssessmentViewModel implements ISecondaryAssessmentViewModel {
    id?: string | null;
    status?: AssessmentStatus;
    counselorInput?: CounselorInputViewModel | null;

    constructor(data?: ISecondaryAssessmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.counselorInput = _data["counselorInput"] ? CounselorInputViewModel.fromJS(_data["counselorInput"]) : <any>null;
        }
    }

    static fromJS(data: any): SecondaryAssessmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryAssessmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["counselorInput"] = this.counselorInput ? this.counselorInput.toJSON() : <any>null;
        return data;
    }

    clone(): SecondaryAssessmentViewModel {
        const json = this.toJSON();
        let result = new SecondaryAssessmentViewModel();
        result.init(json);
        return result;
    }
}

export interface ISecondaryAssessmentViewModel {
    id?: string | null;
    status?: AssessmentStatus;
    counselorInput?: CounselorInputViewModel | null;
}

export class SubScoreViewModel implements ISubScoreViewModel {
    scoreType?: ScoreType;
    score?: number;

    constructor(data?: ISubScoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreType = _data["scoreType"] !== undefined ? _data["scoreType"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
        }
    }

    static fromJS(data: any): SubScoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubScoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoreType"] = this.scoreType !== undefined ? this.scoreType : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        return data;
    }

    clone(): SubScoreViewModel {
        const json = this.toJSON();
        let result = new SubScoreViewModel();
        result.init(json);
        return result;
    }
}

export interface ISubScoreViewModel {
    scoreType?: ScoreType;
    score?: number;
}

export enum ScoreType {
    InternalizingProblems = "InternalizingProblems",
    AttentionProblems = "AttentionProblems",
    ExternalizingProblems = "ExternalizingProblems",
    Suicidality = "Suicidality",
    TotalScore = "TotalScore",
}

export class SaveAssessmentResultResponse implements ISaveAssessmentResultResponse {
    id?: string | null;
    assessmentResultKey?: string | null;

    constructor(data?: ISaveAssessmentResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.assessmentResultKey = _data["assessmentResultKey"] !== undefined ? _data["assessmentResultKey"] : <any>null;
        }
    }

    static fromJS(data: any): SaveAssessmentResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAssessmentResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["assessmentResultKey"] = this.assessmentResultKey !== undefined ? this.assessmentResultKey : <any>null;
        return data;
    }

    clone(): SaveAssessmentResultResponse {
        const json = this.toJSON();
        let result = new SaveAssessmentResultResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveAssessmentResultResponse {
    id?: string | null;
    assessmentResultKey?: string | null;
}

export class SaveAssessmentResultRequest implements ISaveAssessmentResultRequest {
    results?: AssessmentResultViewModel | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    branchName?: BranchName;

    constructor(data?: ISaveAssessmentResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.results = _data["results"] ? AssessmentResultViewModel.fromJS(_data["results"]) : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.priorityLevel = _data["priorityLevel"] !== undefined ? _data["priorityLevel"] : <any>null;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : <any>null;
        }
    }

    static fromJS(data: any): SaveAssessmentResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAssessmentResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["results"] = this.results ? this.results.toJSON() : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["priorityLevel"] = this.priorityLevel !== undefined ? this.priorityLevel : <any>null;
        data["branchName"] = this.branchName !== undefined ? this.branchName : <any>null;
        return data;
    }

    clone(): SaveAssessmentResultRequest {
        const json = this.toJSON();
        let result = new SaveAssessmentResultRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveAssessmentResultRequest {
    results?: AssessmentResultViewModel | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    branchName?: BranchName;
}

export class SaveCounselorInputRequest implements ISaveCounselorInputRequest {
    assessmentResultId?: string | null;
    counselorInput?: CounselorInputViewModel | null;

    constructor(data?: ISaveCounselorInputRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentResultId = _data["assessmentResultId"] !== undefined ? _data["assessmentResultId"] : <any>null;
            this.counselorInput = _data["counselorInput"] ? CounselorInputViewModel.fromJS(_data["counselorInput"]) : <any>null;
        }
    }

    static fromJS(data: any): SaveCounselorInputRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCounselorInputRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentResultId"] = this.assessmentResultId !== undefined ? this.assessmentResultId : <any>null;
        data["counselorInput"] = this.counselorInput ? this.counselorInput.toJSON() : <any>null;
        return data;
    }

    clone(): SaveCounselorInputRequest {
        const json = this.toJSON();
        let result = new SaveCounselorInputRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveCounselorInputRequest {
    assessmentResultId?: string | null;
    counselorInput?: CounselorInputViewModel | null;
}

export class GetStudentAssessmentsResponse implements IGetStudentAssessmentsResponse {
    assessments?: AssessmentResultViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IGetStudentAssessmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assessments"])) {
                this.assessments = [] as any;
                for (let item of _data["assessments"])
                    this.assessments!.push(AssessmentResultViewModel.fromJS(item));
            }
            else {
                this.assessments = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): GetStudentAssessmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentAssessmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assessments)) {
            data["assessments"] = [];
            for (let item of this.assessments)
                data["assessments"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): GetStudentAssessmentsResponse {
        const json = this.toJSON();
        let result = new GetStudentAssessmentsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetStudentAssessmentsResponse {
    assessments?: AssessmentResultViewModel[] | null;
    resultsLength?: number;
}

export class GetFirstRespondersSelfScreeningHistoryPreviewResponse implements IGetFirstRespondersSelfScreeningHistoryPreviewResponse {
    firstName?: string | null;
    lastName?: string | null;
    preferredName?: string | null;
    userId?: string | null;
    results?: FirstRespondersSelfScreeningHistoryPreviewViewModel[] | null;

    constructor(data?: IGetFirstRespondersSelfScreeningHistoryPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.preferredName = _data["preferredName"] !== undefined ? _data["preferredName"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FirstRespondersSelfScreeningHistoryPreviewViewModel.fromJS(item));
            }
            else {
                this.results = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFirstRespondersSelfScreeningHistoryPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFirstRespondersSelfScreeningHistoryPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["preferredName"] = this.preferredName !== undefined ? this.preferredName : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetFirstRespondersSelfScreeningHistoryPreviewResponse {
        const json = this.toJSON();
        let result = new GetFirstRespondersSelfScreeningHistoryPreviewResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFirstRespondersSelfScreeningHistoryPreviewResponse {
    firstName?: string | null;
    lastName?: string | null;
    preferredName?: string | null;
    userId?: string | null;
    results?: FirstRespondersSelfScreeningHistoryPreviewViewModel[] | null;
}

export class FirstRespondersSelfScreeningHistoryPreviewViewModel implements IFirstRespondersSelfScreeningHistoryPreviewViewModel {
    id?: string | null;
    name?: string | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus;
    riskLevel?: string | null;
    counselorInputComplete?: boolean;

    constructor(data?: IFirstRespondersSelfScreeningHistoryPreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.counselorInputComplete = _data["counselorInputComplete"] !== undefined ? _data["counselorInputComplete"] : <any>null;
        }
    }

    static fromJS(data: any): FirstRespondersSelfScreeningHistoryPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FirstRespondersSelfScreeningHistoryPreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["counselorInputComplete"] = this.counselorInputComplete !== undefined ? this.counselorInputComplete : <any>null;
        return data;
    }

    clone(): FirstRespondersSelfScreeningHistoryPreviewViewModel {
        const json = this.toJSON();
        let result = new FirstRespondersSelfScreeningHistoryPreviewViewModel();
        result.init(json);
        return result;
    }
}

export interface IFirstRespondersSelfScreeningHistoryPreviewViewModel {
    id?: string | null;
    name?: string | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus;
    riskLevel?: string | null;
    counselorInputComplete?: boolean;
}

export class GetFirstRespondersSelfScreeningAssessmentResultResponse implements IGetFirstRespondersSelfScreeningAssessmentResultResponse {
    history?: FirstRespondersAssessmentHistoryViewModel | null;
    hasAccess?: boolean;

    constructor(data?: IGetFirstRespondersSelfScreeningAssessmentResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.history = _data["history"] ? FirstRespondersAssessmentHistoryViewModel.fromJS(_data["history"]) : <any>null;
            this.hasAccess = _data["hasAccess"] !== undefined ? _data["hasAccess"] : <any>null;
        }
    }

    static fromJS(data: any): GetFirstRespondersSelfScreeningAssessmentResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFirstRespondersSelfScreeningAssessmentResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["history"] = this.history ? this.history.toJSON() : <any>null;
        data["hasAccess"] = this.hasAccess !== undefined ? this.hasAccess : <any>null;
        return data;
    }

    clone(): GetFirstRespondersSelfScreeningAssessmentResultResponse {
        const json = this.toJSON();
        let result = new GetFirstRespondersSelfScreeningAssessmentResultResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFirstRespondersSelfScreeningAssessmentResultResponse {
    history?: FirstRespondersAssessmentHistoryViewModel | null;
    hasAccess?: boolean;
}

export class FirstRespondersAssessmentHistoryViewModel implements IFirstRespondersAssessmentHistoryViewModel {
    firstName?: string | null;
    lastName?: string | null;
    preferredName?: string | null;
    userId?: string | null;
    assessmentResult?: FirstRespondersAssessmentResultHistoryViewModel | null;

    constructor(data?: IFirstRespondersAssessmentHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.preferredName = _data["preferredName"] !== undefined ? _data["preferredName"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.assessmentResult = _data["assessmentResult"] ? FirstRespondersAssessmentResultHistoryViewModel.fromJS(_data["assessmentResult"]) : <any>null;
        }
    }

    static fromJS(data: any): FirstRespondersAssessmentHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FirstRespondersAssessmentHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["preferredName"] = this.preferredName !== undefined ? this.preferredName : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["assessmentResult"] = this.assessmentResult ? this.assessmentResult.toJSON() : <any>null;
        return data;
    }

    clone(): FirstRespondersAssessmentHistoryViewModel {
        const json = this.toJSON();
        let result = new FirstRespondersAssessmentHistoryViewModel();
        result.init(json);
        return result;
    }
}

export interface IFirstRespondersAssessmentHistoryViewModel {
    firstName?: string | null;
    lastName?: string | null;
    preferredName?: string | null;
    userId?: string | null;
    assessmentResult?: FirstRespondersAssessmentResultHistoryViewModel | null;
}

export class FirstRespondersAssessmentResultHistoryViewModel implements IFirstRespondersAssessmentResultHistoryViewModel {
    id?: string | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus;
    riskLevel?: string | null;
    participant?: ParticipantDataViewModel | null;
    counselorInput?: CounselorInputViewModel | null;
    frhcwSelfScreeningAssessment?: FRHCWSelfScreeningViewModel | null;
    columbiaAssessment?: FirstRespondersColumbiaViewModel | null;

    constructor(data?: IFirstRespondersAssessmentResultHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.participant = _data["participant"] ? ParticipantDataViewModel.fromJS(_data["participant"]) : <any>null;
            this.counselorInput = _data["counselorInput"] ? CounselorInputViewModel.fromJS(_data["counselorInput"]) : <any>null;
            this.frhcwSelfScreeningAssessment = _data["frhcwSelfScreeningAssessment"] ? FRHCWSelfScreeningViewModel.fromJS(_data["frhcwSelfScreeningAssessment"]) : <any>null;
            this.columbiaAssessment = _data["columbiaAssessment"] ? FirstRespondersColumbiaViewModel.fromJS(_data["columbiaAssessment"]) : <any>null;
        }
    }

    static fromJS(data: any): FirstRespondersAssessmentResultHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FirstRespondersAssessmentResultHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        data["counselorInput"] = this.counselorInput ? this.counselorInput.toJSON() : <any>null;
        data["frhcwSelfScreeningAssessment"] = this.frhcwSelfScreeningAssessment ? this.frhcwSelfScreeningAssessment.toJSON() : <any>null;
        data["columbiaAssessment"] = this.columbiaAssessment ? this.columbiaAssessment.toJSON() : <any>null;
        return data;
    }

    clone(): FirstRespondersAssessmentResultHistoryViewModel {
        const json = this.toJSON();
        let result = new FirstRespondersAssessmentResultHistoryViewModel();
        result.init(json);
        return result;
    }
}

export interface IFirstRespondersAssessmentResultHistoryViewModel {
    id?: string | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus;
    riskLevel?: string | null;
    participant?: ParticipantDataViewModel | null;
    counselorInput?: CounselorInputViewModel | null;
    frhcwSelfScreeningAssessment?: FRHCWSelfScreeningViewModel | null;
    columbiaAssessment?: FirstRespondersColumbiaViewModel | null;
}

export class ParticipantDataViewModel implements IParticipantDataViewModel {
    id?: string | null;
    branchId?: string | null;
    user?: UserViewModel | null;
    districtId?: string | null;
    districtName?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    organizations?: UserOrganizationViewModel[] | null;
    contact?: Contact | null;
    counselorName?: string | null;
    waiverUploaded?: boolean | null;
    participantDocuments?: ParticipantDocument[] | null;
    assessmentSettings?: AssessmentSettings | null;

    constructor(data?: IParticipantDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(UserOrganizationViewModel.fromJS(item));
            }
            else {
                this.organizations = <any>null;
            }
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>null;
            this.counselorName = _data["counselorName"] !== undefined ? _data["counselorName"] : <any>null;
            this.waiverUploaded = _data["waiverUploaded"] !== undefined ? _data["waiverUploaded"] : <any>null;
            if (Array.isArray(_data["participantDocuments"])) {
                this.participantDocuments = [] as any;
                for (let item of _data["participantDocuments"])
                    this.participantDocuments!.push(ParticipantDocument.fromJS(item));
            }
            else {
                this.participantDocuments = <any>null;
            }
            this.assessmentSettings = _data["assessmentSettings"] ? AssessmentSettings.fromJS(_data["assessmentSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): ParticipantDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        data["contact"] = this.contact ? this.contact.toJSON() : <any>null;
        data["counselorName"] = this.counselorName !== undefined ? this.counselorName : <any>null;
        data["waiverUploaded"] = this.waiverUploaded !== undefined ? this.waiverUploaded : <any>null;
        if (Array.isArray(this.participantDocuments)) {
            data["participantDocuments"] = [];
            for (let item of this.participantDocuments)
                data["participantDocuments"].push(item.toJSON());
        }
        data["assessmentSettings"] = this.assessmentSettings ? this.assessmentSettings.toJSON() : <any>null;
        return data;
    }

    clone(): ParticipantDataViewModel {
        const json = this.toJSON();
        let result = new ParticipantDataViewModel();
        result.init(json);
        return result;
    }
}

export interface IParticipantDataViewModel {
    id?: string | null;
    branchId?: string | null;
    user?: UserViewModel | null;
    districtId?: string | null;
    districtName?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    organizations?: UserOrganizationViewModel[] | null;
    contact?: Contact | null;
    counselorName?: string | null;
    waiverUploaded?: boolean | null;
    participantDocuments?: ParticipantDocument[] | null;
    assessmentSettings?: AssessmentSettings | null;
}

export class UserViewModel implements IUserViewModel {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    preferredName?: string | null;
    sex?: string | null;
    gender?: string | null;
    pronoun?: string | null;
    race?: string[] | null;
    dateOfBirth?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    userId?: string | null;
    currentRole?: string | null;
    currentProfileType?: ProfileType;
    currentOrganizations?: UserOrganizationViewModel[] | null;
    profiles?: UserProfileViewModel[] | null;
    responseType?: IncidentResponseType | null;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.preferredName = _data["preferredName"] !== undefined ? _data["preferredName"] : <any>null;
            this.sex = _data["sex"] !== undefined ? _data["sex"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.pronoun = _data["pronoun"] !== undefined ? _data["pronoun"] : <any>null;
            if (Array.isArray(_data["race"])) {
                this.race = [] as any;
                for (let item of _data["race"])
                    this.race!.push(item);
            }
            else {
                this.race = <any>null;
            }
            this.dateOfBirth = _data["dateOfBirth"] !== undefined ? _data["dateOfBirth"] : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.currentRole = _data["currentRole"] !== undefined ? _data["currentRole"] : <any>null;
            this.currentProfileType = _data["currentProfileType"] !== undefined ? _data["currentProfileType"] : <any>null;
            if (Array.isArray(_data["currentOrganizations"])) {
                this.currentOrganizations = [] as any;
                for (let item of _data["currentOrganizations"])
                    this.currentOrganizations!.push(UserOrganizationViewModel.fromJS(item));
            }
            else {
                this.currentOrganizations = <any>null;
            }
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(UserProfileViewModel.fromJS(item));
            }
            else {
                this.profiles = <any>null;
            }
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : <any>null;
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["preferredName"] = this.preferredName !== undefined ? this.preferredName : <any>null;
        data["sex"] = this.sex !== undefined ? this.sex : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["pronoun"] = this.pronoun !== undefined ? this.pronoun : <any>null;
        if (Array.isArray(this.race)) {
            data["race"] = [];
            for (let item of this.race)
                data["race"].push(item);
        }
        data["dateOfBirth"] = this.dateOfBirth !== undefined ? this.dateOfBirth : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["currentRole"] = this.currentRole !== undefined ? this.currentRole : <any>null;
        data["currentProfileType"] = this.currentProfileType !== undefined ? this.currentProfileType : <any>null;
        if (Array.isArray(this.currentOrganizations)) {
            data["currentOrganizations"] = [];
            for (let item of this.currentOrganizations)
                data["currentOrganizations"].push(item.toJSON());
        }
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        data["responseType"] = this.responseType !== undefined ? this.responseType : <any>null;
        return data;
    }

    clone(): UserViewModel {
        const json = this.toJSON();
        let result = new UserViewModel();
        result.init(json);
        return result;
    }
}

export interface IUserViewModel {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    preferredName?: string | null;
    sex?: string | null;
    gender?: string | null;
    pronoun?: string | null;
    race?: string[] | null;
    dateOfBirth?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    userId?: string | null;
    currentRole?: string | null;
    currentProfileType?: ProfileType;
    currentOrganizations?: UserOrganizationViewModel[] | null;
    profiles?: UserProfileViewModel[] | null;
    responseType?: IncidentResponseType | null;
}

export enum ProfileType {
    Admin = "Admin",
    Schools = "Schools",
    FirstResponders = "FirstResponders",
    HealthcareWorkers = "HealthcareWorkers",
    IncidentResponse = "IncidentResponse",
    Participant = "Participant",
    Reporting = "Reporting",
}

export class UserOrganizationViewModel implements IUserOrganizationViewModel {
    branchId?: string | null;
    isActive?: boolean | null;
    activatedOnDate?: Date | null;
    deactivatedOnDate?: Date | null;
    organizationId?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    assessmentSettings?: AssessmentSettings | null;

    constructor(data?: IUserOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.activatedOnDate = _data["activatedOnDate"] ? new Date(_data["activatedOnDate"].toString()) : <any>null;
            this.deactivatedOnDate = _data["deactivatedOnDate"] ? new Date(_data["deactivatedOnDate"].toString()) : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : <any>null;
            this.assessmentSettings = _data["assessmentSettings"] ? AssessmentSettings.fromJS(_data["assessmentSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): UserOrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["activatedOnDate"] = this.activatedOnDate ? this.activatedOnDate.toISOString() : <any>null;
        data["deactivatedOnDate"] = this.deactivatedOnDate ? this.deactivatedOnDate.toISOString() : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        data["assessmentSettings"] = this.assessmentSettings ? this.assessmentSettings.toJSON() : <any>null;
        return data;
    }

    clone(): UserOrganizationViewModel {
        const json = this.toJSON();
        let result = new UserOrganizationViewModel();
        result.init(json);
        return result;
    }
}

export interface IUserOrganizationViewModel {
    branchId?: string | null;
    isActive?: boolean | null;
    activatedOnDate?: Date | null;
    deactivatedOnDate?: Date | null;
    organizationId?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    assessmentSettings?: AssessmentSettings | null;
}

export class AssessmentSettings implements IAssessmentSettings {
    columbiaEnabled?: boolean;
    level2Enabled?: boolean;
    selfScreeningEnabled?: boolean;
    pscyEnabled?: boolean;

    constructor(data?: IAssessmentSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columbiaEnabled = _data["columbiaEnabled"] !== undefined ? _data["columbiaEnabled"] : <any>null;
            this.level2Enabled = _data["level2Enabled"] !== undefined ? _data["level2Enabled"] : <any>null;
            this.selfScreeningEnabled = _data["selfScreeningEnabled"] !== undefined ? _data["selfScreeningEnabled"] : <any>null;
            this.pscyEnabled = _data["pscyEnabled"] !== undefined ? _data["pscyEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): AssessmentSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columbiaEnabled"] = this.columbiaEnabled !== undefined ? this.columbiaEnabled : <any>null;
        data["level2Enabled"] = this.level2Enabled !== undefined ? this.level2Enabled : <any>null;
        data["selfScreeningEnabled"] = this.selfScreeningEnabled !== undefined ? this.selfScreeningEnabled : <any>null;
        data["pscyEnabled"] = this.pscyEnabled !== undefined ? this.pscyEnabled : <any>null;
        return data;
    }

    clone(): AssessmentSettings {
        const json = this.toJSON();
        let result = new AssessmentSettings();
        result.init(json);
        return result;
    }
}

export interface IAssessmentSettings {
    columbiaEnabled?: boolean;
    level2Enabled?: boolean;
    selfScreeningEnabled?: boolean;
    pscyEnabled?: boolean;
}

export class UserProfileViewModel implements IUserProfileViewModel {
    type?: ProfileType;
    role?: string | null;
    accessibleBranchIds?: string[] | null;
    organizations?: UserOrganizationViewModel[] | null;
    isActive?: boolean;

    constructor(data?: IUserProfileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            if (Array.isArray(_data["accessibleBranchIds"])) {
                this.accessibleBranchIds = [] as any;
                for (let item of _data["accessibleBranchIds"])
                    this.accessibleBranchIds!.push(item);
            }
            else {
                this.accessibleBranchIds = <any>null;
            }
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(UserOrganizationViewModel.fromJS(item));
            }
            else {
                this.organizations = <any>null;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): UserProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        if (Array.isArray(this.accessibleBranchIds)) {
            data["accessibleBranchIds"] = [];
            for (let item of this.accessibleBranchIds)
                data["accessibleBranchIds"].push(item);
        }
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }

    clone(): UserProfileViewModel {
        const json = this.toJSON();
        let result = new UserProfileViewModel();
        result.init(json);
        return result;
    }
}

export interface IUserProfileViewModel {
    type?: ProfileType;
    role?: string | null;
    accessibleBranchIds?: string[] | null;
    organizations?: UserOrganizationViewModel[] | null;
    isActive?: boolean;
}

export enum IncidentResponseType {
    AspenAffiliatedUser = "AspenAffiliatedUser",
    TherapyDog = "TherapyDog",
    MeditationSpecialist = "MeditationSpecialist",
    AspenNonAffiliatedCounselor = "AspenNonAffiliatedCounselor",
    AspenNonAffiliatedChaplain = "AspenNonAffiliatedChaplain",
    OtherGeneralSupport = "OtherGeneralSupport",
}

export class ParticipantDocument implements IParticipantDocument {
    fileType?: string | null;
    fileName?: string | null;
    uploadDate?: Date;
    deletedOn?: Date | null;
    documentLocationType?: DocumentLocationType;
    formSubmissionId?: string | null;
    isValid?: boolean;

    constructor(data?: IParticipantDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>null;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>null;
            this.documentLocationType = _data["documentLocationType"] !== undefined ? _data["documentLocationType"] : <any>null;
            this.formSubmissionId = _data["formSubmissionId"] !== undefined ? _data["formSubmissionId"] : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
        }
    }

    static fromJS(data: any): ParticipantDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>null;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>null;
        data["documentLocationType"] = this.documentLocationType !== undefined ? this.documentLocationType : <any>null;
        data["formSubmissionId"] = this.formSubmissionId !== undefined ? this.formSubmissionId : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        return data;
    }

    clone(): ParticipantDocument {
        const json = this.toJSON();
        let result = new ParticipantDocument();
        result.init(json);
        return result;
    }
}

export interface IParticipantDocument {
    fileType?: string | null;
    fileName?: string | null;
    uploadDate?: Date;
    deletedOn?: Date | null;
    documentLocationType?: DocumentLocationType;
    formSubmissionId?: string | null;
    isValid?: boolean;
}

export enum DocumentLocationType {
    Blob = "Blob",
    FormSubmission = "FormSubmission",
}

export class BaseAssessmentViewModel implements IBaseAssessmentViewModel {
    type?: string | null;
    assessmentId?: string | null;
    assessmentName?: string | null;

    constructor(data?: IBaseAssessmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.assessmentId = _data["assessmentId"] !== undefined ? _data["assessmentId"] : <any>null;
            this.assessmentName = _data["assessmentName"] !== undefined ? _data["assessmentName"] : <any>null;
        }
    }

    static fromJS(data: any): BaseAssessmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAssessmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["assessmentId"] = this.assessmentId !== undefined ? this.assessmentId : <any>null;
        data["assessmentName"] = this.assessmentName !== undefined ? this.assessmentName : <any>null;
        return data;
    }

    clone(): BaseAssessmentViewModel {
        const json = this.toJSON();
        let result = new BaseAssessmentViewModel();
        result.init(json);
        return result;
    }
}

export interface IBaseAssessmentViewModel {
    type?: string | null;
    assessmentId?: string | null;
    assessmentName?: string | null;
}

export class FRHCWSelfScreeningViewModel extends BaseAssessmentViewModel implements IFRHCWSelfScreeningViewModel {
    ableToPayBills?: boolean;
    riskOfLosingResidence?: boolean;
    ableToBuyFood?: boolean;
    hasEnoughGas?: boolean;
    inNeedOfMedical?: boolean;
    needChildcare?: boolean;
    concernedAboutFamilyBehavior?: boolean;
    avoidGoingHome?: boolean;
    distressingRecollections?: boolean;
    disturbingDreams?: boolean;
    difficultyWithDecisions?: boolean;
    difficultySleeping?: boolean;
    lossOfInterest?: boolean;
    moodChanges?: boolean;
    alcoholOrAddictiveSubstances?: boolean;
    feelsLikeBurden?: boolean;
    unnecessaryRisks?: boolean;
    suicidalThoughts?: boolean;
    suicideAttempt?: boolean;

    constructor(data?: IFRHCWSelfScreeningViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ableToPayBills = _data["ableToPayBills"] !== undefined ? _data["ableToPayBills"] : <any>null;
            this.riskOfLosingResidence = _data["riskOfLosingResidence"] !== undefined ? _data["riskOfLosingResidence"] : <any>null;
            this.ableToBuyFood = _data["ableToBuyFood"] !== undefined ? _data["ableToBuyFood"] : <any>null;
            this.hasEnoughGas = _data["hasEnoughGas"] !== undefined ? _data["hasEnoughGas"] : <any>null;
            this.inNeedOfMedical = _data["inNeedOfMedical"] !== undefined ? _data["inNeedOfMedical"] : <any>null;
            this.needChildcare = _data["needChildcare"] !== undefined ? _data["needChildcare"] : <any>null;
            this.concernedAboutFamilyBehavior = _data["concernedAboutFamilyBehavior"] !== undefined ? _data["concernedAboutFamilyBehavior"] : <any>null;
            this.avoidGoingHome = _data["avoidGoingHome"] !== undefined ? _data["avoidGoingHome"] : <any>null;
            this.distressingRecollections = _data["distressingRecollections"] !== undefined ? _data["distressingRecollections"] : <any>null;
            this.disturbingDreams = _data["disturbingDreams"] !== undefined ? _data["disturbingDreams"] : <any>null;
            this.difficultyWithDecisions = _data["difficultyWithDecisions"] !== undefined ? _data["difficultyWithDecisions"] : <any>null;
            this.difficultySleeping = _data["difficultySleeping"] !== undefined ? _data["difficultySleeping"] : <any>null;
            this.lossOfInterest = _data["lossOfInterest"] !== undefined ? _data["lossOfInterest"] : <any>null;
            this.moodChanges = _data["moodChanges"] !== undefined ? _data["moodChanges"] : <any>null;
            this.alcoholOrAddictiveSubstances = _data["alcoholOrAddictiveSubstances"] !== undefined ? _data["alcoholOrAddictiveSubstances"] : <any>null;
            this.feelsLikeBurden = _data["feelsLikeBurden"] !== undefined ? _data["feelsLikeBurden"] : <any>null;
            this.unnecessaryRisks = _data["unnecessaryRisks"] !== undefined ? _data["unnecessaryRisks"] : <any>null;
            this.suicidalThoughts = _data["suicidalThoughts"] !== undefined ? _data["suicidalThoughts"] : <any>null;
            this.suicideAttempt = _data["suicideAttempt"] !== undefined ? _data["suicideAttempt"] : <any>null;
        }
    }

    static fromJS(data: any): FRHCWSelfScreeningViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FRHCWSelfScreeningViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ableToPayBills"] = this.ableToPayBills !== undefined ? this.ableToPayBills : <any>null;
        data["riskOfLosingResidence"] = this.riskOfLosingResidence !== undefined ? this.riskOfLosingResidence : <any>null;
        data["ableToBuyFood"] = this.ableToBuyFood !== undefined ? this.ableToBuyFood : <any>null;
        data["hasEnoughGas"] = this.hasEnoughGas !== undefined ? this.hasEnoughGas : <any>null;
        data["inNeedOfMedical"] = this.inNeedOfMedical !== undefined ? this.inNeedOfMedical : <any>null;
        data["needChildcare"] = this.needChildcare !== undefined ? this.needChildcare : <any>null;
        data["concernedAboutFamilyBehavior"] = this.concernedAboutFamilyBehavior !== undefined ? this.concernedAboutFamilyBehavior : <any>null;
        data["avoidGoingHome"] = this.avoidGoingHome !== undefined ? this.avoidGoingHome : <any>null;
        data["distressingRecollections"] = this.distressingRecollections !== undefined ? this.distressingRecollections : <any>null;
        data["disturbingDreams"] = this.disturbingDreams !== undefined ? this.disturbingDreams : <any>null;
        data["difficultyWithDecisions"] = this.difficultyWithDecisions !== undefined ? this.difficultyWithDecisions : <any>null;
        data["difficultySleeping"] = this.difficultySleeping !== undefined ? this.difficultySleeping : <any>null;
        data["lossOfInterest"] = this.lossOfInterest !== undefined ? this.lossOfInterest : <any>null;
        data["moodChanges"] = this.moodChanges !== undefined ? this.moodChanges : <any>null;
        data["alcoholOrAddictiveSubstances"] = this.alcoholOrAddictiveSubstances !== undefined ? this.alcoholOrAddictiveSubstances : <any>null;
        data["feelsLikeBurden"] = this.feelsLikeBurden !== undefined ? this.feelsLikeBurden : <any>null;
        data["unnecessaryRisks"] = this.unnecessaryRisks !== undefined ? this.unnecessaryRisks : <any>null;
        data["suicidalThoughts"] = this.suicidalThoughts !== undefined ? this.suicidalThoughts : <any>null;
        data["suicideAttempt"] = this.suicideAttempt !== undefined ? this.suicideAttempt : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): FRHCWSelfScreeningViewModel {
        const json = this.toJSON();
        let result = new FRHCWSelfScreeningViewModel();
        result.init(json);
        return result;
    }
}

export interface IFRHCWSelfScreeningViewModel extends IBaseAssessmentViewModel {
    ableToPayBills?: boolean;
    riskOfLosingResidence?: boolean;
    ableToBuyFood?: boolean;
    hasEnoughGas?: boolean;
    inNeedOfMedical?: boolean;
    needChildcare?: boolean;
    concernedAboutFamilyBehavior?: boolean;
    avoidGoingHome?: boolean;
    distressingRecollections?: boolean;
    disturbingDreams?: boolean;
    difficultyWithDecisions?: boolean;
    difficultySleeping?: boolean;
    lossOfInterest?: boolean;
    moodChanges?: boolean;
    alcoholOrAddictiveSubstances?: boolean;
    feelsLikeBurden?: boolean;
    unnecessaryRisks?: boolean;
    suicidalThoughts?: boolean;
    suicideAttempt?: boolean;
}

export class GeneralLevel2AssessmentViewModel extends BaseAssessmentViewModel implements IGeneralLevel2AssessmentViewModel {
    assessmentReason?: string | null;
    emotionalState?: EmotionalState | null;
    cognitiveState?: CognitiveState | null;
    behavioralState?: BehavioralState | null;
    stressors?: Stressors | null;
    suicidalIntent?: SuicidalIntent | null;
    riskFactors?: RiskFactors | null;
    recentChanges?: RecentChanges | null;
    treatmentReceived?: TreatmentReceived | null;
    support?: Support | null;
    studentSkills?: string | null;
    studentFuturePlans?: string | null;
    helpfulLifeChanges?: string | null;
    violenceIdeationHarmfulThoughts?: boolean | null;
    violenceIdeationHarmfulThoughtsTarget?: string | null;
    violenceIdeationPlanToAct?: boolean | null;
    violenceIdeationMeansToAct?: boolean | null;
    violenceIdeationHow?: string | null;
    violenceIdeationTimeFrame?: string | null;
    violenceIdeationLocation?: string | null;

    constructor(data?: IGeneralLevel2AssessmentViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assessmentReason = _data["assessmentReason"] !== undefined ? _data["assessmentReason"] : <any>null;
            this.emotionalState = _data["emotionalState"] ? EmotionalState.fromJS(_data["emotionalState"]) : <any>null;
            this.cognitiveState = _data["cognitiveState"] ? CognitiveState.fromJS(_data["cognitiveState"]) : <any>null;
            this.behavioralState = _data["behavioralState"] ? BehavioralState.fromJS(_data["behavioralState"]) : <any>null;
            this.stressors = _data["stressors"] ? Stressors.fromJS(_data["stressors"]) : <any>null;
            this.suicidalIntent = _data["suicidalIntent"] ? SuicidalIntent.fromJS(_data["suicidalIntent"]) : <any>null;
            this.riskFactors = _data["riskFactors"] ? RiskFactors.fromJS(_data["riskFactors"]) : <any>null;
            this.recentChanges = _data["recentChanges"] ? RecentChanges.fromJS(_data["recentChanges"]) : <any>null;
            this.treatmentReceived = _data["treatmentReceived"] ? TreatmentReceived.fromJS(_data["treatmentReceived"]) : <any>null;
            this.support = _data["support"] ? Support.fromJS(_data["support"]) : <any>null;
            this.studentSkills = _data["studentSkills"] !== undefined ? _data["studentSkills"] : <any>null;
            this.studentFuturePlans = _data["studentFuturePlans"] !== undefined ? _data["studentFuturePlans"] : <any>null;
            this.helpfulLifeChanges = _data["helpfulLifeChanges"] !== undefined ? _data["helpfulLifeChanges"] : <any>null;
            this.violenceIdeationHarmfulThoughts = _data["violenceIdeationHarmfulThoughts"] !== undefined ? _data["violenceIdeationHarmfulThoughts"] : <any>null;
            this.violenceIdeationHarmfulThoughtsTarget = _data["violenceIdeationHarmfulThoughtsTarget"] !== undefined ? _data["violenceIdeationHarmfulThoughtsTarget"] : <any>null;
            this.violenceIdeationPlanToAct = _data["violenceIdeationPlanToAct"] !== undefined ? _data["violenceIdeationPlanToAct"] : <any>null;
            this.violenceIdeationMeansToAct = _data["violenceIdeationMeansToAct"] !== undefined ? _data["violenceIdeationMeansToAct"] : <any>null;
            this.violenceIdeationHow = _data["violenceIdeationHow"] !== undefined ? _data["violenceIdeationHow"] : <any>null;
            this.violenceIdeationTimeFrame = _data["violenceIdeationTimeFrame"] !== undefined ? _data["violenceIdeationTimeFrame"] : <any>null;
            this.violenceIdeationLocation = _data["violenceIdeationLocation"] !== undefined ? _data["violenceIdeationLocation"] : <any>null;
        }
    }

    static fromJS(data: any): GeneralLevel2AssessmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralLevel2AssessmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentReason"] = this.assessmentReason !== undefined ? this.assessmentReason : <any>null;
        data["emotionalState"] = this.emotionalState ? this.emotionalState.toJSON() : <any>null;
        data["cognitiveState"] = this.cognitiveState ? this.cognitiveState.toJSON() : <any>null;
        data["behavioralState"] = this.behavioralState ? this.behavioralState.toJSON() : <any>null;
        data["stressors"] = this.stressors ? this.stressors.toJSON() : <any>null;
        data["suicidalIntent"] = this.suicidalIntent ? this.suicidalIntent.toJSON() : <any>null;
        data["riskFactors"] = this.riskFactors ? this.riskFactors.toJSON() : <any>null;
        data["recentChanges"] = this.recentChanges ? this.recentChanges.toJSON() : <any>null;
        data["treatmentReceived"] = this.treatmentReceived ? this.treatmentReceived.toJSON() : <any>null;
        data["support"] = this.support ? this.support.toJSON() : <any>null;
        data["studentSkills"] = this.studentSkills !== undefined ? this.studentSkills : <any>null;
        data["studentFuturePlans"] = this.studentFuturePlans !== undefined ? this.studentFuturePlans : <any>null;
        data["helpfulLifeChanges"] = this.helpfulLifeChanges !== undefined ? this.helpfulLifeChanges : <any>null;
        data["violenceIdeationHarmfulThoughts"] = this.violenceIdeationHarmfulThoughts !== undefined ? this.violenceIdeationHarmfulThoughts : <any>null;
        data["violenceIdeationHarmfulThoughtsTarget"] = this.violenceIdeationHarmfulThoughtsTarget !== undefined ? this.violenceIdeationHarmfulThoughtsTarget : <any>null;
        data["violenceIdeationPlanToAct"] = this.violenceIdeationPlanToAct !== undefined ? this.violenceIdeationPlanToAct : <any>null;
        data["violenceIdeationMeansToAct"] = this.violenceIdeationMeansToAct !== undefined ? this.violenceIdeationMeansToAct : <any>null;
        data["violenceIdeationHow"] = this.violenceIdeationHow !== undefined ? this.violenceIdeationHow : <any>null;
        data["violenceIdeationTimeFrame"] = this.violenceIdeationTimeFrame !== undefined ? this.violenceIdeationTimeFrame : <any>null;
        data["violenceIdeationLocation"] = this.violenceIdeationLocation !== undefined ? this.violenceIdeationLocation : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): GeneralLevel2AssessmentViewModel {
        const json = this.toJSON();
        let result = new GeneralLevel2AssessmentViewModel();
        result.init(json);
        return result;
    }
}

export interface IGeneralLevel2AssessmentViewModel extends IBaseAssessmentViewModel {
    assessmentReason?: string | null;
    emotionalState?: EmotionalState | null;
    cognitiveState?: CognitiveState | null;
    behavioralState?: BehavioralState | null;
    stressors?: Stressors | null;
    suicidalIntent?: SuicidalIntent | null;
    riskFactors?: RiskFactors | null;
    recentChanges?: RecentChanges | null;
    treatmentReceived?: TreatmentReceived | null;
    support?: Support | null;
    studentSkills?: string | null;
    studentFuturePlans?: string | null;
    helpfulLifeChanges?: string | null;
    violenceIdeationHarmfulThoughts?: boolean | null;
    violenceIdeationHarmfulThoughtsTarget?: string | null;
    violenceIdeationPlanToAct?: boolean | null;
    violenceIdeationMeansToAct?: boolean | null;
    violenceIdeationHow?: string | null;
    violenceIdeationTimeFrame?: string | null;
    violenceIdeationLocation?: string | null;
}

export class EmotionalState implements IEmotionalState {
    numb?: boolean;
    depressed?: boolean;
    other?: string | null;
    scared?: boolean;
    none?: boolean;
    anxious?: boolean;
    irritable?: boolean;
    angry?: boolean;

    constructor(data?: IEmotionalState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numb = _data["numb"] !== undefined ? _data["numb"] : <any>null;
            this.depressed = _data["depressed"] !== undefined ? _data["depressed"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.scared = _data["scared"] !== undefined ? _data["scared"] : <any>null;
            this.none = _data["none"] !== undefined ? _data["none"] : <any>null;
            this.anxious = _data["anxious"] !== undefined ? _data["anxious"] : <any>null;
            this.irritable = _data["irritable"] !== undefined ? _data["irritable"] : <any>null;
            this.angry = _data["angry"] !== undefined ? _data["angry"] : <any>null;
        }
    }

    static fromJS(data: any): EmotionalState {
        data = typeof data === 'object' ? data : {};
        let result = new EmotionalState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numb"] = this.numb !== undefined ? this.numb : <any>null;
        data["depressed"] = this.depressed !== undefined ? this.depressed : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["scared"] = this.scared !== undefined ? this.scared : <any>null;
        data["none"] = this.none !== undefined ? this.none : <any>null;
        data["anxious"] = this.anxious !== undefined ? this.anxious : <any>null;
        data["irritable"] = this.irritable !== undefined ? this.irritable : <any>null;
        data["angry"] = this.angry !== undefined ? this.angry : <any>null;
        return data;
    }

    clone(): EmotionalState {
        const json = this.toJSON();
        let result = new EmotionalState();
        result.init(json);
        return result;
    }
}

export interface IEmotionalState {
    numb?: boolean;
    depressed?: boolean;
    other?: string | null;
    scared?: boolean;
    none?: boolean;
    anxious?: boolean;
    irritable?: boolean;
    angry?: boolean;
}

export class CognitiveState implements ICognitiveState {
    hopeless?: boolean;
    confused?: boolean;
    blamingOthers?: boolean;
    hallucinating?: boolean;
    poorJudgement?: boolean;
    other?: string | null;
    none?: boolean;
    poorInsight?: boolean;
    unableToSpeak?: boolean;
    unrealistic?: boolean;
    rigidThinking?: boolean;
    selfBlame?: boolean;

    constructor(data?: ICognitiveState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hopeless = _data["hopeless"] !== undefined ? _data["hopeless"] : <any>null;
            this.confused = _data["confused"] !== undefined ? _data["confused"] : <any>null;
            this.blamingOthers = _data["blamingOthers"] !== undefined ? _data["blamingOthers"] : <any>null;
            this.hallucinating = _data["hallucinating"] !== undefined ? _data["hallucinating"] : <any>null;
            this.poorJudgement = _data["poorJudgement"] !== undefined ? _data["poorJudgement"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.none = _data["none"] !== undefined ? _data["none"] : <any>null;
            this.poorInsight = _data["poorInsight"] !== undefined ? _data["poorInsight"] : <any>null;
            this.unableToSpeak = _data["unableToSpeak"] !== undefined ? _data["unableToSpeak"] : <any>null;
            this.unrealistic = _data["unrealistic"] !== undefined ? _data["unrealistic"] : <any>null;
            this.rigidThinking = _data["rigidThinking"] !== undefined ? _data["rigidThinking"] : <any>null;
            this.selfBlame = _data["selfBlame"] !== undefined ? _data["selfBlame"] : <any>null;
        }
    }

    static fromJS(data: any): CognitiveState {
        data = typeof data === 'object' ? data : {};
        let result = new CognitiveState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hopeless"] = this.hopeless !== undefined ? this.hopeless : <any>null;
        data["confused"] = this.confused !== undefined ? this.confused : <any>null;
        data["blamingOthers"] = this.blamingOthers !== undefined ? this.blamingOthers : <any>null;
        data["hallucinating"] = this.hallucinating !== undefined ? this.hallucinating : <any>null;
        data["poorJudgement"] = this.poorJudgement !== undefined ? this.poorJudgement : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["none"] = this.none !== undefined ? this.none : <any>null;
        data["poorInsight"] = this.poorInsight !== undefined ? this.poorInsight : <any>null;
        data["unableToSpeak"] = this.unableToSpeak !== undefined ? this.unableToSpeak : <any>null;
        data["unrealistic"] = this.unrealistic !== undefined ? this.unrealistic : <any>null;
        data["rigidThinking"] = this.rigidThinking !== undefined ? this.rigidThinking : <any>null;
        data["selfBlame"] = this.selfBlame !== undefined ? this.selfBlame : <any>null;
        return data;
    }

    clone(): CognitiveState {
        const json = this.toJSON();
        let result = new CognitiveState();
        result.init(json);
        return result;
    }
}

export interface ICognitiveState {
    hopeless?: boolean;
    confused?: boolean;
    blamingOthers?: boolean;
    hallucinating?: boolean;
    poorJudgement?: boolean;
    other?: string | null;
    none?: boolean;
    poorInsight?: boolean;
    unableToSpeak?: boolean;
    unrealistic?: boolean;
    rigidThinking?: boolean;
    selfBlame?: boolean;
}

export class BehavioralState implements IBehavioralState {
    lethargic?: boolean;
    other?: string | null;
    impulsive?: boolean;
    threatening?: boolean;
    none?: boolean;
    riskTaking?: boolean;
    abnormalMovements?: boolean;
    agitated?: boolean;

    constructor(data?: IBehavioralState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lethargic = _data["lethargic"] !== undefined ? _data["lethargic"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.impulsive = _data["impulsive"] !== undefined ? _data["impulsive"] : <any>null;
            this.threatening = _data["threatening"] !== undefined ? _data["threatening"] : <any>null;
            this.none = _data["none"] !== undefined ? _data["none"] : <any>null;
            this.riskTaking = _data["riskTaking"] !== undefined ? _data["riskTaking"] : <any>null;
            this.abnormalMovements = _data["abnormalMovements"] !== undefined ? _data["abnormalMovements"] : <any>null;
            this.agitated = _data["agitated"] !== undefined ? _data["agitated"] : <any>null;
        }
    }

    static fromJS(data: any): BehavioralState {
        data = typeof data === 'object' ? data : {};
        let result = new BehavioralState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lethargic"] = this.lethargic !== undefined ? this.lethargic : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["impulsive"] = this.impulsive !== undefined ? this.impulsive : <any>null;
        data["threatening"] = this.threatening !== undefined ? this.threatening : <any>null;
        data["none"] = this.none !== undefined ? this.none : <any>null;
        data["riskTaking"] = this.riskTaking !== undefined ? this.riskTaking : <any>null;
        data["abnormalMovements"] = this.abnormalMovements !== undefined ? this.abnormalMovements : <any>null;
        data["agitated"] = this.agitated !== undefined ? this.agitated : <any>null;
        return data;
    }

    clone(): BehavioralState {
        const json = this.toJSON();
        let result = new BehavioralState();
        result.init(json);
        return result;
    }
}

export interface IBehavioralState {
    lethargic?: boolean;
    other?: string | null;
    impulsive?: boolean;
    threatening?: boolean;
    none?: boolean;
    riskTaking?: boolean;
    abnormalMovements?: boolean;
    agitated?: boolean;
}

export class Stressors implements IStressors {
    fallingGrades?: boolean;
    legalInvolvement?: boolean;
    friendFamilyLoss?: boolean;
    embarrassment?: boolean;
    friendFamilySuicide?: boolean;
    other?: string | null;
    bullying?: boolean;
    familyIssues?: boolean;
    none?: boolean;
    peerRelationships?: boolean;
    familySuicideHistory?: boolean;
    breakup?: boolean;
    abuseVictim?: boolean;
    suspension?: boolean;
    sleepProblems?: boolean;
    isolation?: boolean;

    constructor(data?: IStressors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fallingGrades = _data["fallingGrades"] !== undefined ? _data["fallingGrades"] : <any>null;
            this.legalInvolvement = _data["legalInvolvement"] !== undefined ? _data["legalInvolvement"] : <any>null;
            this.friendFamilyLoss = _data["friendFamilyLoss"] !== undefined ? _data["friendFamilyLoss"] : <any>null;
            this.embarrassment = _data["embarrassment"] !== undefined ? _data["embarrassment"] : <any>null;
            this.friendFamilySuicide = _data["friendFamilySuicide"] !== undefined ? _data["friendFamilySuicide"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.bullying = _data["bullying"] !== undefined ? _data["bullying"] : <any>null;
            this.familyIssues = _data["familyIssues"] !== undefined ? _data["familyIssues"] : <any>null;
            this.none = _data["none"] !== undefined ? _data["none"] : <any>null;
            this.peerRelationships = _data["peerRelationships"] !== undefined ? _data["peerRelationships"] : <any>null;
            this.familySuicideHistory = _data["familySuicideHistory"] !== undefined ? _data["familySuicideHistory"] : <any>null;
            this.breakup = _data["breakup"] !== undefined ? _data["breakup"] : <any>null;
            this.abuseVictim = _data["abuseVictim"] !== undefined ? _data["abuseVictim"] : <any>null;
            this.suspension = _data["suspension"] !== undefined ? _data["suspension"] : <any>null;
            this.sleepProblems = _data["sleepProblems"] !== undefined ? _data["sleepProblems"] : <any>null;
            this.isolation = _data["isolation"] !== undefined ? _data["isolation"] : <any>null;
        }
    }

    static fromJS(data: any): Stressors {
        data = typeof data === 'object' ? data : {};
        let result = new Stressors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fallingGrades"] = this.fallingGrades !== undefined ? this.fallingGrades : <any>null;
        data["legalInvolvement"] = this.legalInvolvement !== undefined ? this.legalInvolvement : <any>null;
        data["friendFamilyLoss"] = this.friendFamilyLoss !== undefined ? this.friendFamilyLoss : <any>null;
        data["embarrassment"] = this.embarrassment !== undefined ? this.embarrassment : <any>null;
        data["friendFamilySuicide"] = this.friendFamilySuicide !== undefined ? this.friendFamilySuicide : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["bullying"] = this.bullying !== undefined ? this.bullying : <any>null;
        data["familyIssues"] = this.familyIssues !== undefined ? this.familyIssues : <any>null;
        data["none"] = this.none !== undefined ? this.none : <any>null;
        data["peerRelationships"] = this.peerRelationships !== undefined ? this.peerRelationships : <any>null;
        data["familySuicideHistory"] = this.familySuicideHistory !== undefined ? this.familySuicideHistory : <any>null;
        data["breakup"] = this.breakup !== undefined ? this.breakup : <any>null;
        data["abuseVictim"] = this.abuseVictim !== undefined ? this.abuseVictim : <any>null;
        data["suspension"] = this.suspension !== undefined ? this.suspension : <any>null;
        data["sleepProblems"] = this.sleepProblems !== undefined ? this.sleepProblems : <any>null;
        data["isolation"] = this.isolation !== undefined ? this.isolation : <any>null;
        return data;
    }

    clone(): Stressors {
        const json = this.toJSON();
        let result = new Stressors();
        result.init(json);
        return result;
    }
}

export interface IStressors {
    fallingGrades?: boolean;
    legalInvolvement?: boolean;
    friendFamilyLoss?: boolean;
    embarrassment?: boolean;
    friendFamilySuicide?: boolean;
    other?: string | null;
    bullying?: boolean;
    familyIssues?: boolean;
    none?: boolean;
    peerRelationships?: boolean;
    familySuicideHistory?: boolean;
    breakup?: boolean;
    abuseVictim?: boolean;
    suspension?: boolean;
    sleepProblems?: boolean;
    isolation?: boolean;
}

export class SuicidalIntent implements ISuicidalIntent {
    depression?: boolean;
    betterOffGone?: boolean;

    constructor(data?: ISuicidalIntent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depression = _data["depression"] !== undefined ? _data["depression"] : <any>null;
            this.betterOffGone = _data["betterOffGone"] !== undefined ? _data["betterOffGone"] : <any>null;
        }
    }

    static fromJS(data: any): SuicidalIntent {
        data = typeof data === 'object' ? data : {};
        let result = new SuicidalIntent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depression"] = this.depression !== undefined ? this.depression : <any>null;
        data["betterOffGone"] = this.betterOffGone !== undefined ? this.betterOffGone : <any>null;
        return data;
    }

    clone(): SuicidalIntent {
        const json = this.toJSON();
        let result = new SuicidalIntent();
        result.init(json);
        return result;
    }
}

export interface ISuicidalIntent {
    depression?: boolean;
    betterOffGone?: boolean;
}

export class RiskFactors implements IRiskFactors {
    smokingVapingTobaccoUsage?: SmokingVapingTobaccoUsage | null;
    substanceAbuseSubstance?: SubstanceAbuseSubstance | null;
    alcoholUsage?: AlcoholUsage | null;
    selfInjuryHarmTimeframe?: SelfInjuryHarmTimeframe | null;

    constructor(data?: IRiskFactors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smokingVapingTobaccoUsage = _data["smokingVapingTobaccoUsage"] ? SmokingVapingTobaccoUsage.fromJS(_data["smokingVapingTobaccoUsage"]) : <any>null;
            this.substanceAbuseSubstance = _data["substanceAbuseSubstance"] ? SubstanceAbuseSubstance.fromJS(_data["substanceAbuseSubstance"]) : <any>null;
            this.alcoholUsage = _data["alcoholUsage"] ? AlcoholUsage.fromJS(_data["alcoholUsage"]) : <any>null;
            this.selfInjuryHarmTimeframe = _data["selfInjuryHarmTimeframe"] ? SelfInjuryHarmTimeframe.fromJS(_data["selfInjuryHarmTimeframe"]) : <any>null;
        }
    }

    static fromJS(data: any): RiskFactors {
        data = typeof data === 'object' ? data : {};
        let result = new RiskFactors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smokingVapingTobaccoUsage"] = this.smokingVapingTobaccoUsage ? this.smokingVapingTobaccoUsage.toJSON() : <any>null;
        data["substanceAbuseSubstance"] = this.substanceAbuseSubstance ? this.substanceAbuseSubstance.toJSON() : <any>null;
        data["alcoholUsage"] = this.alcoholUsage ? this.alcoholUsage.toJSON() : <any>null;
        data["selfInjuryHarmTimeframe"] = this.selfInjuryHarmTimeframe ? this.selfInjuryHarmTimeframe.toJSON() : <any>null;
        return data;
    }

    clone(): RiskFactors {
        const json = this.toJSON();
        let result = new RiskFactors();
        result.init(json);
        return result;
    }
}

export interface IRiskFactors {
    smokingVapingTobaccoUsage?: SmokingVapingTobaccoUsage | null;
    substanceAbuseSubstance?: SubstanceAbuseSubstance | null;
    alcoholUsage?: AlcoholUsage | null;
    selfInjuryHarmTimeframe?: SelfInjuryHarmTimeframe | null;
}

export class SmokingVapingTobaccoUsage implements ISmokingVapingTobaccoUsage {
    daily?: boolean;
    monthlyOrLess?: boolean;
    weekly?: boolean;

    constructor(data?: ISmokingVapingTobaccoUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daily = _data["daily"] !== undefined ? _data["daily"] : <any>null;
            this.monthlyOrLess = _data["monthlyOrLess"] !== undefined ? _data["monthlyOrLess"] : <any>null;
            this.weekly = _data["weekly"] !== undefined ? _data["weekly"] : <any>null;
        }
    }

    static fromJS(data: any): SmokingVapingTobaccoUsage {
        data = typeof data === 'object' ? data : {};
        let result = new SmokingVapingTobaccoUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daily"] = this.daily !== undefined ? this.daily : <any>null;
        data["monthlyOrLess"] = this.monthlyOrLess !== undefined ? this.monthlyOrLess : <any>null;
        data["weekly"] = this.weekly !== undefined ? this.weekly : <any>null;
        return data;
    }

    clone(): SmokingVapingTobaccoUsage {
        const json = this.toJSON();
        let result = new SmokingVapingTobaccoUsage();
        result.init(json);
        return result;
    }
}

export interface ISmokingVapingTobaccoUsage {
    daily?: boolean;
    monthlyOrLess?: boolean;
    weekly?: boolean;
}

export class SubstanceAbuseSubstance implements ISubstanceAbuseSubstance {
    cocaine?: boolean;
    pills?: boolean;
    marijuana?: boolean;
    meth?: boolean;

    constructor(data?: ISubstanceAbuseSubstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cocaine = _data["cocaine"] !== undefined ? _data["cocaine"] : <any>null;
            this.pills = _data["pills"] !== undefined ? _data["pills"] : <any>null;
            this.marijuana = _data["marijuana"] !== undefined ? _data["marijuana"] : <any>null;
            this.meth = _data["meth"] !== undefined ? _data["meth"] : <any>null;
        }
    }

    static fromJS(data: any): SubstanceAbuseSubstance {
        data = typeof data === 'object' ? data : {};
        let result = new SubstanceAbuseSubstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cocaine"] = this.cocaine !== undefined ? this.cocaine : <any>null;
        data["pills"] = this.pills !== undefined ? this.pills : <any>null;
        data["marijuana"] = this.marijuana !== undefined ? this.marijuana : <any>null;
        data["meth"] = this.meth !== undefined ? this.meth : <any>null;
        return data;
    }

    clone(): SubstanceAbuseSubstance {
        const json = this.toJSON();
        let result = new SubstanceAbuseSubstance();
        result.init(json);
        return result;
    }
}

export interface ISubstanceAbuseSubstance {
    cocaine?: boolean;
    pills?: boolean;
    marijuana?: boolean;
    meth?: boolean;
}

export class AlcoholUsage implements IAlcoholUsage {
    daily?: boolean;
    monthlyOrLess?: boolean;
    weekly?: boolean;

    constructor(data?: IAlcoholUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daily = _data["daily"] !== undefined ? _data["daily"] : <any>null;
            this.monthlyOrLess = _data["monthlyOrLess"] !== undefined ? _data["monthlyOrLess"] : <any>null;
            this.weekly = _data["weekly"] !== undefined ? _data["weekly"] : <any>null;
        }
    }

    static fromJS(data: any): AlcoholUsage {
        data = typeof data === 'object' ? data : {};
        let result = new AlcoholUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daily"] = this.daily !== undefined ? this.daily : <any>null;
        data["monthlyOrLess"] = this.monthlyOrLess !== undefined ? this.monthlyOrLess : <any>null;
        data["weekly"] = this.weekly !== undefined ? this.weekly : <any>null;
        return data;
    }

    clone(): AlcoholUsage {
        const json = this.toJSON();
        let result = new AlcoholUsage();
        result.init(json);
        return result;
    }
}

export interface IAlcoholUsage {
    daily?: boolean;
    monthlyOrLess?: boolean;
    weekly?: boolean;
}

export class SelfInjuryHarmTimeframe implements ISelfInjuryHarmTimeframe {
    pastWeek?: boolean;
    pastYearLifetime?: boolean;
    pastDate?: boolean;
    pastMonth?: boolean;

    constructor(data?: ISelfInjuryHarmTimeframe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pastWeek = _data["pastWeek"] !== undefined ? _data["pastWeek"] : <any>null;
            this.pastYearLifetime = _data["pastYearLifetime"] !== undefined ? _data["pastYearLifetime"] : <any>null;
            this.pastDate = _data["pastDate"] !== undefined ? _data["pastDate"] : <any>null;
            this.pastMonth = _data["pastMonth"] !== undefined ? _data["pastMonth"] : <any>null;
        }
    }

    static fromJS(data: any): SelfInjuryHarmTimeframe {
        data = typeof data === 'object' ? data : {};
        let result = new SelfInjuryHarmTimeframe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pastWeek"] = this.pastWeek !== undefined ? this.pastWeek : <any>null;
        data["pastYearLifetime"] = this.pastYearLifetime !== undefined ? this.pastYearLifetime : <any>null;
        data["pastDate"] = this.pastDate !== undefined ? this.pastDate : <any>null;
        data["pastMonth"] = this.pastMonth !== undefined ? this.pastMonth : <any>null;
        return data;
    }

    clone(): SelfInjuryHarmTimeframe {
        const json = this.toJSON();
        let result = new SelfInjuryHarmTimeframe();
        result.init(json);
        return result;
    }
}

export interface ISelfInjuryHarmTimeframe {
    pastWeek?: boolean;
    pastYearLifetime?: boolean;
    pastDate?: boolean;
    pastMonth?: boolean;
}

export class RecentChanges implements IRecentChanges {
    schoolwork?: boolean;
    attendance?: boolean;
    emotionsMood?: boolean;
    thoughtsCognitions?: boolean;
    behaviors?: boolean;
    appearance?: boolean;
    peerInteraction?: boolean;
    other?: string | null;

    constructor(data?: IRecentChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolwork = _data["schoolwork"] !== undefined ? _data["schoolwork"] : <any>null;
            this.attendance = _data["attendance"] !== undefined ? _data["attendance"] : <any>null;
            this.emotionsMood = _data["emotionsMood"] !== undefined ? _data["emotionsMood"] : <any>null;
            this.thoughtsCognitions = _data["thoughtsCognitions"] !== undefined ? _data["thoughtsCognitions"] : <any>null;
            this.behaviors = _data["behaviors"] !== undefined ? _data["behaviors"] : <any>null;
            this.appearance = _data["appearance"] !== undefined ? _data["appearance"] : <any>null;
            this.peerInteraction = _data["peerInteraction"] !== undefined ? _data["peerInteraction"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
        }
    }

    static fromJS(data: any): RecentChanges {
        data = typeof data === 'object' ? data : {};
        let result = new RecentChanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolwork"] = this.schoolwork !== undefined ? this.schoolwork : <any>null;
        data["attendance"] = this.attendance !== undefined ? this.attendance : <any>null;
        data["emotionsMood"] = this.emotionsMood !== undefined ? this.emotionsMood : <any>null;
        data["thoughtsCognitions"] = this.thoughtsCognitions !== undefined ? this.thoughtsCognitions : <any>null;
        data["behaviors"] = this.behaviors !== undefined ? this.behaviors : <any>null;
        data["appearance"] = this.appearance !== undefined ? this.appearance : <any>null;
        data["peerInteraction"] = this.peerInteraction !== undefined ? this.peerInteraction : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        return data;
    }

    clone(): RecentChanges {
        const json = this.toJSON();
        let result = new RecentChanges();
        result.init(json);
        return result;
    }
}

export interface IRecentChanges {
    schoolwork?: boolean;
    attendance?: boolean;
    emotionsMood?: boolean;
    thoughtsCognitions?: boolean;
    behaviors?: boolean;
    appearance?: boolean;
    peerInteraction?: boolean;
    other?: string | null;
}

export class TreatmentReceived implements ITreatmentReceived {
    anxiety?: boolean;
    bipolar?: boolean;
    counselingTherapy?: boolean;
    depression?: boolean;
    eatingDisorder?: boolean;
    hospitalization?: boolean;
    medications?: boolean;
    ptsd?: boolean;
    psychiatristPsychologist?: boolean;
    selfInjury?: boolean;
    substanceAbuse?: boolean;
    other?: string | null;

    constructor(data?: ITreatmentReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anxiety = _data["anxiety"] !== undefined ? _data["anxiety"] : <any>null;
            this.bipolar = _data["bipolar"] !== undefined ? _data["bipolar"] : <any>null;
            this.counselingTherapy = _data["counselingTherapy"] !== undefined ? _data["counselingTherapy"] : <any>null;
            this.depression = _data["depression"] !== undefined ? _data["depression"] : <any>null;
            this.eatingDisorder = _data["eatingDisorder"] !== undefined ? _data["eatingDisorder"] : <any>null;
            this.hospitalization = _data["hospitalization"] !== undefined ? _data["hospitalization"] : <any>null;
            this.medications = _data["medications"] !== undefined ? _data["medications"] : <any>null;
            this.ptsd = _data["ptsd"] !== undefined ? _data["ptsd"] : <any>null;
            this.psychiatristPsychologist = _data["psychiatristPsychologist"] !== undefined ? _data["psychiatristPsychologist"] : <any>null;
            this.selfInjury = _data["selfInjury"] !== undefined ? _data["selfInjury"] : <any>null;
            this.substanceAbuse = _data["substanceAbuse"] !== undefined ? _data["substanceAbuse"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
        }
    }

    static fromJS(data: any): TreatmentReceived {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anxiety"] = this.anxiety !== undefined ? this.anxiety : <any>null;
        data["bipolar"] = this.bipolar !== undefined ? this.bipolar : <any>null;
        data["counselingTherapy"] = this.counselingTherapy !== undefined ? this.counselingTherapy : <any>null;
        data["depression"] = this.depression !== undefined ? this.depression : <any>null;
        data["eatingDisorder"] = this.eatingDisorder !== undefined ? this.eatingDisorder : <any>null;
        data["hospitalization"] = this.hospitalization !== undefined ? this.hospitalization : <any>null;
        data["medications"] = this.medications !== undefined ? this.medications : <any>null;
        data["ptsd"] = this.ptsd !== undefined ? this.ptsd : <any>null;
        data["psychiatristPsychologist"] = this.psychiatristPsychologist !== undefined ? this.psychiatristPsychologist : <any>null;
        data["selfInjury"] = this.selfInjury !== undefined ? this.selfInjury : <any>null;
        data["substanceAbuse"] = this.substanceAbuse !== undefined ? this.substanceAbuse : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        return data;
    }

    clone(): TreatmentReceived {
        const json = this.toJSON();
        let result = new TreatmentReceived();
        result.init(json);
        return result;
    }
}

export interface ITreatmentReceived {
    anxiety?: boolean;
    bipolar?: boolean;
    counselingTherapy?: boolean;
    depression?: boolean;
    eatingDisorder?: boolean;
    hospitalization?: boolean;
    medications?: boolean;
    ptsd?: boolean;
    psychiatristPsychologist?: boolean;
    selfInjury?: boolean;
    substanceAbuse?: boolean;
    other?: string | null;
}

export class Support implements ISupport {
    supportiveFamily?: boolean;
    socialNetworkAvailable?: boolean;
    futurePlans?: boolean;
    futureHope?: boolean;
    other?: string | null;
    therapyCounseling?: boolean;
    noRiskFactorHistory?: boolean;
    willingToSafetyPlan?: boolean;
    feelsValued?: boolean;
    adultSupervision?: boolean;

    constructor(data?: ISupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportiveFamily = _data["supportiveFamily"] !== undefined ? _data["supportiveFamily"] : <any>null;
            this.socialNetworkAvailable = _data["socialNetworkAvailable"] !== undefined ? _data["socialNetworkAvailable"] : <any>null;
            this.futurePlans = _data["futurePlans"] !== undefined ? _data["futurePlans"] : <any>null;
            this.futureHope = _data["futureHope"] !== undefined ? _data["futureHope"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.therapyCounseling = _data["therapyCounseling"] !== undefined ? _data["therapyCounseling"] : <any>null;
            this.noRiskFactorHistory = _data["noRiskFactorHistory"] !== undefined ? _data["noRiskFactorHistory"] : <any>null;
            this.willingToSafetyPlan = _data["willingToSafetyPlan"] !== undefined ? _data["willingToSafetyPlan"] : <any>null;
            this.feelsValued = _data["feelsValued"] !== undefined ? _data["feelsValued"] : <any>null;
            this.adultSupervision = _data["adultSupervision"] !== undefined ? _data["adultSupervision"] : <any>null;
        }
    }

    static fromJS(data: any): Support {
        data = typeof data === 'object' ? data : {};
        let result = new Support();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportiveFamily"] = this.supportiveFamily !== undefined ? this.supportiveFamily : <any>null;
        data["socialNetworkAvailable"] = this.socialNetworkAvailable !== undefined ? this.socialNetworkAvailable : <any>null;
        data["futurePlans"] = this.futurePlans !== undefined ? this.futurePlans : <any>null;
        data["futureHope"] = this.futureHope !== undefined ? this.futureHope : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["therapyCounseling"] = this.therapyCounseling !== undefined ? this.therapyCounseling : <any>null;
        data["noRiskFactorHistory"] = this.noRiskFactorHistory !== undefined ? this.noRiskFactorHistory : <any>null;
        data["willingToSafetyPlan"] = this.willingToSafetyPlan !== undefined ? this.willingToSafetyPlan : <any>null;
        data["feelsValued"] = this.feelsValued !== undefined ? this.feelsValued : <any>null;
        data["adultSupervision"] = this.adultSupervision !== undefined ? this.adultSupervision : <any>null;
        return data;
    }

    clone(): Support {
        const json = this.toJSON();
        let result = new Support();
        result.init(json);
        return result;
    }
}

export interface ISupport {
    supportiveFamily?: boolean;
    socialNetworkAvailable?: boolean;
    futurePlans?: boolean;
    futureHope?: boolean;
    other?: string | null;
    therapyCounseling?: boolean;
    noRiskFactorHistory?: boolean;
    willingToSafetyPlan?: boolean;
    feelsValued?: boolean;
    adultSupervision?: boolean;
}

export class FirstRespondersColumbiaViewModel extends BaseAssessmentViewModel implements IFirstRespondersColumbiaViewModel {
    selfHarmThoughtsHow?: boolean;
    actingOnUnnecessaryRisks?: boolean;
    hasBegunIsolating?: boolean;
    harmfulThoughtsWithIntent?: boolean;
    intendToAct?: boolean;
    preparedToEndLife?: boolean;

    constructor(data?: IFirstRespondersColumbiaViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selfHarmThoughtsHow = _data["selfHarmThoughtsHow"] !== undefined ? _data["selfHarmThoughtsHow"] : <any>null;
            this.actingOnUnnecessaryRisks = _data["actingOnUnnecessaryRisks"] !== undefined ? _data["actingOnUnnecessaryRisks"] : <any>null;
            this.hasBegunIsolating = _data["hasBegunIsolating"] !== undefined ? _data["hasBegunIsolating"] : <any>null;
            this.harmfulThoughtsWithIntent = _data["harmfulThoughtsWithIntent"] !== undefined ? _data["harmfulThoughtsWithIntent"] : <any>null;
            this.intendToAct = _data["intendToAct"] !== undefined ? _data["intendToAct"] : <any>null;
            this.preparedToEndLife = _data["preparedToEndLife"] !== undefined ? _data["preparedToEndLife"] : <any>null;
        }
    }

    static fromJS(data: any): FirstRespondersColumbiaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FirstRespondersColumbiaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfHarmThoughtsHow"] = this.selfHarmThoughtsHow !== undefined ? this.selfHarmThoughtsHow : <any>null;
        data["actingOnUnnecessaryRisks"] = this.actingOnUnnecessaryRisks !== undefined ? this.actingOnUnnecessaryRisks : <any>null;
        data["hasBegunIsolating"] = this.hasBegunIsolating !== undefined ? this.hasBegunIsolating : <any>null;
        data["harmfulThoughtsWithIntent"] = this.harmfulThoughtsWithIntent !== undefined ? this.harmfulThoughtsWithIntent : <any>null;
        data["intendToAct"] = this.intendToAct !== undefined ? this.intendToAct : <any>null;
        data["preparedToEndLife"] = this.preparedToEndLife !== undefined ? this.preparedToEndLife : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): FirstRespondersColumbiaViewModel {
        const json = this.toJSON();
        let result = new FirstRespondersColumbiaViewModel();
        result.init(json);
        return result;
    }
}

export interface IFirstRespondersColumbiaViewModel extends IBaseAssessmentViewModel {
    selfHarmThoughtsHow?: boolean;
    actingOnUnnecessaryRisks?: boolean;
    hasBegunIsolating?: boolean;
    harmfulThoughtsWithIntent?: boolean;
    intendToAct?: boolean;
    preparedToEndLife?: boolean;
}

export class GetNewAssessmentResultsCountResponse implements IGetNewAssessmentResultsCountResponse {
    count?: number;

    constructor(data?: IGetNewAssessmentResultsCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): GetNewAssessmentResultsCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewAssessmentResultsCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }

    clone(): GetNewAssessmentResultsCountResponse {
        const json = this.toJSON();
        let result = new GetNewAssessmentResultsCountResponse();
        result.init(json);
        return result;
    }
}

export interface IGetNewAssessmentResultsCountResponse {
    count?: number;
}

export class GetSchoolAssessmentResultsDemographicStatsResponse implements IGetSchoolAssessmentResultsDemographicStatsResponse {
    sexDemographicCounts?: DemographicCount[] | null;
    genderDemographicCounts?: DemographicCount[] | null;
    ageDemographicCounts?: DemographicCount[] | null;

    constructor(data?: IGetSchoolAssessmentResultsDemographicStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sexDemographicCounts"])) {
                this.sexDemographicCounts = [] as any;
                for (let item of _data["sexDemographicCounts"])
                    this.sexDemographicCounts!.push(DemographicCount.fromJS(item));
            }
            else {
                this.sexDemographicCounts = <any>null;
            }
            if (Array.isArray(_data["genderDemographicCounts"])) {
                this.genderDemographicCounts = [] as any;
                for (let item of _data["genderDemographicCounts"])
                    this.genderDemographicCounts!.push(DemographicCount.fromJS(item));
            }
            else {
                this.genderDemographicCounts = <any>null;
            }
            if (Array.isArray(_data["ageDemographicCounts"])) {
                this.ageDemographicCounts = [] as any;
                for (let item of _data["ageDemographicCounts"])
                    this.ageDemographicCounts!.push(DemographicCount.fromJS(item));
            }
            else {
                this.ageDemographicCounts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSchoolAssessmentResultsDemographicStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSchoolAssessmentResultsDemographicStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sexDemographicCounts)) {
            data["sexDemographicCounts"] = [];
            for (let item of this.sexDemographicCounts)
                data["sexDemographicCounts"].push(item.toJSON());
        }
        if (Array.isArray(this.genderDemographicCounts)) {
            data["genderDemographicCounts"] = [];
            for (let item of this.genderDemographicCounts)
                data["genderDemographicCounts"].push(item.toJSON());
        }
        if (Array.isArray(this.ageDemographicCounts)) {
            data["ageDemographicCounts"] = [];
            for (let item of this.ageDemographicCounts)
                data["ageDemographicCounts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetSchoolAssessmentResultsDemographicStatsResponse {
        const json = this.toJSON();
        let result = new GetSchoolAssessmentResultsDemographicStatsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSchoolAssessmentResultsDemographicStatsResponse {
    sexDemographicCounts?: DemographicCount[] | null;
    genderDemographicCounts?: DemographicCount[] | null;
    ageDemographicCounts?: DemographicCount[] | null;
}

export class DemographicCount implements IDemographicCount {
    name?: string | null;
    label?: string | null;
    count?: number;
    percentage?: number;

    constructor(data?: IDemographicCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : <any>null;
        }
    }

    static fromJS(data: any): DemographicCount {
        data = typeof data === 'object' ? data : {};
        let result = new DemographicCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["percentage"] = this.percentage !== undefined ? this.percentage : <any>null;
        return data;
    }

    clone(): DemographicCount {
        const json = this.toJSON();
        let result = new DemographicCount();
        result.init(json);
        return result;
    }
}

export interface IDemographicCount {
    name?: string | null;
    label?: string | null;
    count?: number;
    percentage?: number;
}

export class GetAllBranchesResponse implements IGetAllBranchesResponse {
    branches?: BranchViewModel[] | null;

    constructor(data?: IGetAllBranchesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchViewModel.fromJS(item));
            }
            else {
                this.branches = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllBranchesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBranchesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllBranchesResponse {
        const json = this.toJSON();
        let result = new GetAllBranchesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllBranchesResponse {
    branches?: BranchViewModel[] | null;
}

export class BranchViewModel implements IBranchViewModel {
    id?: string | null;
    name?: BranchName;

    constructor(data?: IBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): BranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): BranchViewModel {
        const json = this.toJSON();
        let result = new BranchViewModel();
        result.init(json);
        return result;
    }
}

export interface IBranchViewModel {
    id?: string | null;
    name?: BranchName;
}

export class GetCaseResponse implements IGetCaseResponse {
    case?: FirstResponderCaseDto | null;
    canAccess?: boolean;

    constructor(data?: IGetCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case = _data["case"] ? FirstResponderCaseDto.fromJS(_data["case"]) : <any>null;
            this.canAccess = _data["canAccess"] !== undefined ? _data["canAccess"] : <any>null;
        }
    }

    static fromJS(data: any): GetCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["canAccess"] = this.canAccess !== undefined ? this.canAccess : <any>null;
        return data;
    }

    clone(): GetCaseResponse {
        const json = this.toJSON();
        let result = new GetCaseResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCaseResponse {
    case?: FirstResponderCaseDto | null;
    canAccess?: boolean;
}

export class FirstResponderCaseDto implements IFirstResponderCaseDto {
    caseNumber?: string | null;
    id?: string | null;
    riskLevel?: string | null;
    status?: CaseStatus | null;
    dateSubmitted?: Date | null;
    comments?: string | null;
    participant?: CaseParticipantDto | null;
    chaplainProviderNotes?: ChaplainProviderNoteDto[] | null;
    assessmentResultSummaries?: AssessmentResultSummaryViewModel[] | null;
    fileUploads?: CaseDocument[] | null;

    constructor(data?: IFirstResponderCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.participant = _data["participant"] ? CaseParticipantDto.fromJS(_data["participant"]) : <any>null;
            if (Array.isArray(_data["chaplainProviderNotes"])) {
                this.chaplainProviderNotes = [] as any;
                for (let item of _data["chaplainProviderNotes"])
                    this.chaplainProviderNotes!.push(ChaplainProviderNoteDto.fromJS(item));
            }
            else {
                this.chaplainProviderNotes = <any>null;
            }
            if (Array.isArray(_data["assessmentResultSummaries"])) {
                this.assessmentResultSummaries = [] as any;
                for (let item of _data["assessmentResultSummaries"])
                    this.assessmentResultSummaries!.push(AssessmentResultSummaryViewModel.fromJS(item));
            }
            else {
                this.assessmentResultSummaries = <any>null;
            }
            if (Array.isArray(_data["fileUploads"])) {
                this.fileUploads = [] as any;
                for (let item of _data["fileUploads"])
                    this.fileUploads!.push(CaseDocument.fromJS(item));
            }
            else {
                this.fileUploads = <any>null;
            }
        }
    }

    static fromJS(data: any): FirstResponderCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FirstResponderCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        if (Array.isArray(this.chaplainProviderNotes)) {
            data["chaplainProviderNotes"] = [];
            for (let item of this.chaplainProviderNotes)
                data["chaplainProviderNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentResultSummaries)) {
            data["assessmentResultSummaries"] = [];
            for (let item of this.assessmentResultSummaries)
                data["assessmentResultSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.fileUploads)) {
            data["fileUploads"] = [];
            for (let item of this.fileUploads)
                data["fileUploads"].push(item.toJSON());
        }
        return data;
    }

    clone(): FirstResponderCaseDto {
        const json = this.toJSON();
        let result = new FirstResponderCaseDto();
        result.init(json);
        return result;
    }
}

export interface IFirstResponderCaseDto {
    caseNumber?: string | null;
    id?: string | null;
    riskLevel?: string | null;
    status?: CaseStatus | null;
    dateSubmitted?: Date | null;
    comments?: string | null;
    participant?: CaseParticipantDto | null;
    chaplainProviderNotes?: ChaplainProviderNoteDto[] | null;
    assessmentResultSummaries?: AssessmentResultSummaryViewModel[] | null;
    fileUploads?: CaseDocument[] | null;
}

export enum CaseStatus {
    New = "New",
    NoAnswer = "NoAnswer",
    InProgress = "InProgress",
    Submitted = "Submitted",
    Accepted = "Accepted",
    Closed = "Closed",
}

export class CaseParticipantDto implements ICaseParticipantDto {
    id?: string | null;
    userId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    branchIds?: string[] | null;
    departmentNames?: string[] | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: ICaseParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            else {
                this.branchIds = <any>null;
            }
            if (Array.isArray(_data["departmentNames"])) {
                this.departmentNames = [] as any;
                for (let item of _data["departmentNames"])
                    this.departmentNames!.push(item);
            }
            else {
                this.departmentNames = <any>null;
            }
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
        }
    }

    static fromJS(data: any): CaseParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        if (Array.isArray(this.departmentNames)) {
            data["departmentNames"] = [];
            for (let item of this.departmentNames)
                data["departmentNames"].push(item);
        }
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        return data;
    }

    clone(): CaseParticipantDto {
        const json = this.toJSON();
        let result = new CaseParticipantDto();
        result.init(json);
        return result;
    }
}

export interface ICaseParticipantDto {
    id?: string | null;
    userId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    branchIds?: string[] | null;
    departmentNames?: string[] | null;
    email?: string | null;
    phone?: string | null;
}

export class ChaplainProviderNoteDto implements IChaplainProviderNoteDto {
    userId?: string | null;
    date?: Date | null;
    note?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IChaplainProviderNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): ChaplainProviderNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChaplainProviderNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }

    clone(): ChaplainProviderNoteDto {
        const json = this.toJSON();
        let result = new ChaplainProviderNoteDto();
        result.init(json);
        return result;
    }
}

export interface IChaplainProviderNoteDto {
    userId?: string | null;
    date?: Date | null;
    note?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class AssessmentResultSummaryViewModel implements IAssessmentResultSummaryViewModel {
    id?: string | null;
    risk?: string | null;
    priorityLevel?: string | null;
    name?: string | null;

    constructor(data?: IAssessmentResultSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.risk = _data["risk"] !== undefined ? _data["risk"] : <any>null;
            this.priorityLevel = _data["priorityLevel"] !== undefined ? _data["priorityLevel"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AssessmentResultSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentResultSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["risk"] = this.risk !== undefined ? this.risk : <any>null;
        data["priorityLevel"] = this.priorityLevel !== undefined ? this.priorityLevel : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): AssessmentResultSummaryViewModel {
        const json = this.toJSON();
        let result = new AssessmentResultSummaryViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssessmentResultSummaryViewModel {
    id?: string | null;
    risk?: string | null;
    priorityLevel?: string | null;
    name?: string | null;
}

export class CaseDocument implements ICaseDocument {
    fileType?: string | null;
    fileName?: string | null;
    uploadDate?: Date;
    deletedOn?: Date | null;
    documentLocationType?: DocumentLocationType;
    isValid?: boolean;

    constructor(data?: ICaseDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>null;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>null;
            this.documentLocationType = _data["documentLocationType"] !== undefined ? _data["documentLocationType"] : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
        }
    }

    static fromJS(data: any): CaseDocument {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>null;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>null;
        data["documentLocationType"] = this.documentLocationType !== undefined ? this.documentLocationType : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        return data;
    }

    clone(): CaseDocument {
        const json = this.toJSON();
        let result = new CaseDocument();
        result.init(json);
        return result;
    }
}

export interface ICaseDocument {
    fileType?: string | null;
    fileName?: string | null;
    uploadDate?: Date;
    deletedOn?: Date | null;
    documentLocationType?: DocumentLocationType;
    isValid?: boolean;
}

export class GetAssessmentsForCaseResponse implements IGetAssessmentsForCaseResponse {
    participant?: ParticipantDataViewModel | null;
    counselors?: CounselorDepartmentViewModel[] | null;
    assessmentResults?: AssessmentResultCaseViewModel[] | null;

    constructor(data?: IGetAssessmentsForCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participant = _data["participant"] ? ParticipantDataViewModel.fromJS(_data["participant"]) : <any>null;
            if (Array.isArray(_data["counselors"])) {
                this.counselors = [] as any;
                for (let item of _data["counselors"])
                    this.counselors!.push(CounselorDepartmentViewModel.fromJS(item));
            }
            else {
                this.counselors = <any>null;
            }
            if (Array.isArray(_data["assessmentResults"])) {
                this.assessmentResults = [] as any;
                for (let item of _data["assessmentResults"])
                    this.assessmentResults!.push(AssessmentResultCaseViewModel.fromJS(item));
            }
            else {
                this.assessmentResults = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAssessmentsForCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssessmentsForCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        if (Array.isArray(this.counselors)) {
            data["counselors"] = [];
            for (let item of this.counselors)
                data["counselors"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentResults)) {
            data["assessmentResults"] = [];
            for (let item of this.assessmentResults)
                data["assessmentResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAssessmentsForCaseResponse {
        const json = this.toJSON();
        let result = new GetAssessmentsForCaseResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAssessmentsForCaseResponse {
    participant?: ParticipantDataViewModel | null;
    counselors?: CounselorDepartmentViewModel[] | null;
    assessmentResults?: AssessmentResultCaseViewModel[] | null;
}

export class CounselorDepartmentViewModel implements ICounselorDepartmentViewModel {
    departmentName?: string | null;
    counselors?: CounselorDeptInformationViewModel[] | null;

    constructor(data?: ICounselorDepartmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : <any>null;
            if (Array.isArray(_data["counselors"])) {
                this.counselors = [] as any;
                for (let item of _data["counselors"])
                    this.counselors!.push(CounselorDeptInformationViewModel.fromJS(item));
            }
            else {
                this.counselors = <any>null;
            }
        }
    }

    static fromJS(data: any): CounselorDepartmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CounselorDepartmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : <any>null;
        if (Array.isArray(this.counselors)) {
            data["counselors"] = [];
            for (let item of this.counselors)
                data["counselors"].push(item.toJSON());
        }
        return data;
    }

    clone(): CounselorDepartmentViewModel {
        const json = this.toJSON();
        let result = new CounselorDepartmentViewModel();
        result.init(json);
        return result;
    }
}

export interface ICounselorDepartmentViewModel {
    departmentName?: string | null;
    counselors?: CounselorDeptInformationViewModel[] | null;
}

export class CounselorDeptInformationViewModel implements ICounselorDeptInformationViewModel {
    counselorId?: string | null;
    counselorName?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    districtId?: string | null;
    districtName?: string | null;

    constructor(data?: ICounselorDeptInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselorId = _data["counselorId"] !== undefined ? _data["counselorId"] : <any>null;
            this.counselorName = _data["counselorName"] !== undefined ? _data["counselorName"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
        }
    }

    static fromJS(data: any): CounselorDeptInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CounselorDeptInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselorId"] = this.counselorId !== undefined ? this.counselorId : <any>null;
        data["counselorName"] = this.counselorName !== undefined ? this.counselorName : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        return data;
    }

    clone(): CounselorDeptInformationViewModel {
        const json = this.toJSON();
        let result = new CounselorDeptInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface ICounselorDeptInformationViewModel {
    counselorId?: string | null;
    counselorName?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    districtId?: string | null;
    districtName?: string | null;
}

export class AssessmentResultCaseViewModel implements IAssessmentResultCaseViewModel {
    id?: string | null;
    name?: string | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    counselorInputComplete?: boolean;
    sentCaseDate?: Date | null;
    secondaryAssessmentResultId?: string | null;
    label?: string | null;

    constructor(data?: IAssessmentResultCaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.priorityLevel = _data["priorityLevel"] !== undefined ? _data["priorityLevel"] : <any>null;
            this.counselorInputComplete = _data["counselorInputComplete"] !== undefined ? _data["counselorInputComplete"] : <any>null;
            this.sentCaseDate = _data["sentCaseDate"] ? new Date(_data["sentCaseDate"].toString()) : <any>null;
            this.secondaryAssessmentResultId = _data["secondaryAssessmentResultId"] !== undefined ? _data["secondaryAssessmentResultId"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
        }
    }

    static fromJS(data: any): AssessmentResultCaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentResultCaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["priorityLevel"] = this.priorityLevel !== undefined ? this.priorityLevel : <any>null;
        data["counselorInputComplete"] = this.counselorInputComplete !== undefined ? this.counselorInputComplete : <any>null;
        data["sentCaseDate"] = this.sentCaseDate ? this.sentCaseDate.toISOString() : <any>null;
        data["secondaryAssessmentResultId"] = this.secondaryAssessmentResultId !== undefined ? this.secondaryAssessmentResultId : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data;
    }

    clone(): AssessmentResultCaseViewModel {
        const json = this.toJSON();
        let result = new AssessmentResultCaseViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssessmentResultCaseViewModel {
    id?: string | null;
    name?: string | null;
    dateSubmitted?: Date | null;
    status?: AssessmentStatus | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    counselorInputComplete?: boolean;
    sentCaseDate?: Date | null;
    secondaryAssessmentResultId?: string | null;
    label?: string | null;
}

export class SaveFrHcwCaseResponse implements ISaveFrHcwCaseResponse {

    constructor(data?: ISaveFrHcwCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SaveFrHcwCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFrHcwCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SaveFrHcwCaseResponse {
        const json = this.toJSON();
        let result = new SaveFrHcwCaseResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveFrHcwCaseResponse {
}

export class SaveFrHcwCaseRequest implements ISaveFrHcwCaseRequest {
    branchId?: string | null;
    case?: CreateCaseViewModel | null;

    constructor(data?: ISaveFrHcwCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.case = _data["case"] ? CreateCaseViewModel.fromJS(_data["case"]) : <any>null;
        }
    }

    static fromJS(data: any): SaveFrHcwCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFrHcwCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        return data;
    }

    clone(): SaveFrHcwCaseRequest {
        const json = this.toJSON();
        let result = new SaveFrHcwCaseRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveFrHcwCaseRequest {
    branchId?: string | null;
    case?: CreateCaseViewModel | null;
}

export class CreateCaseViewModel implements ICreateCaseViewModel {
    source?: string | null;
    sourceName?: string | null;
    comments?: string | null;
    status?: CaseStatus;
    participant?: ParticipantDataViewModel | null;
    counselorDepartments?: CounselorDeptInformationViewModel[] | null;
    assessments?: AssessmentResultCaseViewModel[] | null;

    constructor(data?: ICreateCaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.sourceName = _data["sourceName"] !== undefined ? _data["sourceName"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.participant = _data["participant"] ? ParticipantDataViewModel.fromJS(_data["participant"]) : <any>null;
            if (Array.isArray(_data["counselorDepartments"])) {
                this.counselorDepartments = [] as any;
                for (let item of _data["counselorDepartments"])
                    this.counselorDepartments!.push(CounselorDeptInformationViewModel.fromJS(item));
            }
            else {
                this.counselorDepartments = <any>null;
            }
            if (Array.isArray(_data["assessments"])) {
                this.assessments = [] as any;
                for (let item of _data["assessments"])
                    this.assessments!.push(AssessmentResultCaseViewModel.fromJS(item));
            }
            else {
                this.assessments = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateCaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        if (Array.isArray(this.counselorDepartments)) {
            data["counselorDepartments"] = [];
            for (let item of this.counselorDepartments)
                data["counselorDepartments"].push(item.toJSON());
        }
        if (Array.isArray(this.assessments)) {
            data["assessments"] = [];
            for (let item of this.assessments)
                data["assessments"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateCaseViewModel {
        const json = this.toJSON();
        let result = new CreateCaseViewModel();
        result.init(json);
        return result;
    }
}

export interface ICreateCaseViewModel {
    source?: string | null;
    sourceName?: string | null;
    comments?: string | null;
    status?: CaseStatus;
    participant?: ParticipantDataViewModel | null;
    counselorDepartments?: CounselorDeptInformationViewModel[] | null;
    assessments?: AssessmentResultCaseViewModel[] | null;
}

export class UpdateCaseNotesResponse implements IUpdateCaseNotesResponse {
    notes?: ChaplainProviderNoteDto[] | null;

    constructor(data?: IUpdateCaseNotesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(ChaplainProviderNoteDto.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateCaseNotesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseNotesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateCaseNotesResponse {
        const json = this.toJSON();
        let result = new UpdateCaseNotesResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseNotesResponse {
    notes?: ChaplainProviderNoteDto[] | null;
}

export class UpdateCaseNotesRequest implements IUpdateCaseNotesRequest {
    id?: string | null;
    note?: ChaplainProviderNoteDto | null;

    constructor(data?: IUpdateCaseNotesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.note = _data["note"] ? ChaplainProviderNoteDto.fromJS(_data["note"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateCaseNotesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseNotesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["note"] = this.note ? this.note.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateCaseNotesRequest {
        const json = this.toJSON();
        let result = new UpdateCaseNotesRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseNotesRequest {
    id?: string | null;
    note?: ChaplainProviderNoteDto | null;
}

export class GetCaseNotesResponse implements IGetCaseNotesResponse {
    notes?: ChaplainProviderNoteDto[] | null;

    constructor(data?: IGetCaseNotesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(ChaplainProviderNoteDto.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCaseNotesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaseNotesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetCaseNotesResponse {
        const json = this.toJSON();
        let result = new GetCaseNotesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCaseNotesResponse {
    notes?: ChaplainProviderNoteDto[] | null;
}

export class UpdateCaseStatusWithNoteResponse implements IUpdateCaseStatusWithNoteResponse {
    id?: string | null;
    status?: CaseStatus;

    constructor(data?: IUpdateCaseStatusWithNoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCaseStatusWithNoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseStatusWithNoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): UpdateCaseStatusWithNoteResponse {
        const json = this.toJSON();
        let result = new UpdateCaseStatusWithNoteResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseStatusWithNoteResponse {
    id?: string | null;
    status?: CaseStatus;
}

export class UpdateCaseStatusWithNoteRequest implements IUpdateCaseStatusWithNoteRequest {
    id?: string | null;
    status?: CaseStatus;
    sendEmailToCounselors?: boolean | null;

    constructor(data?: IUpdateCaseStatusWithNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.sendEmailToCounselors = _data["sendEmailToCounselors"] !== undefined ? _data["sendEmailToCounselors"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCaseStatusWithNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseStatusWithNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["sendEmailToCounselors"] = this.sendEmailToCounselors !== undefined ? this.sendEmailToCounselors : <any>null;
        return data;
    }

    clone(): UpdateCaseStatusWithNoteRequest {
        const json = this.toJSON();
        let result = new UpdateCaseStatusWithNoteRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseStatusWithNoteRequest {
    id?: string | null;
    status?: CaseStatus;
    sendEmailToCounselors?: boolean | null;
}

export class UploadCaseDocumentsResponse implements IUploadCaseDocumentsResponse {

    constructor(data?: IUploadCaseDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UploadCaseDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCaseDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UploadCaseDocumentsResponse {
        const json = this.toJSON();
        let result = new UploadCaseDocumentsResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadCaseDocumentsResponse {
}

export class DownloadCaseDocumentResponse implements IDownloadCaseDocumentResponse {
    link?: string | null;

    constructor(data?: IDownloadCaseDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
        }
    }

    static fromJS(data: any): DownloadCaseDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadCaseDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link !== undefined ? this.link : <any>null;
        return data;
    }

    clone(): DownloadCaseDocumentResponse {
        const json = this.toJSON();
        let result = new DownloadCaseDocumentResponse();
        result.init(json);
        return result;
    }
}

export interface IDownloadCaseDocumentResponse {
    link?: string | null;
}

export class UpdateCaseStatusResponse implements IUpdateCaseStatusResponse {
    id?: string | null;

    constructor(data?: IUpdateCaseStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCaseStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateCaseStatusResponse {
        const json = this.toJSON();
        let result = new UpdateCaseStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseStatusResponse {
    id?: string | null;
}

export class UpdateCaseStatusRequest implements IUpdateCaseStatusRequest {
    id?: string | null;
    status?: CaseStatus;

    constructor(data?: IUpdateCaseStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCaseStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): UpdateCaseStatusRequest {
        const json = this.toJSON();
        let result = new UpdateCaseStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseStatusRequest {
    id?: string | null;
    status?: CaseStatus;
}

export class GetCasesByCounselorResponse implements IGetCasesByCounselorResponse {
    cases?: FirstResponderCaseViewModel[] | null;

    constructor(data?: IGetCasesByCounselorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(FirstResponderCaseViewModel.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCasesByCounselorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCasesByCounselorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetCasesByCounselorResponse {
        const json = this.toJSON();
        let result = new GetCasesByCounselorResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCasesByCounselorResponse {
    cases?: FirstResponderCaseViewModel[] | null;
}

export class FirstResponderCaseViewModel implements IFirstResponderCaseViewModel {
    caseNumber?: string | null;
    id?: string | null;
    source?: string | null;
    sourceName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    participantId?: string | null;
    department?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    status?: CaseStatus;
    dateSubmitted?: Date | null;

    constructor(data?: IFirstResponderCaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.sourceName = _data["sourceName"] !== undefined ? _data["sourceName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
            this.department = _data["department"] !== undefined ? _data["department"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.priorityLevel = _data["priorityLevel"] !== undefined ? _data["priorityLevel"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): FirstResponderCaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FirstResponderCaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        data["department"] = this.department !== undefined ? this.department : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["priorityLevel"] = this.priorityLevel !== undefined ? this.priorityLevel : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        return data;
    }

    clone(): FirstResponderCaseViewModel {
        const json = this.toJSON();
        let result = new FirstResponderCaseViewModel();
        result.init(json);
        return result;
    }
}

export interface IFirstResponderCaseViewModel {
    caseNumber?: string | null;
    id?: string | null;
    source?: string | null;
    sourceName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    participantId?: string | null;
    department?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    status?: CaseStatus;
    dateSubmitted?: Date | null;
}

export class CanAccessCaseResponse implements ICanAccessCaseResponse {
    hasAccess?: boolean;

    constructor(data?: ICanAccessCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAccess = _data["hasAccess"] !== undefined ? _data["hasAccess"] : <any>null;
        }
    }

    static fromJS(data: any): CanAccessCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CanAccessCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAccess"] = this.hasAccess !== undefined ? this.hasAccess : <any>null;
        return data;
    }

    clone(): CanAccessCaseResponse {
        const json = this.toJSON();
        let result = new CanAccessCaseResponse();
        result.init(json);
        return result;
    }
}

export interface ICanAccessCaseResponse {
    hasAccess?: boolean;
}

export class GetCasePreviewsResponse implements IGetCasePreviewsResponse {
    casePreviews?: CasePreview[] | null;
    resultsLength?: number;

    constructor(data?: IGetCasePreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["casePreviews"])) {
                this.casePreviews = [] as any;
                for (let item of _data["casePreviews"])
                    this.casePreviews!.push(CasePreview.fromJS(item));
            }
            else {
                this.casePreviews = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): GetCasePreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCasePreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.casePreviews)) {
            data["casePreviews"] = [];
            for (let item of this.casePreviews)
                data["casePreviews"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): GetCasePreviewsResponse {
        const json = this.toJSON();
        let result = new GetCasePreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCasePreviewsResponse {
    casePreviews?: CasePreview[] | null;
    resultsLength?: number;
}

export class CasePreview implements ICasePreview {
    id?: string | null;
    caseNumber?: string | null;
    submittedDate?: Date | null;
    status?: CaseStatus | null;
    assignedCounselorNames?: string[] | null;

    constructor(data?: ICasePreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["assignedCounselorNames"])) {
                this.assignedCounselorNames = [] as any;
                for (let item of _data["assignedCounselorNames"])
                    this.assignedCounselorNames!.push(item);
            }
            else {
                this.assignedCounselorNames = <any>null;
            }
        }
    }

    static fromJS(data: any): CasePreview {
        data = typeof data === 'object' ? data : {};
        let result = new CasePreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.assignedCounselorNames)) {
            data["assignedCounselorNames"] = [];
            for (let item of this.assignedCounselorNames)
                data["assignedCounselorNames"].push(item);
        }
        return data;
    }

    clone(): CasePreview {
        const json = this.toJSON();
        let result = new CasePreview();
        result.init(json);
        return result;
    }
}

export interface ICasePreview {
    id?: string | null;
    caseNumber?: string | null;
    submittedDate?: Date | null;
    status?: CaseStatus | null;
    assignedCounselorNames?: string[] | null;
}

export class CreateSchoolCaseResponse implements ICreateSchoolCaseResponse {
    id?: string | null;

    constructor(data?: ICreateSchoolCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSchoolCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSchoolCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): CreateSchoolCaseResponse {
        const json = this.toJSON();
        let result = new CreateSchoolCaseResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateSchoolCaseResponse {
    id?: string | null;
}

export class CreateSchoolCaseRequest implements ICreateSchoolCaseRequest {
    case?: SchoolCaseViewModel | null;

    constructor(data?: ICreateSchoolCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case = _data["case"] ? SchoolCaseViewModel.fromJS(_data["case"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateSchoolCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSchoolCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        return data;
    }

    clone(): CreateSchoolCaseRequest {
        const json = this.toJSON();
        let result = new CreateSchoolCaseRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateSchoolCaseRequest {
    case?: SchoolCaseViewModel | null;
}

export class SchoolCaseViewModel implements ISchoolCaseViewModel {
    id?: string | null;
    caseNumber?: string | null;
    source?: string | null;
    sourceName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    studentId?: string | null;
    participantId?: string | null;
    participant?: ParticipantDataViewModel | null;
    assignedUserId?: string | null;
    assignedUserName?: string | null;
    districtId?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    status?: CaseStatus;
    comments?: string | null;
    assessmentId?: string | null;
    dateSubmitted?: Date | null;
    chaplainProviderNotes?: ChaplainProviderNoteDto[] | null;
    updateLog?: CaseUpdateDto[] | null;
    fileUploads?: CaseDocument[] | null;

    constructor(data?: ISchoolCaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.sourceName = _data["sourceName"] !== undefined ? _data["sourceName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : <any>null;
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
            this.participant = _data["participant"] ? ParticipantDataViewModel.fromJS(_data["participant"]) : <any>null;
            this.assignedUserId = _data["assignedUserId"] !== undefined ? _data["assignedUserId"] : <any>null;
            this.assignedUserName = _data["assignedUserName"] !== undefined ? _data["assignedUserName"] : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.priorityLevel = _data["priorityLevel"] !== undefined ? _data["priorityLevel"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.assessmentId = _data["assessmentId"] !== undefined ? _data["assessmentId"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            if (Array.isArray(_data["chaplainProviderNotes"])) {
                this.chaplainProviderNotes = [] as any;
                for (let item of _data["chaplainProviderNotes"])
                    this.chaplainProviderNotes!.push(ChaplainProviderNoteDto.fromJS(item));
            }
            else {
                this.chaplainProviderNotes = <any>null;
            }
            if (Array.isArray(_data["updateLog"])) {
                this.updateLog = [] as any;
                for (let item of _data["updateLog"])
                    this.updateLog!.push(CaseUpdateDto.fromJS(item));
            }
            else {
                this.updateLog = <any>null;
            }
            if (Array.isArray(_data["fileUploads"])) {
                this.fileUploads = [] as any;
                for (let item of _data["fileUploads"])
                    this.fileUploads!.push(CaseDocument.fromJS(item));
            }
            else {
                this.fileUploads = <any>null;
            }
        }
    }

    static fromJS(data: any): SchoolCaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolCaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["studentId"] = this.studentId !== undefined ? this.studentId : <any>null;
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        data["assignedUserId"] = this.assignedUserId !== undefined ? this.assignedUserId : <any>null;
        data["assignedUserName"] = this.assignedUserName !== undefined ? this.assignedUserName : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["priorityLevel"] = this.priorityLevel !== undefined ? this.priorityLevel : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["assessmentId"] = this.assessmentId !== undefined ? this.assessmentId : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        if (Array.isArray(this.chaplainProviderNotes)) {
            data["chaplainProviderNotes"] = [];
            for (let item of this.chaplainProviderNotes)
                data["chaplainProviderNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.updateLog)) {
            data["updateLog"] = [];
            for (let item of this.updateLog)
                data["updateLog"].push(item.toJSON());
        }
        if (Array.isArray(this.fileUploads)) {
            data["fileUploads"] = [];
            for (let item of this.fileUploads)
                data["fileUploads"].push(item.toJSON());
        }
        return data;
    }

    clone(): SchoolCaseViewModel {
        const json = this.toJSON();
        let result = new SchoolCaseViewModel();
        result.init(json);
        return result;
    }
}

export interface ISchoolCaseViewModel {
    id?: string | null;
    caseNumber?: string | null;
    source?: string | null;
    sourceName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    studentId?: string | null;
    participantId?: string | null;
    participant?: ParticipantDataViewModel | null;
    assignedUserId?: string | null;
    assignedUserName?: string | null;
    districtId?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
    status?: CaseStatus;
    comments?: string | null;
    assessmentId?: string | null;
    dateSubmitted?: Date | null;
    chaplainProviderNotes?: ChaplainProviderNoteDto[] | null;
    updateLog?: CaseUpdateDto[] | null;
    fileUploads?: CaseDocument[] | null;
}

export class CaseUpdateDto implements ICaseUpdateDto {
    userId?: string | null;
    role?: string | null;
    updatedDate?: Date;
    action?: CaseAction;
    previousValue?: string | null;
    newValue?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: ICaseUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.previousValue = _data["previousValue"] !== undefined ? _data["previousValue"] : <any>null;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): CaseUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["previousValue"] = this.previousValue !== undefined ? this.previousValue : <any>null;
        data["newValue"] = this.newValue !== undefined ? this.newValue : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }

    clone(): CaseUpdateDto {
        const json = this.toJSON();
        let result = new CaseUpdateDto();
        result.init(json);
        return result;
    }
}

export interface ICaseUpdateDto {
    userId?: string | null;
    role?: string | null;
    updatedDate?: Date;
    action?: CaseAction;
    previousValue?: string | null;
    newValue?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export enum CaseAction {
    Status = "Status",
    Note = "Note",
    Assignee = "Assignee",
    Dismiss = "Dismiss",
    AssignParticipant = "AssignParticipant",
    DocumentUpload = "DocumentUpload",
}

export class GetSchoolCaseByIdResponse implements IGetSchoolCaseByIdResponse {
    case?: SchoolCaseViewModel | null;
    canAccess?: boolean;

    constructor(data?: IGetSchoolCaseByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case = _data["case"] ? SchoolCaseViewModel.fromJS(_data["case"]) : <any>null;
            this.canAccess = _data["canAccess"] !== undefined ? _data["canAccess"] : <any>null;
        }
    }

    static fromJS(data: any): GetSchoolCaseByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSchoolCaseByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["canAccess"] = this.canAccess !== undefined ? this.canAccess : <any>null;
        return data;
    }

    clone(): GetSchoolCaseByIdResponse {
        const json = this.toJSON();
        let result = new GetSchoolCaseByIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSchoolCaseByIdResponse {
    case?: SchoolCaseViewModel | null;
    canAccess?: boolean;
}

export class GetSchoolCasesByOrganizationResponse implements IGetSchoolCasesByOrganizationResponse {
    cases?: SchoolCaseViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IGetSchoolCasesByOrganizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(SchoolCaseViewModel.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): GetSchoolCasesByOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSchoolCasesByOrganizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): GetSchoolCasesByOrganizationResponse {
        const json = this.toJSON();
        let result = new GetSchoolCasesByOrganizationResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSchoolCasesByOrganizationResponse {
    cases?: SchoolCaseViewModel[] | null;
    resultsLength?: number;
}

export class GetSchoolCasesByOrganizationRequest implements IGetSchoolCasesByOrganizationRequest {
    counselor?: CounselorViewModel | null;

    constructor(data?: IGetSchoolCasesByOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselor = _data["counselor"] ? CounselorViewModel.fromJS(_data["counselor"]) : <any>null;
        }
    }

    static fromJS(data: any): GetSchoolCasesByOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSchoolCasesByOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselor"] = this.counselor ? this.counselor.toJSON() : <any>null;
        return data;
    }

    clone(): GetSchoolCasesByOrganizationRequest {
        const json = this.toJSON();
        let result = new GetSchoolCasesByOrganizationRequest();
        result.init(json);
        return result;
    }
}

export interface IGetSchoolCasesByOrganizationRequest {
    counselor?: CounselorViewModel | null;
}

export class CounselorViewModel implements ICounselorViewModel {
    id?: string | null;
    user?: UserViewModel | null;
    mailingAddress?: MailingAddress | null;
    organizations?: UserOrganizationViewModel[] | null;
    notificationSettings?: NotificationSettings | null;
    assessmentSettings?: AssessmentSettings | null;

    constructor(data?: ICounselorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(UserOrganizationViewModel.fromJS(item));
            }
            else {
                this.organizations = <any>null;
            }
            this.notificationSettings = _data["notificationSettings"] ? NotificationSettings.fromJS(_data["notificationSettings"]) : <any>null;
            this.assessmentSettings = _data["assessmentSettings"] ? AssessmentSettings.fromJS(_data["assessmentSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): CounselorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CounselorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        data["notificationSettings"] = this.notificationSettings ? this.notificationSettings.toJSON() : <any>null;
        data["assessmentSettings"] = this.assessmentSettings ? this.assessmentSettings.toJSON() : <any>null;
        return data;
    }

    clone(): CounselorViewModel {
        const json = this.toJSON();
        let result = new CounselorViewModel();
        result.init(json);
        return result;
    }
}

export interface ICounselorViewModel {
    id?: string | null;
    user?: UserViewModel | null;
    mailingAddress?: MailingAddress | null;
    organizations?: UserOrganizationViewModel[] | null;
    notificationSettings?: NotificationSettings | null;
    assessmentSettings?: AssessmentSettings | null;
}

export class NotificationSettings implements INotificationSettings {
    selfScreenings?: boolean;
    newCases?: boolean;
    caseUpdates?: boolean;
    newCaseNotes?: boolean;

    constructor(data?: INotificationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfScreenings = _data["selfScreenings"] !== undefined ? _data["selfScreenings"] : <any>null;
            this.newCases = _data["newCases"] !== undefined ? _data["newCases"] : <any>null;
            this.caseUpdates = _data["caseUpdates"] !== undefined ? _data["caseUpdates"] : <any>null;
            this.newCaseNotes = _data["newCaseNotes"] !== undefined ? _data["newCaseNotes"] : <any>null;
        }
    }

    static fromJS(data: any): NotificationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfScreenings"] = this.selfScreenings !== undefined ? this.selfScreenings : <any>null;
        data["newCases"] = this.newCases !== undefined ? this.newCases : <any>null;
        data["caseUpdates"] = this.caseUpdates !== undefined ? this.caseUpdates : <any>null;
        data["newCaseNotes"] = this.newCaseNotes !== undefined ? this.newCaseNotes : <any>null;
        return data;
    }

    clone(): NotificationSettings {
        const json = this.toJSON();
        let result = new NotificationSettings();
        result.init(json);
        return result;
    }
}

export interface INotificationSettings {
    selfScreenings?: boolean;
    newCases?: boolean;
    caseUpdates?: boolean;
    newCaseNotes?: boolean;
}

export class GetHotlineCasesForCurrentUserResponse implements IGetHotlineCasesForCurrentUserResponse {
    casePreviews?: HotlineCasePreview[] | null;
    resultsLength?: number;

    constructor(data?: IGetHotlineCasesForCurrentUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["casePreviews"])) {
                this.casePreviews = [] as any;
                for (let item of _data["casePreviews"])
                    this.casePreviews!.push(HotlineCasePreview.fromJS(item));
            }
            else {
                this.casePreviews = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): GetHotlineCasesForCurrentUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHotlineCasesForCurrentUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.casePreviews)) {
            data["casePreviews"] = [];
            for (let item of this.casePreviews)
                data["casePreviews"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): GetHotlineCasesForCurrentUserResponse {
        const json = this.toJSON();
        let result = new GetHotlineCasesForCurrentUserResponse();
        result.init(json);
        return result;
    }
}

export interface IGetHotlineCasesForCurrentUserResponse {
    casePreviews?: HotlineCasePreview[] | null;
    resultsLength?: number;
}

export class HotlineCasePreview implements IHotlineCasePreview {
    id?: string | null;
    caseNumber?: string | null;
    studentFirstName?: string | null;
    studentLastName?: string | null;
    studentOrganization?: string | null;
    studentDistrict?: string | null;
    riskLevel?: string | null;
    submittedDate?: Date;
    status?: CaseStatus | null;
    participantName?: string | null;

    constructor(data?: IHotlineCasePreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.studentFirstName = _data["studentFirstName"] !== undefined ? _data["studentFirstName"] : <any>null;
            this.studentLastName = _data["studentLastName"] !== undefined ? _data["studentLastName"] : <any>null;
            this.studentOrganization = _data["studentOrganization"] !== undefined ? _data["studentOrganization"] : <any>null;
            this.studentDistrict = _data["studentDistrict"] !== undefined ? _data["studentDistrict"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.participantName = _data["participantName"] !== undefined ? _data["participantName"] : <any>null;
        }
    }

    static fromJS(data: any): HotlineCasePreview {
        data = typeof data === 'object' ? data : {};
        let result = new HotlineCasePreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["studentFirstName"] = this.studentFirstName !== undefined ? this.studentFirstName : <any>null;
        data["studentLastName"] = this.studentLastName !== undefined ? this.studentLastName : <any>null;
        data["studentOrganization"] = this.studentOrganization !== undefined ? this.studentOrganization : <any>null;
        data["studentDistrict"] = this.studentDistrict !== undefined ? this.studentDistrict : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["participantName"] = this.participantName !== undefined ? this.participantName : <any>null;
        return data;
    }

    clone(): HotlineCasePreview {
        const json = this.toJSON();
        let result = new HotlineCasePreview();
        result.init(json);
        return result;
    }
}

export interface IHotlineCasePreview {
    id?: string | null;
    caseNumber?: string | null;
    studentFirstName?: string | null;
    studentLastName?: string | null;
    studentOrganization?: string | null;
    studentDistrict?: string | null;
    riskLevel?: string | null;
    submittedDate?: Date;
    status?: CaseStatus | null;
    participantName?: string | null;
}

export class DismissCaseResponse implements IDismissCaseResponse {

    constructor(data?: IDismissCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DismissCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DismissCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DismissCaseResponse {
        const json = this.toJSON();
        let result = new DismissCaseResponse();
        result.init(json);
        return result;
    }
}

export interface IDismissCaseResponse {
}

export class UpdateSchoolAssigneeResponse implements IUpdateSchoolAssigneeResponse {
    firstName?: string | null;
    lastName?: string | null;
    type?: string | null;

    constructor(data?: IUpdateSchoolAssigneeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateSchoolAssigneeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSchoolAssigneeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): UpdateSchoolAssigneeResponse {
        const json = this.toJSON();
        let result = new UpdateSchoolAssigneeResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateSchoolAssigneeResponse {
    firstName?: string | null;
    lastName?: string | null;
    type?: string | null;
}

export class QuickSearchCasesResponse implements IQuickSearchCasesResponse {
    cases?: SchoolCaseViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IQuickSearchCasesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(SchoolCaseViewModel.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): QuickSearchCasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuickSearchCasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): QuickSearchCasesResponse {
        const json = this.toJSON();
        let result = new QuickSearchCasesResponse();
        result.init(json);
        return result;
    }
}

export interface IQuickSearchCasesResponse {
    cases?: SchoolCaseViewModel[] | null;
    resultsLength?: number;
}

export class UpdateParticipantIdResponse implements IUpdateParticipantIdResponse {

    constructor(data?: IUpdateParticipantIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateParticipantIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateParticipantIdResponse {
        const json = this.toJSON();
        let result = new UpdateParticipantIdResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateParticipantIdResponse {
}

export class UpdateScheduleResponse implements IUpdateScheduleResponse {
    id?: string | null;

    constructor(data?: IUpdateScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateScheduleResponse {
        const json = this.toJSON();
        let result = new UpdateScheduleResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduleResponse {
    id?: string | null;
}

export class UpdateScheduleRequest implements IUpdateScheduleRequest {
    configuration?: ConfigurationViewModel | null;

    constructor(data?: IUpdateScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? ConfigurationViewModel.fromJS(_data["configuration"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateScheduleRequest {
        const json = this.toJSON();
        let result = new UpdateScheduleRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduleRequest {
    configuration?: ConfigurationViewModel | null;
}

export class ConfigurationViewModel implements IConfigurationViewModel {
    id?: string | null;
    type?: ConfigurationType;
    config?: any | null;

    constructor(data?: IConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.config = _data["config"] !== undefined ? _data["config"] : <any>null;
        }
    }

    static fromJS(data: any): ConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["config"] = this.config !== undefined ? this.config : <any>null;
        return data;
    }

    clone(): ConfigurationViewModel {
        const json = this.toJSON();
        let result = new ConfigurationViewModel();
        result.init(json);
        return result;
    }
}

export interface IConfigurationViewModel {
    id?: string | null;
    type?: ConfigurationType;
    config?: any | null;
}

export enum ConfigurationType {
    HotlineSchedule = "HotlineSchedule",
    IncidentResponseType = "IncidentResponseType",
}

export class GetHotlineScheduleResponse implements IGetHotlineScheduleResponse {
    schedule?: HotlineScheduleViewModel | null;

    constructor(data?: IGetHotlineScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schedule = _data["schedule"] ? HotlineScheduleViewModel.fromJS(_data["schedule"]) : <any>null;
        }
    }

    static fromJS(data: any): GetHotlineScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHotlineScheduleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>null;
        return data;
    }

    clone(): GetHotlineScheduleResponse {
        const json = this.toJSON();
        let result = new GetHotlineScheduleResponse();
        result.init(json);
        return result;
    }
}

export interface IGetHotlineScheduleResponse {
    schedule?: HotlineScheduleViewModel | null;
}

export class HotlineScheduleViewModel implements IHotlineScheduleViewModel {
    monday?: TimeRangeViewModel | null;
    tuesday?: TimeRangeViewModel | null;
    wednesday?: TimeRangeViewModel | null;
    thursday?: TimeRangeViewModel | null;
    friday?: TimeRangeViewModel | null;
    saturday?: TimeRangeViewModel | null;
    sunday?: TimeRangeViewModel | null;
    masterSwitch?: boolean;
    timeZone?: string | null;

    constructor(data?: IHotlineScheduleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monday = _data["monday"] ? TimeRangeViewModel.fromJS(_data["monday"]) : <any>null;
            this.tuesday = _data["tuesday"] ? TimeRangeViewModel.fromJS(_data["tuesday"]) : <any>null;
            this.wednesday = _data["wednesday"] ? TimeRangeViewModel.fromJS(_data["wednesday"]) : <any>null;
            this.thursday = _data["thursday"] ? TimeRangeViewModel.fromJS(_data["thursday"]) : <any>null;
            this.friday = _data["friday"] ? TimeRangeViewModel.fromJS(_data["friday"]) : <any>null;
            this.saturday = _data["saturday"] ? TimeRangeViewModel.fromJS(_data["saturday"]) : <any>null;
            this.sunday = _data["sunday"] ? TimeRangeViewModel.fromJS(_data["sunday"]) : <any>null;
            this.masterSwitch = _data["masterSwitch"] !== undefined ? _data["masterSwitch"] : <any>null;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : <any>null;
        }
    }

    static fromJS(data: any): HotlineScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HotlineScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monday"] = this.monday ? this.monday.toJSON() : <any>null;
        data["tuesday"] = this.tuesday ? this.tuesday.toJSON() : <any>null;
        data["wednesday"] = this.wednesday ? this.wednesday.toJSON() : <any>null;
        data["thursday"] = this.thursday ? this.thursday.toJSON() : <any>null;
        data["friday"] = this.friday ? this.friday.toJSON() : <any>null;
        data["saturday"] = this.saturday ? this.saturday.toJSON() : <any>null;
        data["sunday"] = this.sunday ? this.sunday.toJSON() : <any>null;
        data["masterSwitch"] = this.masterSwitch !== undefined ? this.masterSwitch : <any>null;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : <any>null;
        return data;
    }

    clone(): HotlineScheduleViewModel {
        const json = this.toJSON();
        let result = new HotlineScheduleViewModel();
        result.init(json);
        return result;
    }
}

export interface IHotlineScheduleViewModel {
    monday?: TimeRangeViewModel | null;
    tuesday?: TimeRangeViewModel | null;
    wednesday?: TimeRangeViewModel | null;
    thursday?: TimeRangeViewModel | null;
    friday?: TimeRangeViewModel | null;
    saturday?: TimeRangeViewModel | null;
    sunday?: TimeRangeViewModel | null;
    masterSwitch?: boolean;
    timeZone?: string | null;
}

export class TimeRangeViewModel implements ITimeRangeViewModel {
    startTime?: string | null;
    endTime?: string | null;

    constructor(data?: ITimeRangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : <any>null;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : <any>null;
        }
    }

    static fromJS(data: any): TimeRangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime !== undefined ? this.startTime : <any>null;
        data["endTime"] = this.endTime !== undefined ? this.endTime : <any>null;
        return data;
    }

    clone(): TimeRangeViewModel {
        const json = this.toJSON();
        let result = new TimeRangeViewModel();
        result.init(json);
        return result;
    }
}

export interface ITimeRangeViewModel {
    startTime?: string | null;
    endTime?: string | null;
}

export class GetIncidentResponseTypesResponse implements IGetIncidentResponseTypesResponse {
    options?: OptionViewModel[] | null;

    constructor(data?: IGetIncidentResponseTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionViewModel.fromJS(item));
            }
            else {
                this.options = <any>null;
            }
        }
    }

    static fromJS(data: any): GetIncidentResponseTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncidentResponseTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetIncidentResponseTypesResponse {
        const json = this.toJSON();
        let result = new GetIncidentResponseTypesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetIncidentResponseTypesResponse {
    options?: OptionViewModel[] | null;
}

export class OptionViewModel implements IOptionViewModel {
    value?: IncidentResponseType;
    label?: string | null;

    constructor(data?: IOptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
        }
    }

    static fromJS(data: any): OptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data;
    }

    clone(): OptionViewModel {
        const json = this.toJSON();
        let result = new OptionViewModel();
        result.init(json);
        return result;
    }
}

export interface IOptionViewModel {
    value?: IncidentResponseType;
    label?: string | null;
}

export class GetCounselorResponse implements IGetCounselorResponse {
    counselor?: CounselorViewModel | null;

    constructor(data?: IGetCounselorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselor = _data["counselor"] ? CounselorViewModel.fromJS(_data["counselor"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCounselorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCounselorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselor"] = this.counselor ? this.counselor.toJSON() : <any>null;
        return data;
    }

    clone(): GetCounselorResponse {
        const json = this.toJSON();
        let result = new GetCounselorResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCounselorResponse {
    counselor?: CounselorViewModel | null;
}

export class GetCounselorByUserIdResponse implements IGetCounselorByUserIdResponse {
    counselor?: CounselorViewModel | null;

    constructor(data?: IGetCounselorByUserIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselor = _data["counselor"] ? CounselorViewModel.fromJS(_data["counselor"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCounselorByUserIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCounselorByUserIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselor"] = this.counselor ? this.counselor.toJSON() : <any>null;
        return data;
    }

    clone(): GetCounselorByUserIdResponse {
        const json = this.toJSON();
        let result = new GetCounselorByUserIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCounselorByUserIdResponse {
    counselor?: CounselorViewModel | null;
}

export class CanAccessSchoolCaseResponse implements ICanAccessSchoolCaseResponse {
    canAccess?: boolean;

    constructor(data?: ICanAccessSchoolCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"] !== undefined ? _data["canAccess"] : <any>null;
        }
    }

    static fromJS(data: any): CanAccessSchoolCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CanAccessSchoolCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess !== undefined ? this.canAccess : <any>null;
        return data;
    }

    clone(): CanAccessSchoolCaseResponse {
        const json = this.toJSON();
        let result = new CanAccessSchoolCaseResponse();
        result.init(json);
        return result;
    }
}

export interface ICanAccessSchoolCaseResponse {
    canAccess?: boolean;
}

export class UpdateNotificationSettingsResponse implements IUpdateNotificationSettingsResponse {

    constructor(data?: IUpdateNotificationSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateNotificationSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateNotificationSettingsResponse {
        const json = this.toJSON();
        let result = new UpdateNotificationSettingsResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateNotificationSettingsResponse {
}

export class UpdateNotificationSettingsRequest implements IUpdateNotificationSettingsRequest {
    counselorId?: string | null;
    notificationSettings?: NotificationSettings | null;

    constructor(data?: IUpdateNotificationSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselorId = _data["counselorId"] !== undefined ? _data["counselorId"] : <any>null;
            this.notificationSettings = _data["notificationSettings"] ? NotificationSettings.fromJS(_data["notificationSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselorId"] = this.counselorId !== undefined ? this.counselorId : <any>null;
        data["notificationSettings"] = this.notificationSettings ? this.notificationSettings.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateNotificationSettingsRequest {
        const json = this.toJSON();
        let result = new UpdateNotificationSettingsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateNotificationSettingsRequest {
    counselorId?: string | null;
    notificationSettings?: NotificationSettings | null;
}

export class GetDistrictsResponse implements IGetDistrictsResponse {
    districts?: DistrictViewModel[] | null;

    constructor(data?: IGetDistrictsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(DistrictViewModel.fromJS(item));
            }
            else {
                this.districts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDistrictsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistrictsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDistrictsResponse {
        const json = this.toJSON();
        let result = new GetDistrictsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDistrictsResponse {
    districts?: DistrictViewModel[] | null;
}

export class DistrictViewModel implements IDistrictViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    regionId?: string | null;
    regionName?: string | null;

    constructor(data?: IDistrictViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : <any>null;
        }
    }

    static fromJS(data: any): DistrictViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        return data;
    }

    clone(): DistrictViewModel {
        const json = this.toJSON();
        let result = new DistrictViewModel();
        result.init(json);
        return result;
    }
}

export interface IDistrictViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    regionId?: string | null;
    regionName?: string | null;
}

export class GetDistrictResponse implements IGetDistrictResponse {
    district?: DistrictViewModel | null;

    constructor(data?: IGetDistrictResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.district = _data["district"] ? DistrictViewModel.fromJS(_data["district"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDistrictResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistrictResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["district"] = this.district ? this.district.toJSON() : <any>null;
        return data;
    }

    clone(): GetDistrictResponse {
        const json = this.toJSON();
        let result = new GetDistrictResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDistrictResponse {
    district?: DistrictViewModel | null;
}

export class GetRegionDistrictsResponse implements IGetRegionDistrictsResponse {
    districts?: DistrictViewModel[] | null;

    constructor(data?: IGetRegionDistrictsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(DistrictViewModel.fromJS(item));
            }
            else {
                this.districts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRegionDistrictsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionDistrictsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetRegionDistrictsResponse {
        const json = this.toJSON();
        let result = new GetRegionDistrictsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRegionDistrictsResponse {
    districts?: DistrictViewModel[] | null;
}

export class GetIncidentReportResponse implements IGetIncidentReportResponse {
    incidentReport?: IncidentReportViewModel | null;

    constructor(data?: IGetIncidentReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentReport = _data["incidentReport"] ? IncidentReportViewModel.fromJS(_data["incidentReport"]) : <any>null;
        }
    }

    static fromJS(data: any): GetIncidentReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncidentReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentReport"] = this.incidentReport ? this.incidentReport.toJSON() : <any>null;
        return data;
    }

    clone(): GetIncidentReportResponse {
        const json = this.toJSON();
        let result = new GetIncidentReportResponse();
        result.init(json);
        return result;
    }
}

export interface IGetIncidentReportResponse {
    incidentReport?: IncidentReportViewModel | null;
}

export class IncidentReportViewModel implements IIncidentReportViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    date?: Date;
    severityLevel?: IncidentSeverityLevel;
    description?: string | null;
    status?: IncidentReportStatus;
    accessLevel?: IncidentAccessLevel;
    locations?: UserOrganizationViewModel[] | null;
    previousEvents?: IncidentEventViewModel[] | null;
    upcomingEvents?: IncidentEventViewModel[] | null;

    constructor(data?: IIncidentReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.severityLevel = _data["severityLevel"] !== undefined ? _data["severityLevel"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.accessLevel = _data["accessLevel"] !== undefined ? _data["accessLevel"] : <any>null;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(UserOrganizationViewModel.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
            if (Array.isArray(_data["previousEvents"])) {
                this.previousEvents = [] as any;
                for (let item of _data["previousEvents"])
                    this.previousEvents!.push(IncidentEventViewModel.fromJS(item));
            }
            else {
                this.previousEvents = <any>null;
            }
            if (Array.isArray(_data["upcomingEvents"])) {
                this.upcomingEvents = [] as any;
                for (let item of _data["upcomingEvents"])
                    this.upcomingEvents!.push(IncidentEventViewModel.fromJS(item));
            }
            else {
                this.upcomingEvents = <any>null;
            }
        }
    }

    static fromJS(data: any): IncidentReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["severityLevel"] = this.severityLevel !== undefined ? this.severityLevel : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["accessLevel"] = this.accessLevel !== undefined ? this.accessLevel : <any>null;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.previousEvents)) {
            data["previousEvents"] = [];
            for (let item of this.previousEvents)
                data["previousEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.upcomingEvents)) {
            data["upcomingEvents"] = [];
            for (let item of this.upcomingEvents)
                data["upcomingEvents"].push(item.toJSON());
        }
        return data;
    }

    clone(): IncidentReportViewModel {
        const json = this.toJSON();
        let result = new IncidentReportViewModel();
        result.init(json);
        return result;
    }
}

export interface IIncidentReportViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    date?: Date;
    severityLevel?: IncidentSeverityLevel;
    description?: string | null;
    status?: IncidentReportStatus;
    accessLevel?: IncidentAccessLevel;
    locations?: UserOrganizationViewModel[] | null;
    previousEvents?: IncidentEventViewModel[] | null;
    upcomingEvents?: IncidentEventViewModel[] | null;
}

export enum IncidentSeverityLevel {
    Low = "Low",
    Moderate = "Moderate",
    Severe = "Severe",
}

export enum IncidentReportStatus {
    New = "New",
    Updated = "Updated",
    Closed = "Closed",
}

export enum IncidentAccessLevel {
    AllUsers = "AllUsers",
    AdminOnly = "AdminOnly",
    None = "None",
}

export class IncidentEventViewModel implements IIncidentEventViewModel {
    id?: string | null;
    name?: string | null;
    locationBranchId?: string | null;
    locationId?: string | null;
    districtName?: string | null;
    organizationName?: string | null;
    supportPhase?: SupportPhase;
    date?: Date;
    startTime?: Date;
    endTime?: Date;
    requestedResponseTypes?: RequestedResponseTypeViewModel[] | null;
    regionIdsToNotify?: string[] | null;
    comment?: string | null;

    constructor(data?: IIncidentEventViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.locationBranchId = _data["locationBranchId"] !== undefined ? _data["locationBranchId"] : <any>null;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.supportPhase = _data["supportPhase"] !== undefined ? _data["supportPhase"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            if (Array.isArray(_data["requestedResponseTypes"])) {
                this.requestedResponseTypes = [] as any;
                for (let item of _data["requestedResponseTypes"])
                    this.requestedResponseTypes!.push(RequestedResponseTypeViewModel.fromJS(item));
            }
            else {
                this.requestedResponseTypes = <any>null;
            }
            if (Array.isArray(_data["regionIdsToNotify"])) {
                this.regionIdsToNotify = [] as any;
                for (let item of _data["regionIdsToNotify"])
                    this.regionIdsToNotify!.push(item);
            }
            else {
                this.regionIdsToNotify = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): IncidentEventViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentEventViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["locationBranchId"] = this.locationBranchId !== undefined ? this.locationBranchId : <any>null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["supportPhase"] = this.supportPhase !== undefined ? this.supportPhase : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        if (Array.isArray(this.requestedResponseTypes)) {
            data["requestedResponseTypes"] = [];
            for (let item of this.requestedResponseTypes)
                data["requestedResponseTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.regionIdsToNotify)) {
            data["regionIdsToNotify"] = [];
            for (let item of this.regionIdsToNotify)
                data["regionIdsToNotify"].push(item);
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }

    clone(): IncidentEventViewModel {
        const json = this.toJSON();
        let result = new IncidentEventViewModel();
        result.init(json);
        return result;
    }
}

export interface IIncidentEventViewModel {
    id?: string | null;
    name?: string | null;
    locationBranchId?: string | null;
    locationId?: string | null;
    districtName?: string | null;
    organizationName?: string | null;
    supportPhase?: SupportPhase;
    date?: Date;
    startTime?: Date;
    endTime?: Date;
    requestedResponseTypes?: RequestedResponseTypeViewModel[] | null;
    regionIdsToNotify?: string[] | null;
    comment?: string | null;
}

export enum SupportPhase {
    ImmediateCrisis = "ImmediateCrisis",
    OneMonth = "OneMonth",
    ThreeMonths = "ThreeMonths",
    SixMonths = "SixMonths",
    TwelveMonths = "TwelveMonths",
}

export class RequestedResponseTypeViewModel implements IRequestedResponseTypeViewModel {
    id?: string | null;
    responseType?: IncidentResponseType;
    userId?: string | null;
    systemId?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IRequestedResponseTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): RequestedResponseTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestedResponseTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["responseType"] = this.responseType !== undefined ? this.responseType : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }

    clone(): RequestedResponseTypeViewModel {
        const json = this.toJSON();
        let result = new RequestedResponseTypeViewModel();
        result.init(json);
        return result;
    }
}

export interface IRequestedResponseTypeViewModel {
    id?: string | null;
    responseType?: IncidentResponseType;
    userId?: string | null;
    systemId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class CreateIncidentReportResponse implements ICreateIncidentReportResponse {
    id?: string | null;

    constructor(data?: ICreateIncidentReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreateIncidentReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): CreateIncidentReportResponse {
        const json = this.toJSON();
        let result = new CreateIncidentReportResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateIncidentReportResponse {
    id?: string | null;
}

export class CreateIncidentReportRequest implements ICreateIncidentReportRequest {
    incidentReport?: IncidentReportViewModel | null;

    constructor(data?: ICreateIncidentReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentReport = _data["incidentReport"] ? IncidentReportViewModel.fromJS(_data["incidentReport"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateIncidentReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentReport"] = this.incidentReport ? this.incidentReport.toJSON() : <any>null;
        return data;
    }

    clone(): CreateIncidentReportRequest {
        const json = this.toJSON();
        let result = new CreateIncidentReportRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateIncidentReportRequest {
    incidentReport?: IncidentReportViewModel | null;
}

export class UpdateIncidentReportResponse implements IUpdateIncidentReportResponse {
    id?: string | null;

    constructor(data?: IUpdateIncidentReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateIncidentReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateIncidentReportResponse {
        const json = this.toJSON();
        let result = new UpdateIncidentReportResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncidentReportResponse {
    id?: string | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
}

export class ApiError extends ProblemDetails implements IApiError {
    error?: string | null;
    errorKey?: any | null;

    constructor(data?: IApiError) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : <any>null;
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : <any>null;
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiError {
        const json = this.toJSON();
        let result = new ApiError();
        result.init(json);
        return result;
    }
}

export interface IApiError extends IProblemDetails {
    error?: string | null;
    errorKey?: any | null;
}

export class UpdateIncidentReportRequest implements IUpdateIncidentReportRequest {
    incidentReport?: IncidentReportViewModel | null;
    id?: string | null;

    constructor(data?: IUpdateIncidentReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentReport = _data["incidentReport"] ? IncidentReportViewModel.fromJS(_data["incidentReport"]) : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateIncidentReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentReport"] = this.incidentReport ? this.incidentReport.toJSON() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateIncidentReportRequest {
        const json = this.toJSON();
        let result = new UpdateIncidentReportRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncidentReportRequest {
    incidentReport?: IncidentReportViewModel | null;
    id?: string | null;
}

export class UpdateIncidentReportAccessResponse implements IUpdateIncidentReportAccessResponse {
    accessLevel?: IncidentAccessLevel;

    constructor(data?: IUpdateIncidentReportAccessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessLevel = _data["accessLevel"] !== undefined ? _data["accessLevel"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateIncidentReportAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentReportAccessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessLevel"] = this.accessLevel !== undefined ? this.accessLevel : <any>null;
        return data;
    }

    clone(): UpdateIncidentReportAccessResponse {
        const json = this.toJSON();
        let result = new UpdateIncidentReportAccessResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncidentReportAccessResponse {
    accessLevel?: IncidentAccessLevel;
}

export class UpdateIncidentReportAccessRequest implements IUpdateIncidentReportAccessRequest {
    accessLevel?: IncidentAccessLevel;
    id?: string | null;

    constructor(data?: IUpdateIncidentReportAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessLevel = _data["accessLevel"] !== undefined ? _data["accessLevel"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateIncidentReportAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentReportAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessLevel"] = this.accessLevel !== undefined ? this.accessLevel : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateIncidentReportAccessRequest {
        const json = this.toJSON();
        let result = new UpdateIncidentReportAccessRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncidentReportAccessRequest {
    accessLevel?: IncidentAccessLevel;
    id?: string | null;
}

export class GetIncidentReportPreviewsResponse implements IGetIncidentReportPreviewsResponse {
    incidentReports?: IncidentReportsPreview[] | null;

    constructor(data?: IGetIncidentReportPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incidentReports"])) {
                this.incidentReports = [] as any;
                for (let item of _data["incidentReports"])
                    this.incidentReports!.push(IncidentReportsPreview.fromJS(item));
            }
            else {
                this.incidentReports = <any>null;
            }
        }
    }

    static fromJS(data: any): GetIncidentReportPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncidentReportPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incidentReports)) {
            data["incidentReports"] = [];
            for (let item of this.incidentReports)
                data["incidentReports"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetIncidentReportPreviewsResponse {
        const json = this.toJSON();
        let result = new GetIncidentReportPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetIncidentReportPreviewsResponse {
    incidentReports?: IncidentReportsPreview[] | null;
}

export class IncidentReportsPreview implements IIncidentReportsPreview {
    id?: string | null;
    name?: string | null;
    date?: Date;
    branchId?: string | null;
    status?: IncidentReportStatus;
    accessLevel?: IncidentAccessLevel;
    organizationNames?: string[] | null;

    constructor(data?: IIncidentReportsPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.accessLevel = _data["accessLevel"] !== undefined ? _data["accessLevel"] : <any>null;
            if (Array.isArray(_data["organizationNames"])) {
                this.organizationNames = [] as any;
                for (let item of _data["organizationNames"])
                    this.organizationNames!.push(item);
            }
            else {
                this.organizationNames = <any>null;
            }
        }
    }

    static fromJS(data: any): IncidentReportsPreview {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReportsPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["accessLevel"] = this.accessLevel !== undefined ? this.accessLevel : <any>null;
        if (Array.isArray(this.organizationNames)) {
            data["organizationNames"] = [];
            for (let item of this.organizationNames)
                data["organizationNames"].push(item);
        }
        return data;
    }

    clone(): IncidentReportsPreview {
        const json = this.toJSON();
        let result = new IncidentReportsPreview();
        result.init(json);
        return result;
    }
}

export interface IIncidentReportsPreview {
    id?: string | null;
    name?: string | null;
    date?: Date;
    branchId?: string | null;
    status?: IncidentReportStatus;
    accessLevel?: IncidentAccessLevel;
    organizationNames?: string[] | null;
}

export class CreateIncidentEventResponse implements ICreateIncidentEventResponse {

    constructor(data?: ICreateIncidentEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateIncidentEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateIncidentEventResponse {
        const json = this.toJSON();
        let result = new CreateIncidentEventResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateIncidentEventResponse {
}

export class CreateIncidentEventRequest implements ICreateIncidentEventRequest {
    incidentReportId?: string | null;
    name?: string | null;
    locationBranchId?: string | null;
    locationId?: string | null;
    supportPhase?: SupportPhase;
    date?: Date;
    startTime?: Date;
    endTime?: Date;
    requestedResponseTypes?: RequestedResponseTypeViewModel[] | null;
    regionIdsToNotify?: string[] | null;
    comment?: string | null;

    constructor(data?: ICreateIncidentEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentReportId = _data["incidentReportId"] !== undefined ? _data["incidentReportId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.locationBranchId = _data["locationBranchId"] !== undefined ? _data["locationBranchId"] : <any>null;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.supportPhase = _data["supportPhase"] !== undefined ? _data["supportPhase"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            if (Array.isArray(_data["requestedResponseTypes"])) {
                this.requestedResponseTypes = [] as any;
                for (let item of _data["requestedResponseTypes"])
                    this.requestedResponseTypes!.push(RequestedResponseTypeViewModel.fromJS(item));
            }
            else {
                this.requestedResponseTypes = <any>null;
            }
            if (Array.isArray(_data["regionIdsToNotify"])) {
                this.regionIdsToNotify = [] as any;
                for (let item of _data["regionIdsToNotify"])
                    this.regionIdsToNotify!.push(item);
            }
            else {
                this.regionIdsToNotify = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): CreateIncidentEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentReportId"] = this.incidentReportId !== undefined ? this.incidentReportId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["locationBranchId"] = this.locationBranchId !== undefined ? this.locationBranchId : <any>null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["supportPhase"] = this.supportPhase !== undefined ? this.supportPhase : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        if (Array.isArray(this.requestedResponseTypes)) {
            data["requestedResponseTypes"] = [];
            for (let item of this.requestedResponseTypes)
                data["requestedResponseTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.regionIdsToNotify)) {
            data["regionIdsToNotify"] = [];
            for (let item of this.regionIdsToNotify)
                data["regionIdsToNotify"].push(item);
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }

    clone(): CreateIncidentEventRequest {
        const json = this.toJSON();
        let result = new CreateIncidentEventRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateIncidentEventRequest {
    incidentReportId?: string | null;
    name?: string | null;
    locationBranchId?: string | null;
    locationId?: string | null;
    supportPhase?: SupportPhase;
    date?: Date;
    startTime?: Date;
    endTime?: Date;
    requestedResponseTypes?: RequestedResponseTypeViewModel[] | null;
    regionIdsToNotify?: string[] | null;
    comment?: string | null;
}

export class UpdateIncidentEventResponse implements IUpdateIncidentEventResponse {

    constructor(data?: IUpdateIncidentEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateIncidentEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateIncidentEventResponse {
        const json = this.toJSON();
        let result = new UpdateIncidentEventResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncidentEventResponse {
}

export class UpdateIncidentEventRequest implements IUpdateIncidentEventRequest {
    reportId?: string | null;
    eventId?: string | null;
    incidentEventViewModel?: IncidentEventViewModel | null;

    constructor(data?: IUpdateIncidentEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : <any>null;
            this.incidentEventViewModel = _data["incidentEventViewModel"] ? IncidentEventViewModel.fromJS(_data["incidentEventViewModel"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateIncidentEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : <any>null;
        data["incidentEventViewModel"] = this.incidentEventViewModel ? this.incidentEventViewModel.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateIncidentEventRequest {
        const json = this.toJSON();
        let result = new UpdateIncidentEventRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncidentEventRequest {
    reportId?: string | null;
    eventId?: string | null;
    incidentEventViewModel?: IncidentEventViewModel | null;
}

export class GetIncidentEventResponse implements IGetIncidentEventResponse {
    event?: IncidentEventViewModel | null;
    reportName?: string | null;

    constructor(data?: IGetIncidentEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"] ? IncidentEventViewModel.fromJS(_data["event"]) : <any>null;
            this.reportName = _data["reportName"] !== undefined ? _data["reportName"] : <any>null;
        }
    }

    static fromJS(data: any): GetIncidentEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncidentEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>null;
        data["reportName"] = this.reportName !== undefined ? this.reportName : <any>null;
        return data;
    }

    clone(): GetIncidentEventResponse {
        const json = this.toJSON();
        let result = new GetIncidentEventResponse();
        result.init(json);
        return result;
    }
}

export interface IGetIncidentEventResponse {
    event?: IncidentEventViewModel | null;
    reportName?: string | null;
}

export class DeleteIncidentEventResponse implements IDeleteIncidentEventResponse {

    constructor(data?: IDeleteIncidentEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteIncidentEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteIncidentEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DeleteIncidentEventResponse {
        const json = this.toJSON();
        let result = new DeleteIncidentEventResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteIncidentEventResponse {
}

export class AssignUserToResourceResponse implements IAssignUserToResourceResponse {
    assigneeName?: string | null;

    constructor(data?: IAssignUserToResourceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assigneeName = _data["assigneeName"] !== undefined ? _data["assigneeName"] : <any>null;
        }
    }

    static fromJS(data: any): AssignUserToResourceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserToResourceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assigneeName"] = this.assigneeName !== undefined ? this.assigneeName : <any>null;
        return data;
    }

    clone(): AssignUserToResourceResponse {
        const json = this.toJSON();
        let result = new AssignUserToResourceResponse();
        result.init(json);
        return result;
    }
}

export interface IAssignUserToResourceResponse {
    assigneeName?: string | null;
}

export class AssignUserToResourceRequest implements IAssignUserToResourceRequest {
    reportId?: string | null;
    eventId?: string | null;
    resourceId?: string | null;
    userId?: string | null;
    responseType?: IncidentResponseType;

    constructor(data?: IAssignUserToResourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : <any>null;
            this.resourceId = _data["resourceId"] !== undefined ? _data["resourceId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : <any>null;
        }
    }

    static fromJS(data: any): AssignUserToResourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserToResourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : <any>null;
        data["resourceId"] = this.resourceId !== undefined ? this.resourceId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["responseType"] = this.responseType !== undefined ? this.responseType : <any>null;
        return data;
    }

    clone(): AssignUserToResourceRequest {
        const json = this.toJSON();
        let result = new AssignUserToResourceRequest();
        result.init(json);
        return result;
    }
}

export interface IAssignUserToResourceRequest {
    reportId?: string | null;
    eventId?: string | null;
    resourceId?: string | null;
    userId?: string | null;
    responseType?: IncidentResponseType;
}

export class UnassignUserToResourceResponse implements IUnassignUserToResourceResponse {

    constructor(data?: IUnassignUserToResourceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UnassignUserToResourceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignUserToResourceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UnassignUserToResourceResponse {
        const json = this.toJSON();
        let result = new UnassignUserToResourceResponse();
        result.init(json);
        return result;
    }
}

export interface IUnassignUserToResourceResponse {
}

export class UnassignUserToResourceRequest implements IUnassignUserToResourceRequest {
    reportId?: string | null;
    eventId?: string | null;
    resourceId?: string | null;
    userId?: string | null;

    constructor(data?: IUnassignUserToResourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : <any>null;
            this.resourceId = _data["resourceId"] !== undefined ? _data["resourceId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): UnassignUserToResourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignUserToResourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : <any>null;
        data["resourceId"] = this.resourceId !== undefined ? this.resourceId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }

    clone(): UnassignUserToResourceRequest {
        const json = this.toJSON();
        let result = new UnassignUserToResourceRequest();
        result.init(json);
        return result;
    }
}

export interface IUnassignUserToResourceRequest {
    reportId?: string | null;
    eventId?: string | null;
    resourceId?: string | null;
    userId?: string | null;
}

export class GetInsurancesResponse implements IGetInsurancesResponse {
    insurances?: InsuranceViewModel[] | null;

    constructor(data?: IGetInsurancesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insurances"])) {
                this.insurances = [] as any;
                for (let item of _data["insurances"])
                    this.insurances!.push(InsuranceViewModel.fromJS(item));
            }
            else {
                this.insurances = <any>null;
            }
        }
    }

    static fromJS(data: any): GetInsurancesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsurancesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insurances)) {
            data["insurances"] = [];
            for (let item of this.insurances)
                data["insurances"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetInsurancesResponse {
        const json = this.toJSON();
        let result = new GetInsurancesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetInsurancesResponse {
    insurances?: InsuranceViewModel[] | null;
}

export class InsuranceViewModel implements IInsuranceViewModel {
    id?: string | null;
    name?: string | null;
    providerTally?: number | null;

    constructor(data?: IInsuranceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.providerTally = _data["providerTally"] !== undefined ? _data["providerTally"] : <any>null;
        }
    }

    static fromJS(data: any): InsuranceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["providerTally"] = this.providerTally !== undefined ? this.providerTally : <any>null;
        return data;
    }

    clone(): InsuranceViewModel {
        const json = this.toJSON();
        let result = new InsuranceViewModel();
        result.init(json);
        return result;
    }
}

export interface IInsuranceViewModel {
    id?: string | null;
    name?: string | null;
    providerTally?: number | null;
}

export class AddInsuranceResponse implements IAddInsuranceResponse {
    id?: string | null;

    constructor(data?: IAddInsuranceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddInsuranceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddInsuranceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): AddInsuranceResponse {
        const json = this.toJSON();
        let result = new AddInsuranceResponse();
        result.init(json);
        return result;
    }
}

export interface IAddInsuranceResponse {
    id?: string | null;
}

export class UpdateInsuranceResponse implements IUpdateInsuranceResponse {
    id?: string | null;

    constructor(data?: IUpdateInsuranceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateInsuranceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInsuranceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateInsuranceResponse {
        const json = this.toJSON();
        let result = new UpdateInsuranceResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateInsuranceResponse {
    id?: string | null;
}

export class DeleteInsuranceResponse implements IDeleteInsuranceResponse {
    result?: boolean;

    constructor(data?: IDeleteInsuranceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteInsuranceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInsuranceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        return data;
    }

    clone(): DeleteInsuranceResponse {
        const json = this.toJSON();
        let result = new DeleteInsuranceResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteInsuranceResponse {
    result?: boolean;
}

export class GeocodeResponse implements IGeocodeResponse {
    coordinates?: Coordinates | null;

    constructor(data?: IGeocodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : <any>null;
        }
    }

    static fromJS(data: any): GeocodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>null;
        return data;
    }

    clone(): GeocodeResponse {
        const json = this.toJSON();
        let result = new GeocodeResponse();
        result.init(json);
        return result;
    }
}

export interface IGeocodeResponse {
    coordinates?: Coordinates | null;
}

export class Coordinates implements ICoordinates {
    lng?: number;
    lat?: number;

    constructor(data?: ICoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
        }
    }

    static fromJS(data: any): Coordinates {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        return data;
    }

    clone(): Coordinates {
        const json = this.toJSON();
        let result = new Coordinates();
        result.init(json);
        return result;
    }
}

export interface ICoordinates {
    lng?: number;
    lat?: number;
}

export class CreateNeedResponse implements ICreateNeedResponse {
    id?: string | null;

    constructor(data?: ICreateNeedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreateNeedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNeedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): CreateNeedResponse {
        const json = this.toJSON();
        let result = new CreateNeedResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateNeedResponse {
    id?: string | null;
}

export class CreateNeedRequest implements ICreateNeedRequest {
    need?: NeedViewModel | null;

    constructor(data?: ICreateNeedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.need = _data["need"] ? NeedViewModel.fromJS(_data["need"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateNeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["need"] = this.need ? this.need.toJSON() : <any>null;
        return data;
    }

    clone(): CreateNeedRequest {
        const json = this.toJSON();
        let result = new CreateNeedRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateNeedRequest {
    need?: NeedViewModel | null;
}

export class UpdateNeedNameResponse implements IUpdateNeedNameResponse {
    needCode?: string | null;

    constructor(data?: IUpdateNeedNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.needCode = _data["needCode"] !== undefined ? _data["needCode"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateNeedNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNeedNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["needCode"] = this.needCode !== undefined ? this.needCode : <any>null;
        return data;
    }

    clone(): UpdateNeedNameResponse {
        const json = this.toJSON();
        let result = new UpdateNeedNameResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateNeedNameResponse {
    needCode?: string | null;
}

export class UpdateNeedNameRequest implements IUpdateNeedNameRequest {
    updatedNeedName?: string | null;
    updatedNeedCode?: string | null;
    previousNeedCode?: string | null;
    isSubNeed?: boolean;

    constructor(data?: IUpdateNeedNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedNeedName = _data["updatedNeedName"] !== undefined ? _data["updatedNeedName"] : <any>null;
            this.updatedNeedCode = _data["updatedNeedCode"] !== undefined ? _data["updatedNeedCode"] : <any>null;
            this.previousNeedCode = _data["previousNeedCode"] !== undefined ? _data["previousNeedCode"] : <any>null;
            this.isSubNeed = _data["isSubNeed"] !== undefined ? _data["isSubNeed"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateNeedNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNeedNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedNeedName"] = this.updatedNeedName !== undefined ? this.updatedNeedName : <any>null;
        data["updatedNeedCode"] = this.updatedNeedCode !== undefined ? this.updatedNeedCode : <any>null;
        data["previousNeedCode"] = this.previousNeedCode !== undefined ? this.previousNeedCode : <any>null;
        data["isSubNeed"] = this.isSubNeed !== undefined ? this.isSubNeed : <any>null;
        return data;
    }

    clone(): UpdateNeedNameRequest {
        const json = this.toJSON();
        let result = new UpdateNeedNameRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateNeedNameRequest {
    updatedNeedName?: string | null;
    updatedNeedCode?: string | null;
    previousNeedCode?: string | null;
    isSubNeed?: boolean;
}

export class DeleteNeedResponse implements IDeleteNeedResponse {
    result?: boolean;

    constructor(data?: IDeleteNeedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteNeedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteNeedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        return data;
    }

    clone(): DeleteNeedResponse {
        const json = this.toJSON();
        let result = new DeleteNeedResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteNeedResponse {
    result?: boolean;
}

export class GetOrganizationsResponse implements IGetOrganizationsResponse {
    organizations?: OrganizationViewModel[] | null;

    constructor(data?: IGetOrganizationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationViewModel.fromJS(item));
            }
            else {
                this.organizations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetOrganizationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetOrganizationsResponse {
        const json = this.toJSON();
        let result = new GetOrganizationsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetOrganizationsResponse {
    organizations?: OrganizationViewModel[] | null;
}

export class OrganizationViewModel implements IOrganizationViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    departmentType?: DepartmentType;
    isActive?: boolean | null;
    assessmentSettings?: AssessmentSettings | null;

    constructor(data?: IOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : <any>null;
            this.departmentType = _data["departmentType"] !== undefined ? _data["departmentType"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.assessmentSettings = _data["assessmentSettings"] ? AssessmentSettings.fromJS(_data["assessmentSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): OrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        data["departmentType"] = this.departmentType !== undefined ? this.departmentType : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["assessmentSettings"] = this.assessmentSettings ? this.assessmentSettings.toJSON() : <any>null;
        return data;
    }

    clone(): OrganizationViewModel {
        const json = this.toJSON();
        let result = new OrganizationViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    departmentType?: DepartmentType;
    isActive?: boolean | null;
    assessmentSettings?: AssessmentSettings | null;
}

export enum DepartmentType {
    School = "School",
    Ems = "Ems",
    Fire = "Fire",
    LawEnforcement = "LawEnforcement",
    Dispatch = "Dispatch",
    Hospital = "Hospital",
    MentalHealth = "MentalHealth",
    PublicHealth = "PublicHealth",
    HealthCareProvider = "HealthCareProvider",
}

export class GetLocationsResponse implements IGetLocationsResponse {
    locations?: AspenLocationViewModel[] | null;

    constructor(data?: IGetLocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(AspenLocationViewModel.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetLocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLocationsResponse {
        const json = this.toJSON();
        let result = new GetLocationsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetLocationsResponse {
    locations?: AspenLocationViewModel[] | null;
}

export class AspenLocationViewModel implements IAspenLocationViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    isActive?: boolean | null;

    constructor(data?: IAspenLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): AspenLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AspenLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }

    clone(): AspenLocationViewModel {
        const json = this.toJSON();
        let result = new AspenLocationViewModel();
        result.init(json);
        return result;
    }
}

export interface IAspenLocationViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    isActive?: boolean | null;
}

export class AddNewLocationResponse implements IAddNewLocationResponse {

    constructor(data?: IAddNewLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddNewLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): AddNewLocationResponse {
        const json = this.toJSON();
        let result = new AddNewLocationResponse();
        result.init(json);
        return result;
    }
}

export interface IAddNewLocationResponse {
}

export class AddNewLocationRequest implements IAddNewLocationRequest {
    branchId?: string | null;
    isNewRegion?: boolean;
    isNewDistrict?: boolean;
    regionName?: string | null;
    regionId?: string | null;
    district?: DistrictViewModel | null;
    organization?: OrganizationViewModel | null;

    constructor(data?: IAddNewLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.isNewRegion = _data["isNewRegion"] !== undefined ? _data["isNewRegion"] : <any>null;
            this.isNewDistrict = _data["isNewDistrict"] !== undefined ? _data["isNewDistrict"] : <any>null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.district = _data["district"] ? DistrictViewModel.fromJS(_data["district"]) : <any>null;
            this.organization = _data["organization"] ? OrganizationViewModel.fromJS(_data["organization"]) : <any>null;
        }
    }

    static fromJS(data: any): AddNewLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["isNewRegion"] = this.isNewRegion !== undefined ? this.isNewRegion : <any>null;
        data["isNewDistrict"] = this.isNewDistrict !== undefined ? this.isNewDistrict : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["district"] = this.district ? this.district.toJSON() : <any>null;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>null;
        return data;
    }

    clone(): AddNewLocationRequest {
        const json = this.toJSON();
        let result = new AddNewLocationRequest();
        result.init(json);
        return result;
    }
}

export interface IAddNewLocationRequest {
    branchId?: string | null;
    isNewRegion?: boolean;
    isNewDistrict?: boolean;
    regionName?: string | null;
    regionId?: string | null;
    district?: DistrictViewModel | null;
    organization?: OrganizationViewModel | null;
}

export class DisableOrganizationResponse implements IDisableOrganizationResponse {

    constructor(data?: IDisableOrganizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DisableOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableOrganizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DisableOrganizationResponse {
        const json = this.toJSON();
        let result = new DisableOrganizationResponse();
        result.init(json);
        return result;
    }
}

export interface IDisableOrganizationResponse {
}

export class GetOrganizationOptionsResponse implements IGetOrganizationOptionsResponse {
    options?: DistrictOptionViewModel[] | null;

    constructor(data?: IGetOrganizationOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(DistrictOptionViewModel.fromJS(item));
            }
            else {
                this.options = <any>null;
            }
        }
    }

    static fromJS(data: any): GetOrganizationOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetOrganizationOptionsResponse {
        const json = this.toJSON();
        let result = new GetOrganizationOptionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetOrganizationOptionsResponse {
    options?: DistrictOptionViewModel[] | null;
}

export class DistrictOptionViewModel implements IDistrictOptionViewModel {
    label?: string | null;
    options?: OrganizationOptionViewModel[] | null;

    constructor(data?: IDistrictOptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OrganizationOptionViewModel.fromJS(item));
            }
            else {
                this.options = <any>null;
            }
        }
    }

    static fromJS(data: any): DistrictOptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictOptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }

    clone(): DistrictOptionViewModel {
        const json = this.toJSON();
        let result = new DistrictOptionViewModel();
        result.init(json);
        return result;
    }
}

export interface IDistrictOptionViewModel {
    label?: string | null;
    options?: OrganizationOptionViewModel[] | null;
}

export class OrganizationOptionViewModel implements IOrganizationOptionViewModel {
    label?: string | null;
    value?: UserOrganizationViewModel | null;

    constructor(data?: IOrganizationOptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.value = _data["value"] ? UserOrganizationViewModel.fromJS(_data["value"]) : <any>null;
        }
    }

    static fromJS(data: any): OrganizationOptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationOptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        return data;
    }

    clone(): OrganizationOptionViewModel {
        const json = this.toJSON();
        let result = new OrganizationOptionViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationOptionViewModel {
    label?: string | null;
    value?: UserOrganizationViewModel | null;
}

export class UpdateEnabledAssessmentsResponse implements IUpdateEnabledAssessmentsResponse {

    constructor(data?: IUpdateEnabledAssessmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateEnabledAssessmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnabledAssessmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateEnabledAssessmentsResponse {
        const json = this.toJSON();
        let result = new UpdateEnabledAssessmentsResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateEnabledAssessmentsResponse {
}

export class UpdateEnabledAssessmentsRequest implements IUpdateEnabledAssessmentsRequest {
    assessmentSettings?: AssessmentOrganizationsEnabled | null;

    constructor(data?: IUpdateEnabledAssessmentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentSettings = _data["assessmentSettings"] ? AssessmentOrganizationsEnabled.fromJS(_data["assessmentSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateEnabledAssessmentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnabledAssessmentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentSettings"] = this.assessmentSettings ? this.assessmentSettings.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateEnabledAssessmentsRequest {
        const json = this.toJSON();
        let result = new UpdateEnabledAssessmentsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateEnabledAssessmentsRequest {
    assessmentSettings?: AssessmentOrganizationsEnabled | null;
}

export class AssessmentOrganizationsEnabled implements IAssessmentOrganizationsEnabled {
    schoolAssessments?: SchoolAssessments | null;
    frAssessments?: FrAssessments | null;
    hcwAssessments?: HcwAssessments | null;

    constructor(data?: IAssessmentOrganizationsEnabled) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolAssessments = _data["schoolAssessments"] ? SchoolAssessments.fromJS(_data["schoolAssessments"]) : <any>null;
            this.frAssessments = _data["frAssessments"] ? FrAssessments.fromJS(_data["frAssessments"]) : <any>null;
            this.hcwAssessments = _data["hcwAssessments"] ? HcwAssessments.fromJS(_data["hcwAssessments"]) : <any>null;
        }
    }

    static fromJS(data: any): AssessmentOrganizationsEnabled {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentOrganizationsEnabled();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolAssessments"] = this.schoolAssessments ? this.schoolAssessments.toJSON() : <any>null;
        data["frAssessments"] = this.frAssessments ? this.frAssessments.toJSON() : <any>null;
        data["hcwAssessments"] = this.hcwAssessments ? this.hcwAssessments.toJSON() : <any>null;
        return data;
    }

    clone(): AssessmentOrganizationsEnabled {
        const json = this.toJSON();
        let result = new AssessmentOrganizationsEnabled();
        result.init(json);
        return result;
    }
}

export interface IAssessmentOrganizationsEnabled {
    schoolAssessments?: SchoolAssessments | null;
    frAssessments?: FrAssessments | null;
    hcwAssessments?: HcwAssessments | null;
}

export class SchoolAssessments implements ISchoolAssessments {
    columbiaEnabled?: string[] | null;
    level2Enabled?: string[] | null;
    selfScreeningEnabled?: string[] | null;
    pscyEnabled?: string[] | null;

    constructor(data?: ISchoolAssessments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columbiaEnabled"])) {
                this.columbiaEnabled = [] as any;
                for (let item of _data["columbiaEnabled"])
                    this.columbiaEnabled!.push(item);
            }
            else {
                this.columbiaEnabled = <any>null;
            }
            if (Array.isArray(_data["level2Enabled"])) {
                this.level2Enabled = [] as any;
                for (let item of _data["level2Enabled"])
                    this.level2Enabled!.push(item);
            }
            else {
                this.level2Enabled = <any>null;
            }
            if (Array.isArray(_data["selfScreeningEnabled"])) {
                this.selfScreeningEnabled = [] as any;
                for (let item of _data["selfScreeningEnabled"])
                    this.selfScreeningEnabled!.push(item);
            }
            else {
                this.selfScreeningEnabled = <any>null;
            }
            if (Array.isArray(_data["pscyEnabled"])) {
                this.pscyEnabled = [] as any;
                for (let item of _data["pscyEnabled"])
                    this.pscyEnabled!.push(item);
            }
            else {
                this.pscyEnabled = <any>null;
            }
        }
    }

    static fromJS(data: any): SchoolAssessments {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolAssessments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columbiaEnabled)) {
            data["columbiaEnabled"] = [];
            for (let item of this.columbiaEnabled)
                data["columbiaEnabled"].push(item);
        }
        if (Array.isArray(this.level2Enabled)) {
            data["level2Enabled"] = [];
            for (let item of this.level2Enabled)
                data["level2Enabled"].push(item);
        }
        if (Array.isArray(this.selfScreeningEnabled)) {
            data["selfScreeningEnabled"] = [];
            for (let item of this.selfScreeningEnabled)
                data["selfScreeningEnabled"].push(item);
        }
        if (Array.isArray(this.pscyEnabled)) {
            data["pscyEnabled"] = [];
            for (let item of this.pscyEnabled)
                data["pscyEnabled"].push(item);
        }
        return data;
    }

    clone(): SchoolAssessments {
        const json = this.toJSON();
        let result = new SchoolAssessments();
        result.init(json);
        return result;
    }
}

export interface ISchoolAssessments {
    columbiaEnabled?: string[] | null;
    level2Enabled?: string[] | null;
    selfScreeningEnabled?: string[] | null;
    pscyEnabled?: string[] | null;
}

export class FrAssessments implements IFrAssessments {
    selfScreeningEnabled?: string[] | null;

    constructor(data?: IFrAssessments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selfScreeningEnabled"])) {
                this.selfScreeningEnabled = [] as any;
                for (let item of _data["selfScreeningEnabled"])
                    this.selfScreeningEnabled!.push(item);
            }
            else {
                this.selfScreeningEnabled = <any>null;
            }
        }
    }

    static fromJS(data: any): FrAssessments {
        data = typeof data === 'object' ? data : {};
        let result = new FrAssessments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selfScreeningEnabled)) {
            data["selfScreeningEnabled"] = [];
            for (let item of this.selfScreeningEnabled)
                data["selfScreeningEnabled"].push(item);
        }
        return data;
    }

    clone(): FrAssessments {
        const json = this.toJSON();
        let result = new FrAssessments();
        result.init(json);
        return result;
    }
}

export interface IFrAssessments {
    selfScreeningEnabled?: string[] | null;
}

export class HcwAssessments implements IHcwAssessments {
    selfScreeningEnabled?: string[] | null;

    constructor(data?: IHcwAssessments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selfScreeningEnabled"])) {
                this.selfScreeningEnabled = [] as any;
                for (let item of _data["selfScreeningEnabled"])
                    this.selfScreeningEnabled!.push(item);
            }
            else {
                this.selfScreeningEnabled = <any>null;
            }
        }
    }

    static fromJS(data: any): HcwAssessments {
        data = typeof data === 'object' ? data : {};
        let result = new HcwAssessments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selfScreeningEnabled)) {
            data["selfScreeningEnabled"] = [];
            for (let item of this.selfScreeningEnabled)
                data["selfScreeningEnabled"].push(item);
        }
        return data;
    }

    clone(): HcwAssessments {
        const json = this.toJSON();
        let result = new HcwAssessments();
        result.init(json);
        return result;
    }
}

export interface IHcwAssessments {
    selfScreeningEnabled?: string[] | null;
}

export class CreateParticipantResponse implements ICreateParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;

    constructor(data?: ICreateParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alreadyExists = _data["alreadyExists"] !== undefined ? _data["alreadyExists"] : <any>null;
        }
    }

    static fromJS(data: any): CreateParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alreadyExists"] = this.alreadyExists !== undefined ? this.alreadyExists : <any>null;
        return data;
    }

    clone(): CreateParticipantResponse {
        const json = this.toJSON();
        let result = new CreateParticipantResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;
}

export class CreateParticipantRequest implements ICreateParticipantRequest {
    counselorId?: string | null;
    participantData?: ParticipantDataViewModel | null;

    constructor(data?: ICreateParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselorId = _data["counselorId"] !== undefined ? _data["counselorId"] : <any>null;
            this.participantData = _data["participantData"] ? ParticipantDataViewModel.fromJS(_data["participantData"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselorId"] = this.counselorId !== undefined ? this.counselorId : <any>null;
        data["participantData"] = this.participantData ? this.participantData.toJSON() : <any>null;
        return data;
    }

    clone(): CreateParticipantRequest {
        const json = this.toJSON();
        let result = new CreateParticipantRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateParticipantRequest {
    counselorId?: string | null;
    participantData?: ParticipantDataViewModel | null;
}

export class RegisterParticipantResponse implements IRegisterParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;
    waiverUploaded?: boolean;

    constructor(data?: IRegisterParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alreadyExists = _data["alreadyExists"] !== undefined ? _data["alreadyExists"] : <any>null;
            this.waiverUploaded = _data["waiverUploaded"] !== undefined ? _data["waiverUploaded"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alreadyExists"] = this.alreadyExists !== undefined ? this.alreadyExists : <any>null;
        data["waiverUploaded"] = this.waiverUploaded !== undefined ? this.waiverUploaded : <any>null;
        return data;
    }

    clone(): RegisterParticipantResponse {
        const json = this.toJSON();
        let result = new RegisterParticipantResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;
    waiverUploaded?: boolean;
}

export class Exception implements IException {
    message?: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"] !== undefined ? _data["Message"] : <any>null;
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : <any>null;
            this.source = _data["Source"] !== undefined ? _data["Source"] : <any>null;
            this.stackTrace = _data["StackTrace"] !== undefined ? _data["StackTrace"] : <any>null;
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>null;
        data["Source"] = this.source !== undefined ? this.source : <any>null;
        data["StackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        return data;
    }

    clone(): Exception {
        const json = this.toJSON();
        let result = new Exception();
        result.init(json);
        return result;
    }
}

export interface IException {
    message?: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;
}

export abstract class ApiException extends Exception implements IApiException {
    statusCode?: HttpStatusCode;

    constructor(data?: IApiException) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : <any>null;
        }
    }

    static fromJS(data: any): ApiException {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiException' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiException {
        throw new Error("The abstract class 'ApiException' cannot be instantiated.");
    }
}

export interface IApiException extends IException {
    statusCode?: HttpStatusCode;
}

export class ParticipantExistsException extends ApiException implements IParticipantExistsException {

    constructor(data?: IParticipantExistsException) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ParticipantExistsException {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantExistsException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ParticipantExistsException {
        const json = this.toJSON();
        let result = new ParticipantExistsException();
        result.init(json);
        return result;
    }
}

export interface IParticipantExistsException extends IApiException {
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "Ambiguous",
    Ambiguous = "Ambiguous",
    MovedPermanently = "Moved",
    Moved = "Moved",
    Found = "Redirect",
    Redirect = "Redirect",
    SeeOther = "RedirectMethod",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class RegisterParticipantRequest implements IRegisterParticipantRequest {
    data?: ParticipantDto | null;

    constructor(data?: IRegisterParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ParticipantDto.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): RegisterParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }

    clone(): RegisterParticipantRequest {
        const json = this.toJSON();
        let result = new RegisterParticipantRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterParticipantRequest {
    data?: ParticipantDto | null;
}

export class UpdateParticipantProfileResponse implements IUpdateParticipantProfileResponse {
    participantId?: string | null;
    userId?: string | null;

    constructor(data?: IUpdateParticipantProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateParticipantProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }

    clone(): UpdateParticipantProfileResponse {
        const json = this.toJSON();
        let result = new UpdateParticipantProfileResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateParticipantProfileResponse {
    participantId?: string | null;
    userId?: string | null;
}

export class ParticipantDoesNotExistException extends ApiException implements IParticipantDoesNotExistException {

    constructor(data?: IParticipantDoesNotExistException) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ParticipantDoesNotExistException {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDoesNotExistException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ParticipantDoesNotExistException {
        const json = this.toJSON();
        let result = new ParticipantDoesNotExistException();
        result.init(json);
        return result;
    }
}

export interface IParticipantDoesNotExistException extends IApiException {
}

export class UpdateParticipantProfileRequest implements IUpdateParticipantProfileRequest {
    data?: ParticipantDto | null;

    constructor(data?: IUpdateParticipantProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ParticipantDto.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateParticipantProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateParticipantProfileRequest {
        const json = this.toJSON();
        let result = new UpdateParticipantProfileRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateParticipantProfileRequest {
    data?: ParticipantDto | null;
}

export class UpdateParticipantResponse implements IUpdateParticipantResponse {
    id?: string | null;

    constructor(data?: IUpdateParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateParticipantResponse {
        const json = this.toJSON();
        let result = new UpdateParticipantResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateParticipantResponse {
    id?: string | null;
}

export class UpdateParticipantRequest implements IUpdateParticipantRequest {
    counselorId?: string | null;
    participantData?: ParticipantDataViewModel | null;

    constructor(data?: IUpdateParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counselorId = _data["counselorId"] !== undefined ? _data["counselorId"] : <any>null;
            this.participantData = _data["participantData"] ? ParticipantDataViewModel.fromJS(_data["participantData"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counselorId"] = this.counselorId !== undefined ? this.counselorId : <any>null;
        data["participantData"] = this.participantData ? this.participantData.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateParticipantRequest {
        const json = this.toJSON();
        let result = new UpdateParticipantRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateParticipantRequest {
    counselorId?: string | null;
    participantData?: ParticipantDataViewModel | null;
}

export class GetParticipantsResponse implements IGetParticipantsResponse {
    participants?: ParticipantDataViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IGetParticipantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantDataViewModel.fromJS(item));
            }
            else {
                this.participants = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): GetParticipantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetParticipantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): GetParticipantsResponse {
        const json = this.toJSON();
        let result = new GetParticipantsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetParticipantsResponse {
    participants?: ParticipantDataViewModel[] | null;
    resultsLength?: number;
}

export class GetParticipantResponse implements IGetParticipantResponse {
    participant?: ParticipantDataViewModel | null;
    canAccess?: boolean;

    constructor(data?: IGetParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participant = _data["participant"] ? ParticipantDataViewModel.fromJS(_data["participant"]) : <any>null;
            this.canAccess = _data["canAccess"] !== undefined ? _data["canAccess"] : <any>null;
        }
    }

    static fromJS(data: any): GetParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        data["canAccess"] = this.canAccess !== undefined ? this.canAccess : <any>null;
        return data;
    }

    clone(): GetParticipantResponse {
        const json = this.toJSON();
        let result = new GetParticipantResponse();
        result.init(json);
        return result;
    }
}

export interface IGetParticipantResponse {
    participant?: ParticipantDataViewModel | null;
    canAccess?: boolean;
}

export class QuickSearchParticipantsResponse implements IQuickSearchParticipantsResponse {
    participants?: ParticipantDataViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IQuickSearchParticipantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ParticipantDataViewModel.fromJS(item));
            }
            else {
                this.participants = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): QuickSearchParticipantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuickSearchParticipantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): QuickSearchParticipantsResponse {
        const json = this.toJSON();
        let result = new QuickSearchParticipantsResponse();
        result.init(json);
        return result;
    }
}

export interface IQuickSearchParticipantsResponse {
    participants?: ParticipantDataViewModel[] | null;
    resultsLength?: number;
}

export class UploadDocumentsResponse implements IUploadDocumentsResponse {

    constructor(data?: IUploadDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UploadDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UploadDocumentsResponse {
        const json = this.toJSON();
        let result = new UploadDocumentsResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadDocumentsResponse {
}

export class UpdateStudentProfileResponse implements IUpdateStudentProfileResponse {

    constructor(data?: IUpdateStudentProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateStudentProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateStudentProfileResponse {
        const json = this.toJSON();
        let result = new UpdateStudentProfileResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentProfileResponse {
}

export class UpdateStudentProfileRequest implements IUpdateStudentProfileRequest {
    student?: ParticipantDto | null;

    constructor(data?: IUpdateStudentProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.student = _data["student"] ? ParticipantDto.fromJS(_data["student"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateStudentProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["student"] = this.student ? this.student.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateStudentProfileRequest {
        const json = this.toJSON();
        let result = new UpdateStudentProfileRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentProfileRequest {
    student?: ParticipantDto | null;
}

export class DownloadDocumentResponse implements IDownloadDocumentResponse {
    link?: string | null;

    constructor(data?: IDownloadDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
        }
    }

    static fromJS(data: any): DownloadDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link !== undefined ? this.link : <any>null;
        return data;
    }

    clone(): DownloadDocumentResponse {
        const json = this.toJSON();
        let result = new DownloadDocumentResponse();
        result.init(json);
        return result;
    }
}

export interface IDownloadDocumentResponse {
    link?: string | null;
}

export class GetParticipantByUserIdResponse implements IGetParticipantByUserIdResponse {
    participant?: ParticipantDataViewModel | null;
    canAccess?: boolean;

    constructor(data?: IGetParticipantByUserIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participant = _data["participant"] ? ParticipantDataViewModel.fromJS(_data["participant"]) : <any>null;
            this.canAccess = _data["canAccess"] !== undefined ? _data["canAccess"] : <any>null;
        }
    }

    static fromJS(data: any): GetParticipantByUserIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetParticipantByUserIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        data["canAccess"] = this.canAccess !== undefined ? this.canAccess : <any>null;
        return data;
    }

    clone(): GetParticipantByUserIdResponse {
        const json = this.toJSON();
        let result = new GetParticipantByUserIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetParticipantByUserIdResponse {
    participant?: ParticipantDataViewModel | null;
    canAccess?: boolean;
}

export class UpdateParticipantAttributeResponse implements IUpdateParticipantAttributeResponse {
    userId?: string | null;

    constructor(data?: IUpdateParticipantAttributeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateParticipantAttributeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantAttributeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }

    clone(): UpdateParticipantAttributeResponse {
        const json = this.toJSON();
        let result = new UpdateParticipantAttributeResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateParticipantAttributeResponse {
    userId?: string | null;
}

export class UpdateParticipantAttributeRequest implements IUpdateParticipantAttributeRequest {
    userId?: string | null;
    attribute?: string | null;
    booleanValue?: boolean;

    constructor(data?: IUpdateParticipantAttributeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.attribute = _data["attribute"] !== undefined ? _data["attribute"] : <any>null;
            this.booleanValue = _data["booleanValue"] !== undefined ? _data["booleanValue"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateParticipantAttributeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantAttributeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["attribute"] = this.attribute !== undefined ? this.attribute : <any>null;
        data["booleanValue"] = this.booleanValue !== undefined ? this.booleanValue : <any>null;
        return data;
    }

    clone(): UpdateParticipantAttributeRequest {
        const json = this.toJSON();
        let result = new UpdateParticipantAttributeRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateParticipantAttributeRequest {
    userId?: string | null;
    attribute?: string | null;
    booleanValue?: boolean;
}

export class OptOutRequest implements IOptOutRequest {
    participantId?: string | null;

    constructor(data?: IOptOutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
        }
    }

    static fromJS(data: any): OptOutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OptOutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        return data;
    }

    clone(): OptOutRequest {
        const json = this.toJSON();
        let result = new OptOutRequest();
        result.init(json);
        return result;
    }
}

export interface IOptOutRequest {
    participantId?: string | null;
}

export class GetHotlineAndCounselorUsersForParticipantResponse implements IGetHotlineAndCounselorUsersForParticipantResponse {
    assigneeOptions?: HotlineCounselorSelectionDto[] | null;

    constructor(data?: IGetHotlineAndCounselorUsersForParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assigneeOptions"])) {
                this.assigneeOptions = [] as any;
                for (let item of _data["assigneeOptions"])
                    this.assigneeOptions!.push(HotlineCounselorSelectionDto.fromJS(item));
            }
            else {
                this.assigneeOptions = <any>null;
            }
        }
    }

    static fromJS(data: any): GetHotlineAndCounselorUsersForParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHotlineAndCounselorUsersForParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assigneeOptions)) {
            data["assigneeOptions"] = [];
            for (let item of this.assigneeOptions)
                data["assigneeOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetHotlineAndCounselorUsersForParticipantResponse {
        const json = this.toJSON();
        let result = new GetHotlineAndCounselorUsersForParticipantResponse();
        result.init(json);
        return result;
    }
}

export interface IGetHotlineAndCounselorUsersForParticipantResponse {
    assigneeOptions?: HotlineCounselorSelectionDto[] | null;
}

export class HotlineCounselorSelectionDto implements IHotlineCounselorSelectionDto {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    type?: string | null;

    constructor(data?: IHotlineCounselorSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): HotlineCounselorSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotlineCounselorSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): HotlineCounselorSelectionDto {
        const json = this.toJSON();
        let result = new HotlineCounselorSelectionDto();
        result.init(json);
        return result;
    }
}

export interface IHotlineCounselorSelectionDto {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    type?: string | null;
}

export class CounselorRegisterSchoolParticipantResponse implements ICounselorRegisterSchoolParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;

    constructor(data?: ICounselorRegisterSchoolParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alreadyExists = _data["alreadyExists"] !== undefined ? _data["alreadyExists"] : <any>null;
        }
    }

    static fromJS(data: any): CounselorRegisterSchoolParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CounselorRegisterSchoolParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alreadyExists"] = this.alreadyExists !== undefined ? this.alreadyExists : <any>null;
        return data;
    }

    clone(): CounselorRegisterSchoolParticipantResponse {
        const json = this.toJSON();
        let result = new CounselorRegisterSchoolParticipantResponse();
        result.init(json);
        return result;
    }
}

export interface ICounselorRegisterSchoolParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;
}

export class CounselorRegisterSchoolParticipantRequest implements ICounselorRegisterSchoolParticipantRequest {
    participant?: ParticipantDto | null;

    constructor(data?: ICounselorRegisterSchoolParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participant = _data["participant"] ? ParticipantDto.fromJS(_data["participant"]) : <any>null;
        }
    }

    static fromJS(data: any): CounselorRegisterSchoolParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CounselorRegisterSchoolParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        return data;
    }

    clone(): CounselorRegisterSchoolParticipantRequest {
        const json = this.toJSON();
        let result = new CounselorRegisterSchoolParticipantRequest();
        result.init(json);
        return result;
    }
}

export interface ICounselorRegisterSchoolParticipantRequest {
    participant?: ParticipantDto | null;
}

export class SendWaiverNotificationResponse implements ISendWaiverNotificationResponse {
    contactEmail?: string | null;
    emailSent?: boolean;

    constructor(data?: ISendWaiverNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : <any>null;
            this.emailSent = _data["emailSent"] !== undefined ? _data["emailSent"] : <any>null;
        }
    }

    static fromJS(data: any): SendWaiverNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendWaiverNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : <any>null;
        data["emailSent"] = this.emailSent !== undefined ? this.emailSent : <any>null;
        return data;
    }

    clone(): SendWaiverNotificationResponse {
        const json = this.toJSON();
        let result = new SendWaiverNotificationResponse();
        result.init(json);
        return result;
    }
}

export interface ISendWaiverNotificationResponse {
    contactEmail?: string | null;
    emailSent?: boolean;
}

export class SendRegistrationEmailResponse implements ISendRegistrationEmailResponse {
    contactEmail?: string | null;
    emailSent?: boolean;

    constructor(data?: ISendRegistrationEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : <any>null;
            this.emailSent = _data["emailSent"] !== undefined ? _data["emailSent"] : <any>null;
        }
    }

    static fromJS(data: any): SendRegistrationEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendRegistrationEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : <any>null;
        data["emailSent"] = this.emailSent !== undefined ? this.emailSent : <any>null;
        return data;
    }

    clone(): SendRegistrationEmailResponse {
        const json = this.toJSON();
        let result = new SendRegistrationEmailResponse();
        result.init(json);
        return result;
    }
}

export interface ISendRegistrationEmailResponse {
    contactEmail?: string | null;
    emailSent?: boolean;
}

export class PartnerViewModel implements IPartnerViewModel {
    branchId?: string | null;
    id?: string | null;
    companyName?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    website?: string | null;
    locations?: LocationViewModel[] | null;
    deletedOn?: Date | null;

    constructor(data?: IPartnerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationViewModel.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PartnerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>null;
        return data;
    }

    clone(): PartnerViewModel {
        const json = this.toJSON();
        let result = new PartnerViewModel();
        result.init(json);
        return result;
    }
}

export interface IPartnerViewModel {
    branchId?: string | null;
    id?: string | null;
    companyName?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    website?: string | null;
    locations?: LocationViewModel[] | null;
    deletedOn?: Date | null;
}

export class LocationViewModel implements ILocationViewModel {
    organizationId?: string | null;
    organizationName?: string | null;
    organizationCoordinates?: Coordinates | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    repName?: string | null;
    repPhone?: string | null;
    repEmail?: string | null;
    referralProcess?: string | null;
    hours?: string | null;
    services?: string | null;
    insuranceCompanies?: InsuranceViewModel[] | null;
    notes?: string | null;

    constructor(data?: ILocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.organizationCoordinates = _data["organizationCoordinates"] ? Coordinates.fromJS(_data["organizationCoordinates"]) : <any>null;
            this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : <any>null;
            this.repName = _data["repName"] !== undefined ? _data["repName"] : <any>null;
            this.repPhone = _data["repPhone"] !== undefined ? _data["repPhone"] : <any>null;
            this.repEmail = _data["repEmail"] !== undefined ? _data["repEmail"] : <any>null;
            this.referralProcess = _data["referralProcess"] !== undefined ? _data["referralProcess"] : <any>null;
            this.hours = _data["hours"] !== undefined ? _data["hours"] : <any>null;
            this.services = _data["services"] !== undefined ? _data["services"] : <any>null;
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(InsuranceViewModel.fromJS(item));
            }
            else {
                this.insuranceCompanies = <any>null;
            }
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): LocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["organizationCoordinates"] = this.organizationCoordinates ? this.organizationCoordinates.toJSON() : <any>null;
        data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        data["repName"] = this.repName !== undefined ? this.repName : <any>null;
        data["repPhone"] = this.repPhone !== undefined ? this.repPhone : <any>null;
        data["repEmail"] = this.repEmail !== undefined ? this.repEmail : <any>null;
        data["referralProcess"] = this.referralProcess !== undefined ? this.referralProcess : <any>null;
        data["hours"] = this.hours !== undefined ? this.hours : <any>null;
        data["services"] = this.services !== undefined ? this.services : <any>null;
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }

    clone(): LocationViewModel {
        const json = this.toJSON();
        let result = new LocationViewModel();
        result.init(json);
        return result;
    }
}

export interface ILocationViewModel {
    organizationId?: string | null;
    organizationName?: string | null;
    organizationCoordinates?: Coordinates | null;
    districtId?: string | null;
    districtName?: string | null;
    regionId?: string | null;
    regionName?: string | null;
    repName?: string | null;
    repPhone?: string | null;
    repEmail?: string | null;
    referralProcess?: string | null;
    hours?: string | null;
    services?: string | null;
    insuranceCompanies?: InsuranceViewModel[] | null;
    notes?: string | null;
}

export class GetPartnersResponse implements IGetPartnersResponse {
    partners?: PartnerViewModel[] | null;

    constructor(data?: IGetPartnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerViewModel.fromJS(item));
            }
            else {
                this.partners = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPartnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPartnersResponse {
        const json = this.toJSON();
        let result = new GetPartnersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPartnersResponse {
    partners?: PartnerViewModel[] | null;
}

export class GetPartnersRequest implements IGetPartnersRequest {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    organizationIds?: string[] | null;
    districtIds?: string[] | null;

    constructor(data?: IGetPartnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            else {
                this.organizationIds = <any>null;
            }
            if (Array.isArray(_data["districtIds"])) {
                this.districtIds = [] as any;
                for (let item of _data["districtIds"])
                    this.districtIds!.push(item);
            }
            else {
                this.districtIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPartnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        if (Array.isArray(this.districtIds)) {
            data["districtIds"] = [];
            for (let item of this.districtIds)
                data["districtIds"].push(item);
        }
        return data;
    }

    clone(): GetPartnersRequest {
        const json = this.toJSON();
        let result = new GetPartnersRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPartnersRequest {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
    organizationIds?: string[] | null;
    districtIds?: string[] | null;
}

export class CreatePartnerResponse implements ICreatePartnerResponse {
    id?: string | null;

    constructor(data?: ICreatePartnerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreatePartnerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): CreatePartnerResponse {
        const json = this.toJSON();
        let result = new CreatePartnerResponse();
        result.init(json);
        return result;
    }
}

export interface ICreatePartnerResponse {
    id?: string | null;
}

export class CreatePartnerRequest implements ICreatePartnerRequest {
    partner?: PartnerViewModel | null;

    constructor(data?: ICreatePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"] ? PartnerViewModel.fromJS(_data["partner"]) : <any>null;
        }
    }

    static fromJS(data: any): CreatePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner ? this.partner.toJSON() : <any>null;
        return data;
    }

    clone(): CreatePartnerRequest {
        const json = this.toJSON();
        let result = new CreatePartnerRequest();
        result.init(json);
        return result;
    }
}

export interface ICreatePartnerRequest {
    partner?: PartnerViewModel | null;
}

export class UpdatePartnerResponse implements IUpdatePartnerResponse {
    id?: string | null;

    constructor(data?: IUpdatePartnerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdatePartnerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdatePartnerResponse {
        const json = this.toJSON();
        let result = new UpdatePartnerResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdatePartnerResponse {
    id?: string | null;
}

export class UpdatePartnerRequest implements IUpdatePartnerRequest {
    partner?: PartnerViewModel | null;

    constructor(data?: IUpdatePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"] ? PartnerViewModel.fromJS(_data["partner"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdatePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner ? this.partner.toJSON() : <any>null;
        return data;
    }

    clone(): UpdatePartnerRequest {
        const json = this.toJSON();
        let result = new UpdatePartnerRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePartnerRequest {
    partner?: PartnerViewModel | null;
}

export class AddLocationsResponse implements IAddLocationsResponse {
    id?: string | null;

    constructor(data?: IAddLocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddLocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddLocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): AddLocationsResponse {
        const json = this.toJSON();
        let result = new AddLocationsResponse();
        result.init(json);
        return result;
    }
}

export interface IAddLocationsResponse {
    id?: string | null;
}

export class AddLocationsRequest implements IAddLocationsRequest {
    id?: string | null;
    locations?: LocationViewModel[] | null;

    constructor(data?: IAddLocationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationViewModel.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
        }
    }

    static fromJS(data: any): AddLocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddLocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }

    clone(): AddLocationsRequest {
        const json = this.toJSON();
        let result = new AddLocationsRequest();
        result.init(json);
        return result;
    }
}

export interface IAddLocationsRequest {
    id?: string | null;
    locations?: LocationViewModel[] | null;
}

export class DeletePartnerResponse implements IDeletePartnerResponse {

    constructor(data?: IDeletePartnerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeletePartnerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePartnerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DeletePartnerResponse {
        const json = this.toJSON();
        let result = new DeletePartnerResponse();
        result.init(json);
        return result;
    }
}

export interface IDeletePartnerResponse {
}

export class DeletePartnerRequest implements IDeletePartnerRequest {
    id?: string | null;
    softDelete?: boolean;

    constructor(data?: IDeletePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.softDelete = _data["softDelete"] !== undefined ? _data["softDelete"] : <any>null;
        }
    }

    static fromJS(data: any): DeletePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["softDelete"] = this.softDelete !== undefined ? this.softDelete : <any>null;
        return data;
    }

    clone(): DeletePartnerRequest {
        const json = this.toJSON();
        let result = new DeletePartnerRequest();
        result.init(json);
        return result;
    }
}

export interface IDeletePartnerRequest {
    id?: string | null;
    softDelete?: boolean;
}

export class QuickSearchPartnersResponse implements IQuickSearchPartnersResponse {
    partners?: PartnerViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IQuickSearchPartnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerViewModel.fromJS(item));
            }
            else {
                this.partners = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): QuickSearchPartnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuickSearchPartnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): QuickSearchPartnersResponse {
        const json = this.toJSON();
        let result = new QuickSearchPartnersResponse();
        result.init(json);
        return result;
    }
}

export interface IQuickSearchPartnersResponse {
    partners?: PartnerViewModel[] | null;
    resultsLength?: number;
}

export class ProviderViewModel implements IProviderViewModel {
    id?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    insuranceCompanies?: InsuranceViewModel[] | null;
    areasOfNeed?: NeedViewModel[] | null;
    notes?: string | null;
    serviceDescription?: string | null;
    website?: string | null;
    locationType?: ProviderLocationType;
    deletedOn?: Date | null;
    visitWaitTime?: VisitWaitTime;

    constructor(data?: IProviderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.mailingAddress = _data["mailingAddress"] ? MailingAddress.fromJS(_data["mailingAddress"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(InsuranceViewModel.fromJS(item));
            }
            else {
                this.insuranceCompanies = <any>null;
            }
            if (Array.isArray(_data["areasOfNeed"])) {
                this.areasOfNeed = [] as any;
                for (let item of _data["areasOfNeed"])
                    this.areasOfNeed!.push(NeedViewModel.fromJS(item));
            }
            else {
                this.areasOfNeed = <any>null;
            }
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.serviceDescription = _data["serviceDescription"] !== undefined ? _data["serviceDescription"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.locationType = _data["locationType"] !== undefined ? _data["locationType"] : <any>null;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>null;
            this.visitWaitTime = _data["visitWaitTime"] !== undefined ? _data["visitWaitTime"] : <any>null;
        }
    }

    static fromJS(data: any): ProviderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.areasOfNeed)) {
            data["areasOfNeed"] = [];
            for (let item of this.areasOfNeed)
                data["areasOfNeed"].push(item.toJSON());
        }
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["serviceDescription"] = this.serviceDescription !== undefined ? this.serviceDescription : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["locationType"] = this.locationType !== undefined ? this.locationType : <any>null;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>null;
        data["visitWaitTime"] = this.visitWaitTime !== undefined ? this.visitWaitTime : <any>null;
        return data;
    }

    clone(): ProviderViewModel {
        const json = this.toJSON();
        let result = new ProviderViewModel();
        result.init(json);
        return result;
    }
}

export interface IProviderViewModel {
    id?: string | null;
    name?: string | null;
    mailingAddress?: MailingAddress | null;
    phone?: string | null;
    emailAddress?: string | null;
    insuranceCompanies?: InsuranceViewModel[] | null;
    areasOfNeed?: NeedViewModel[] | null;
    notes?: string | null;
    serviceDescription?: string | null;
    website?: string | null;
    locationType?: ProviderLocationType;
    deletedOn?: Date | null;
    visitWaitTime?: VisitWaitTime;
}

export enum ProviderLocationType {
    Physical = "Physical",
    Online = "Online",
}

export enum VisitWaitTime {
    Immediately = "Immediately",
    OneWeek = "OneWeek",
    TwoToFourWeeks = "TwoToFourWeeks",
    OneMonth = "OneMonth",
    TwoToThreeMonths = "TwoToThreeMonths",
    FourToSixMonths = "FourToSixMonths",
    SixPlusMonths = "SixPlusMonths",
    NotSpecified = "NotSpecified",
}

export class GetProvidersResponse implements IGetProvidersResponse {
    providers?: ProviderViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IGetProvidersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["providers"])) {
                this.providers = [] as any;
                for (let item of _data["providers"])
                    this.providers!.push(ProviderViewModel.fromJS(item));
            }
            else {
                this.providers = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): GetProvidersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProvidersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providers)) {
            data["providers"] = [];
            for (let item of this.providers)
                data["providers"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): GetProvidersResponse {
        const json = this.toJSON();
        let result = new GetProvidersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProvidersResponse {
    providers?: ProviderViewModel[] | null;
    resultsLength?: number;
}

export class GetProvidersRequest implements IGetProvidersRequest {
    id?: string | null;
    name?: string | null;
    areasOfNeed?: string[] | null;

    constructor(data?: IGetProvidersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["areasOfNeed"])) {
                this.areasOfNeed = [] as any;
                for (let item of _data["areasOfNeed"])
                    this.areasOfNeed!.push(item);
            }
            else {
                this.areasOfNeed = <any>null;
            }
        }
    }

    static fromJS(data: any): GetProvidersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProvidersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.areasOfNeed)) {
            data["areasOfNeed"] = [];
            for (let item of this.areasOfNeed)
                data["areasOfNeed"].push(item);
        }
        return data;
    }

    clone(): GetProvidersRequest {
        const json = this.toJSON();
        let result = new GetProvidersRequest();
        result.init(json);
        return result;
    }
}

export interface IGetProvidersRequest {
    id?: string | null;
    name?: string | null;
    areasOfNeed?: string[] | null;
}

export class SearchProvidersResponse implements ISearchProvidersResponse {
    searchProvidersResults?: SearchProvidersResultViewModel[] | null;

    constructor(data?: ISearchProvidersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchProvidersResults"])) {
                this.searchProvidersResults = [] as any;
                for (let item of _data["searchProvidersResults"])
                    this.searchProvidersResults!.push(SearchProvidersResultViewModel.fromJS(item));
            }
            else {
                this.searchProvidersResults = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchProvidersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProvidersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchProvidersResults)) {
            data["searchProvidersResults"] = [];
            for (let item of this.searchProvidersResults)
                data["searchProvidersResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): SearchProvidersResponse {
        const json = this.toJSON();
        let result = new SearchProvidersResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchProvidersResponse {
    searchProvidersResults?: SearchProvidersResultViewModel[] | null;
}

export class SearchProvidersResultViewModel implements ISearchProvidersResultViewModel {
    distance?: number;
    coordinates?: Coordinates | null;
    provider?: ProviderViewModel | null;

    constructor(data?: ISearchProvidersResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distance = _data["distance"] !== undefined ? _data["distance"] : <any>null;
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : <any>null;
            this.provider = _data["provider"] ? ProviderViewModel.fromJS(_data["provider"]) : <any>null;
        }
    }

    static fromJS(data: any): SearchProvidersResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProvidersResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distance"] = this.distance !== undefined ? this.distance : <any>null;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>null;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>null;
        return data;
    }

    clone(): SearchProvidersResultViewModel {
        const json = this.toJSON();
        let result = new SearchProvidersResultViewModel();
        result.init(json);
        return result;
    }
}

export interface ISearchProvidersResultViewModel {
    distance?: number;
    coordinates?: Coordinates | null;
    provider?: ProviderViewModel | null;
}

export class SearchProvidersRequest implements ISearchProvidersRequest {
    name?: string | null;
    participantId?: string | null;
    areasOfNeed?: string[] | null;
    maxDistanceInMiles?: number;
    address?: MailingAddress | null;
    limit?: number;

    constructor(data?: ISearchProvidersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
            if (Array.isArray(_data["areasOfNeed"])) {
                this.areasOfNeed = [] as any;
                for (let item of _data["areasOfNeed"])
                    this.areasOfNeed!.push(item);
            }
            else {
                this.areasOfNeed = <any>null;
            }
            this.maxDistanceInMiles = _data["maxDistanceInMiles"] !== undefined ? _data["maxDistanceInMiles"] : <any>null;
            this.address = _data["address"] ? MailingAddress.fromJS(_data["address"]) : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
        }
    }

    static fromJS(data: any): SearchProvidersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProvidersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        if (Array.isArray(this.areasOfNeed)) {
            data["areasOfNeed"] = [];
            for (let item of this.areasOfNeed)
                data["areasOfNeed"].push(item);
        }
        data["maxDistanceInMiles"] = this.maxDistanceInMiles !== undefined ? this.maxDistanceInMiles : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        return data;
    }

    clone(): SearchProvidersRequest {
        const json = this.toJSON();
        let result = new SearchProvidersRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchProvidersRequest {
    name?: string | null;
    participantId?: string | null;
    areasOfNeed?: string[] | null;
    maxDistanceInMiles?: number;
    address?: MailingAddress | null;
    limit?: number;
}

export class CreateProviderResponse implements ICreateProviderResponse {
    id?: string | null;

    constructor(data?: ICreateProviderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProviderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProviderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): CreateProviderResponse {
        const json = this.toJSON();
        let result = new CreateProviderResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateProviderResponse {
    id?: string | null;
}

export class CreateProviderRequest implements ICreateProviderRequest {
    provider?: ProviderViewModel | null;

    constructor(data?: ICreateProviderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"] ? ProviderViewModel.fromJS(_data["provider"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateProviderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProviderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider ? this.provider.toJSON() : <any>null;
        return data;
    }

    clone(): CreateProviderRequest {
        const json = this.toJSON();
        let result = new CreateProviderRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateProviderRequest {
    provider?: ProviderViewModel | null;
}

export class UpdateProviderResponse implements IUpdateProviderResponse {
    id?: string | null;

    constructor(data?: IUpdateProviderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProviderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProviderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateProviderResponse {
        const json = this.toJSON();
        let result = new UpdateProviderResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateProviderResponse {
    id?: string | null;
}

export class UpdateProviderRequest implements IUpdateProviderRequest {
    provider?: ProviderViewModel | null;

    constructor(data?: IUpdateProviderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"] ? ProviderViewModel.fromJS(_data["provider"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateProviderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProviderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider ? this.provider.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateProviderRequest {
        const json = this.toJSON();
        let result = new UpdateProviderRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateProviderRequest {
    provider?: ProviderViewModel | null;
}

export class DeleteProviderResponse implements IDeleteProviderResponse {

    constructor(data?: IDeleteProviderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteProviderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProviderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DeleteProviderResponse {
        const json = this.toJSON();
        let result = new DeleteProviderResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteProviderResponse {
}

export class DeleteProviderRequest implements IDeleteProviderRequest {
    id?: string | null;
    softDelete?: boolean;

    constructor(data?: IDeleteProviderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.softDelete = _data["softDelete"] !== undefined ? _data["softDelete"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteProviderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProviderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["softDelete"] = this.softDelete !== undefined ? this.softDelete : <any>null;
        return data;
    }

    clone(): DeleteProviderRequest {
        const json = this.toJSON();
        let result = new DeleteProviderRequest();
        result.init(json);
        return result;
    }
}

export interface IDeleteProviderRequest {
    id?: string | null;
    softDelete?: boolean;
}

export class QuickSearchProvidersPartnersResponse implements IQuickSearchProvidersPartnersResponse {
    providersAndPartners?: ProviderPartnerViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IQuickSearchProvidersPartnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["providersAndPartners"])) {
                this.providersAndPartners = [] as any;
                for (let item of _data["providersAndPartners"])
                    this.providersAndPartners!.push(ProviderPartnerViewModel.fromJS(item));
            }
            else {
                this.providersAndPartners = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): QuickSearchProvidersPartnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuickSearchProvidersPartnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providersAndPartners)) {
            data["providersAndPartners"] = [];
            for (let item of this.providersAndPartners)
                data["providersAndPartners"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): QuickSearchProvidersPartnersResponse {
        const json = this.toJSON();
        let result = new QuickSearchProvidersPartnersResponse();
        result.init(json);
        return result;
    }
}

export interface IQuickSearchProvidersPartnersResponse {
    providersAndPartners?: ProviderPartnerViewModel[] | null;
    resultsLength?: number;
}

export class ProviderPartnerViewModel implements IProviderPartnerViewModel {
    id?: string | null;
    name?: string | null;
    areasOfNeed?: NeedViewModel[] | null;
    phone?: string | null;
    representatives?: string[] | null;
    isProvider?: boolean;

    constructor(data?: IProviderPartnerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["areasOfNeed"])) {
                this.areasOfNeed = [] as any;
                for (let item of _data["areasOfNeed"])
                    this.areasOfNeed!.push(NeedViewModel.fromJS(item));
            }
            else {
                this.areasOfNeed = <any>null;
            }
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            if (Array.isArray(_data["representatives"])) {
                this.representatives = [] as any;
                for (let item of _data["representatives"])
                    this.representatives!.push(item);
            }
            else {
                this.representatives = <any>null;
            }
            this.isProvider = _data["isProvider"] !== undefined ? _data["isProvider"] : <any>null;
        }
    }

    static fromJS(data: any): ProviderPartnerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPartnerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.areasOfNeed)) {
            data["areasOfNeed"] = [];
            for (let item of this.areasOfNeed)
                data["areasOfNeed"].push(item.toJSON());
        }
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        if (Array.isArray(this.representatives)) {
            data["representatives"] = [];
            for (let item of this.representatives)
                data["representatives"].push(item);
        }
        data["isProvider"] = this.isProvider !== undefined ? this.isProvider : <any>null;
        return data;
    }

    clone(): ProviderPartnerViewModel {
        const json = this.toJSON();
        let result = new ProviderPartnerViewModel();
        result.init(json);
        return result;
    }
}

export interface IProviderPartnerViewModel {
    id?: string | null;
    name?: string | null;
    areasOfNeed?: NeedViewModel[] | null;
    phone?: string | null;
    representatives?: string[] | null;
    isProvider?: boolean;
}

export class GetProvidersAndPartnersResponse implements IGetProvidersAndPartnersResponse {
    providersAndPartners?: ProviderPartnerViewModel[] | null;
    resultsLength?: number;

    constructor(data?: IGetProvidersAndPartnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["providersAndPartners"])) {
                this.providersAndPartners = [] as any;
                for (let item of _data["providersAndPartners"])
                    this.providersAndPartners!.push(ProviderPartnerViewModel.fromJS(item));
            }
            else {
                this.providersAndPartners = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): GetProvidersAndPartnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProvidersAndPartnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providersAndPartners)) {
            data["providersAndPartners"] = [];
            for (let item of this.providersAndPartners)
                data["providersAndPartners"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): GetProvidersAndPartnersResponse {
        const json = this.toJSON();
        let result = new GetProvidersAndPartnersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProvidersAndPartnersResponse {
    providersAndPartners?: ProviderPartnerViewModel[] | null;
    resultsLength?: number;
}

export class GetBranchRegionsResponse implements IGetBranchRegionsResponse {
    regions?: RegionViewModel[] | null;

    constructor(data?: IGetBranchRegionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(RegionViewModel.fromJS(item));
            }
            else {
                this.regions = <any>null;
            }
        }
    }

    static fromJS(data: any): GetBranchRegionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchRegionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetBranchRegionsResponse {
        const json = this.toJSON();
        let result = new GetBranchRegionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBranchRegionsResponse {
    regions?: RegionViewModel[] | null;
}

export class RegionViewModel implements IRegionViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;

    constructor(data?: IRegionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): RegionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): RegionViewModel {
        const json = this.toJSON();
        let result = new RegionViewModel();
        result.init(json);
        return result;
    }
}

export interface IRegionViewModel {
    id?: string | null;
    branchId?: string | null;
    name?: string | null;
}

export class SearchResourceDirectoryEntriesResponse implements ISearchResourceDirectoryEntriesResponse {
    resourceDirectoryEntries?: ResourceDirectoryEntry[] | null;

    constructor(data?: ISearchResourceDirectoryEntriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resourceDirectoryEntries"])) {
                this.resourceDirectoryEntries = [] as any;
                for (let item of _data["resourceDirectoryEntries"])
                    this.resourceDirectoryEntries!.push(ResourceDirectoryEntry.fromJS(item));
            }
            else {
                this.resourceDirectoryEntries = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchResourceDirectoryEntriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResourceDirectoryEntriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resourceDirectoryEntries)) {
            data["resourceDirectoryEntries"] = [];
            for (let item of this.resourceDirectoryEntries)
                data["resourceDirectoryEntries"].push(item.toJSON());
        }
        return data;
    }

    clone(): SearchResourceDirectoryEntriesResponse {
        const json = this.toJSON();
        let result = new SearchResourceDirectoryEntriesResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchResourceDirectoryEntriesResponse {
    resourceDirectoryEntries?: ResourceDirectoryEntry[] | null;
}

export class ResourceDirectoryEntry implements IResourceDirectoryEntry {
    id?: string | null;
    type?: ResourceDirectoryEntryType;
    name?: string | null;
    address?: MailingAddress | null;
    phone?: string | null;
    website?: string | null;
    emailAddress?: string | null;
    notes?: string | null;
    serviceDescription?: string | null;
    areasOfNeed?: NeedViewModel[] | null;
    insuranceCompanies?: InsuranceViewModel[] | null;
    locations?: LocationViewModel[] | null;
    distance?: number | null;
    coordinates?: Coordinates | null;
    visitWaitTime?: VisitWaitTime | null;

    constructor(data?: IResourceDirectoryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] ? MailingAddress.fromJS(_data["address"]) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.serviceDescription = _data["serviceDescription"] !== undefined ? _data["serviceDescription"] : <any>null;
            if (Array.isArray(_data["areasOfNeed"])) {
                this.areasOfNeed = [] as any;
                for (let item of _data["areasOfNeed"])
                    this.areasOfNeed!.push(NeedViewModel.fromJS(item));
            }
            else {
                this.areasOfNeed = <any>null;
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies!.push(InsuranceViewModel.fromJS(item));
            }
            else {
                this.insuranceCompanies = <any>null;
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationViewModel.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
            this.distance = _data["distance"] !== undefined ? _data["distance"] : <any>null;
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : <any>null;
            this.visitWaitTime = _data["visitWaitTime"] !== undefined ? _data["visitWaitTime"] : <any>null;
        }
    }

    static fromJS(data: any): ResourceDirectoryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDirectoryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["serviceDescription"] = this.serviceDescription !== undefined ? this.serviceDescription : <any>null;
        if (Array.isArray(this.areasOfNeed)) {
            data["areasOfNeed"] = [];
            for (let item of this.areasOfNeed)
                data["areasOfNeed"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["distance"] = this.distance !== undefined ? this.distance : <any>null;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>null;
        data["visitWaitTime"] = this.visitWaitTime !== undefined ? this.visitWaitTime : <any>null;
        return data;
    }

    clone(): ResourceDirectoryEntry {
        const json = this.toJSON();
        let result = new ResourceDirectoryEntry();
        result.init(json);
        return result;
    }
}

export interface IResourceDirectoryEntry {
    id?: string | null;
    type?: ResourceDirectoryEntryType;
    name?: string | null;
    address?: MailingAddress | null;
    phone?: string | null;
    website?: string | null;
    emailAddress?: string | null;
    notes?: string | null;
    serviceDescription?: string | null;
    areasOfNeed?: NeedViewModel[] | null;
    insuranceCompanies?: InsuranceViewModel[] | null;
    locations?: LocationViewModel[] | null;
    distance?: number | null;
    coordinates?: Coordinates | null;
    visitWaitTime?: VisitWaitTime | null;
}

export enum ResourceDirectoryEntryType {
    PhysicalProvider = "PhysicalProvider",
    OnlineProvider = "OnlineProvider",
    Partner = "Partner",
}

export class SearchResourceDirectoryEntriesRequest implements ISearchResourceDirectoryEntriesRequest {
    needCodes?: string[] | null;
    address?: MailingAddress | null;
    coordinates?: Coordinates | null;
    distance?: number;
    organizationIds?: string[] | null;
    districtIds?: string[] | null;
    insuranceIds?: string[] | null;
    branchId?: string | null;
    name?: string | null;
    hideBranchSpecificResources?: boolean;

    constructor(data?: ISearchResourceDirectoryEntriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["needCodes"])) {
                this.needCodes = [] as any;
                for (let item of _data["needCodes"])
                    this.needCodes!.push(item);
            }
            else {
                this.needCodes = <any>null;
            }
            this.address = _data["address"] ? MailingAddress.fromJS(_data["address"]) : <any>null;
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : <any>null;
            this.distance = _data["distance"] !== undefined ? _data["distance"] : <any>null;
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            else {
                this.organizationIds = <any>null;
            }
            if (Array.isArray(_data["districtIds"])) {
                this.districtIds = [] as any;
                for (let item of _data["districtIds"])
                    this.districtIds!.push(item);
            }
            else {
                this.districtIds = <any>null;
            }
            if (Array.isArray(_data["insuranceIds"])) {
                this.insuranceIds = [] as any;
                for (let item of _data["insuranceIds"])
                    this.insuranceIds!.push(item);
            }
            else {
                this.insuranceIds = <any>null;
            }
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.hideBranchSpecificResources = _data["hideBranchSpecificResources"] !== undefined ? _data["hideBranchSpecificResources"] : <any>null;
        }
    }

    static fromJS(data: any): SearchResourceDirectoryEntriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResourceDirectoryEntriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.needCodes)) {
            data["needCodes"] = [];
            for (let item of this.needCodes)
                data["needCodes"].push(item);
        }
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>null;
        data["distance"] = this.distance !== undefined ? this.distance : <any>null;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        if (Array.isArray(this.districtIds)) {
            data["districtIds"] = [];
            for (let item of this.districtIds)
                data["districtIds"].push(item);
        }
        if (Array.isArray(this.insuranceIds)) {
            data["insuranceIds"] = [];
            for (let item of this.insuranceIds)
                data["insuranceIds"].push(item);
        }
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["hideBranchSpecificResources"] = this.hideBranchSpecificResources !== undefined ? this.hideBranchSpecificResources : <any>null;
        return data;
    }

    clone(): SearchResourceDirectoryEntriesRequest {
        const json = this.toJSON();
        let result = new SearchResourceDirectoryEntriesRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchResourceDirectoryEntriesRequest {
    needCodes?: string[] | null;
    address?: MailingAddress | null;
    coordinates?: Coordinates | null;
    distance?: number;
    organizationIds?: string[] | null;
    districtIds?: string[] | null;
    insuranceIds?: string[] | null;
    branchId?: string | null;
    name?: string | null;
    hideBranchSpecificResources?: boolean;
}

export class GetAspenAnalyticsResponse implements IGetAspenAnalyticsResponse {
    analytics?: AspenAnalyticsViewModel[] | null;

    constructor(data?: IGetAspenAnalyticsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["analytics"])) {
                this.analytics = [] as any;
                for (let item of _data["analytics"])
                    this.analytics!.push(AspenAnalyticsViewModel.fromJS(item));
            }
            else {
                this.analytics = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAspenAnalyticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAspenAnalyticsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.analytics)) {
            data["analytics"] = [];
            for (let item of this.analytics)
                data["analytics"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAspenAnalyticsResponse {
        const json = this.toJSON();
        let result = new GetAspenAnalyticsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAspenAnalyticsResponse {
    analytics?: AspenAnalyticsViewModel[] | null;
}

export class AspenAnalyticsViewModel implements IAspenAnalyticsViewModel {
    assessmentCounts?: AssessmentCountsViewModel | null;
    caseCounts?: SchoolCaseCountsViewModel | null;
    branchName?: BranchName;

    constructor(data?: IAspenAnalyticsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentCounts = _data["assessmentCounts"] ? AssessmentCountsViewModel.fromJS(_data["assessmentCounts"]) : <any>null;
            this.caseCounts = _data["caseCounts"] ? SchoolCaseCountsViewModel.fromJS(_data["caseCounts"]) : <any>null;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : <any>null;
        }
    }

    static fromJS(data: any): AspenAnalyticsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AspenAnalyticsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentCounts"] = this.assessmentCounts ? this.assessmentCounts.toJSON() : <any>null;
        data["caseCounts"] = this.caseCounts ? this.caseCounts.toJSON() : <any>null;
        data["branchName"] = this.branchName !== undefined ? this.branchName : <any>null;
        return data;
    }

    clone(): AspenAnalyticsViewModel {
        const json = this.toJSON();
        let result = new AspenAnalyticsViewModel();
        result.init(json);
        return result;
    }
}

export interface IAspenAnalyticsViewModel {
    assessmentCounts?: AssessmentCountsViewModel | null;
    caseCounts?: SchoolCaseCountsViewModel | null;
    branchName?: BranchName;
}

export class AssessmentCountsViewModel implements IAssessmentCountsViewModel {
    totalAssessmentCount?: number;
    columbiaAssessmentCount?: number;
    levelTwoAssessmentCount?: number;
    selfScreeningCount?: number;
    frSelfScreeningCount?: number;
    frColumbiaCount?: number;

    constructor(data?: IAssessmentCountsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAssessmentCount = _data["totalAssessmentCount"] !== undefined ? _data["totalAssessmentCount"] : <any>null;
            this.columbiaAssessmentCount = _data["columbiaAssessmentCount"] !== undefined ? _data["columbiaAssessmentCount"] : <any>null;
            this.levelTwoAssessmentCount = _data["levelTwoAssessmentCount"] !== undefined ? _data["levelTwoAssessmentCount"] : <any>null;
            this.selfScreeningCount = _data["selfScreeningCount"] !== undefined ? _data["selfScreeningCount"] : <any>null;
            this.frSelfScreeningCount = _data["frSelfScreeningCount"] !== undefined ? _data["frSelfScreeningCount"] : <any>null;
            this.frColumbiaCount = _data["frColumbiaCount"] !== undefined ? _data["frColumbiaCount"] : <any>null;
        }
    }

    static fromJS(data: any): AssessmentCountsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentCountsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAssessmentCount"] = this.totalAssessmentCount !== undefined ? this.totalAssessmentCount : <any>null;
        data["columbiaAssessmentCount"] = this.columbiaAssessmentCount !== undefined ? this.columbiaAssessmentCount : <any>null;
        data["levelTwoAssessmentCount"] = this.levelTwoAssessmentCount !== undefined ? this.levelTwoAssessmentCount : <any>null;
        data["selfScreeningCount"] = this.selfScreeningCount !== undefined ? this.selfScreeningCount : <any>null;
        data["frSelfScreeningCount"] = this.frSelfScreeningCount !== undefined ? this.frSelfScreeningCount : <any>null;
        data["frColumbiaCount"] = this.frColumbiaCount !== undefined ? this.frColumbiaCount : <any>null;
        return data;
    }

    clone(): AssessmentCountsViewModel {
        const json = this.toJSON();
        let result = new AssessmentCountsViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssessmentCountsViewModel {
    totalAssessmentCount?: number;
    columbiaAssessmentCount?: number;
    levelTwoAssessmentCount?: number;
    selfScreeningCount?: number;
    frSelfScreeningCount?: number;
    frColumbiaCount?: number;
}

export class SchoolCaseCountsViewModel implements ISchoolCaseCountsViewModel {
    totalCases?: number;
    totalMediumRisk?: number;
    totalHighRisk?: number;

    constructor(data?: ISchoolCaseCountsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCases = _data["totalCases"] !== undefined ? _data["totalCases"] : <any>null;
            this.totalMediumRisk = _data["totalMediumRisk"] !== undefined ? _data["totalMediumRisk"] : <any>null;
            this.totalHighRisk = _data["totalHighRisk"] !== undefined ? _data["totalHighRisk"] : <any>null;
        }
    }

    static fromJS(data: any): SchoolCaseCountsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolCaseCountsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCases"] = this.totalCases !== undefined ? this.totalCases : <any>null;
        data["totalMediumRisk"] = this.totalMediumRisk !== undefined ? this.totalMediumRisk : <any>null;
        data["totalHighRisk"] = this.totalHighRisk !== undefined ? this.totalHighRisk : <any>null;
        return data;
    }

    clone(): SchoolCaseCountsViewModel {
        const json = this.toJSON();
        let result = new SchoolCaseCountsViewModel();
        result.init(json);
        return result;
    }
}

export interface ISchoolCaseCountsViewModel {
    totalCases?: number;
    totalMediumRisk?: number;
    totalHighRisk?: number;
}

export class GetStatsResponse implements IGetStatsResponse {
    districtStats?: AssessmentStatsViewModel[] | null;
    organizationStats?: AssessmentStatsViewModel[] | null;

    constructor(data?: IGetStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["districtStats"])) {
                this.districtStats = [] as any;
                for (let item of _data["districtStats"])
                    this.districtStats!.push(AssessmentStatsViewModel.fromJS(item));
            }
            else {
                this.districtStats = <any>null;
            }
            if (Array.isArray(_data["organizationStats"])) {
                this.organizationStats = [] as any;
                for (let item of _data["organizationStats"])
                    this.organizationStats!.push(AssessmentStatsViewModel.fromJS(item));
            }
            else {
                this.organizationStats = <any>null;
            }
        }
    }

    static fromJS(data: any): GetStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.districtStats)) {
            data["districtStats"] = [];
            for (let item of this.districtStats)
                data["districtStats"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationStats)) {
            data["organizationStats"] = [];
            for (let item of this.organizationStats)
                data["organizationStats"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetStatsResponse {
        const json = this.toJSON();
        let result = new GetStatsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetStatsResponse {
    districtStats?: AssessmentStatsViewModel[] | null;
    organizationStats?: AssessmentStatsViewModel[] | null;
}

export class AssessmentStatsViewModel implements IAssessmentStatsViewModel {
    name?: string | null;
    districtName?: string | null;
    totalAssessments?: number;
    totalMediumRisk?: number;
    totalHighRisk?: number;

    constructor(data?: IAssessmentStatsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.totalAssessments = _data["totalAssessments"] !== undefined ? _data["totalAssessments"] : <any>null;
            this.totalMediumRisk = _data["totalMediumRisk"] !== undefined ? _data["totalMediumRisk"] : <any>null;
            this.totalHighRisk = _data["totalHighRisk"] !== undefined ? _data["totalHighRisk"] : <any>null;
        }
    }

    static fromJS(data: any): AssessmentStatsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentStatsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["totalAssessments"] = this.totalAssessments !== undefined ? this.totalAssessments : <any>null;
        data["totalMediumRisk"] = this.totalMediumRisk !== undefined ? this.totalMediumRisk : <any>null;
        data["totalHighRisk"] = this.totalHighRisk !== undefined ? this.totalHighRisk : <any>null;
        return data;
    }

    clone(): AssessmentStatsViewModel {
        const json = this.toJSON();
        let result = new AssessmentStatsViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssessmentStatsViewModel {
    name?: string | null;
    districtName?: string | null;
    totalAssessments?: number;
    totalMediumRisk?: number;
    totalHighRisk?: number;
}

export class GetUserPreviewsResponse implements IGetUserPreviewsResponse {
    userPreviews?: UserPreview[] | null;
    totalCount?: number;

    constructor(data?: IGetUserPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userPreviews"])) {
                this.userPreviews = [] as any;
                for (let item of _data["userPreviews"])
                    this.userPreviews!.push(UserPreview.fromJS(item));
            }
            else {
                this.userPreviews = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): GetUserPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userPreviews)) {
            data["userPreviews"] = [];
            for (let item of this.userPreviews)
                data["userPreviews"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }

    clone(): GetUserPreviewsResponse {
        const json = this.toJSON();
        let result = new GetUserPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserPreviewsResponse {
    userPreviews?: UserPreview[] | null;
    totalCount?: number;
}

export class UserPreview implements IUserPreview {
    id?: string | null;
    userId?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    emailAddress?: string | null;
    role?: string | null;
    createdDate?: Date;
    defaultProfileType?: ProfileType;

    constructor(data?: IUserPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.defaultProfileType = _data["defaultProfileType"] !== undefined ? _data["defaultProfileType"] : <any>null;
        }
    }

    static fromJS(data: any): UserPreview {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["defaultProfileType"] = this.defaultProfileType !== undefined ? this.defaultProfileType : <any>null;
        return data;
    }

    clone(): UserPreview {
        const json = this.toJSON();
        let result = new UserPreview();
        result.init(json);
        return result;
    }
}

export interface IUserPreview {
    id?: string | null;
    userId?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    emailAddress?: string | null;
    role?: string | null;
    createdDate?: Date;
    defaultProfileType?: ProfileType;
}

export enum SortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class CreateUserResponse implements ICreateUserResponse {
    userId?: string | null;

    constructor(data?: ICreateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }

    clone(): CreateUserResponse {
        const json = this.toJSON();
        let result = new CreateUserResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateUserResponse {
    userId?: string | null;
}

export class CreateUserRequest implements ICreateUserRequest {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    profileType?: ProfileType;
    role?: string | null;
    organizationIds?: string[] | null;
    responseType?: IncidentResponseType | null;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.profileType = _data["profileType"] !== undefined ? _data["profileType"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            else {
                this.organizationIds = <any>null;
            }
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["profileType"] = this.profileType !== undefined ? this.profileType : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        data["responseType"] = this.responseType !== undefined ? this.responseType : <any>null;
        return data;
    }

    clone(): CreateUserRequest {
        const json = this.toJSON();
        let result = new CreateUserRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateUserRequest {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    profileType?: ProfileType;
    role?: string | null;
    organizationIds?: string[] | null;
    responseType?: IncidentResponseType | null;
}

export class GetByUserIdResponse implements IGetByUserIdResponse {
    user?: UserViewModel | null;

    constructor(data?: IGetByUserIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): GetByUserIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetByUserIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }

    clone(): GetByUserIdResponse {
        const json = this.toJSON();
        let result = new GetByUserIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetByUserIdResponse {
    user?: UserViewModel | null;
}

export class UpdateUserResponse implements IUpdateUserResponse {
    userId?: string | null;

    constructor(data?: IUpdateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }

    clone(): UpdateUserResponse {
        const json = this.toJSON();
        let result = new UpdateUserResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserResponse {
    userId?: string | null;
}

export class UpdateUserRequest implements IUpdateUserRequest {
    userId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    profiles?: UserProfileDto[] | null;
    responseType?: IncidentResponseType | null;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(UserProfileDto.fromJS(item));
            }
            else {
                this.profiles = <any>null;
            }
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        data["responseType"] = this.responseType !== undefined ? this.responseType : <any>null;
        return data;
    }

    clone(): UpdateUserRequest {
        const json = this.toJSON();
        let result = new UpdateUserRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserRequest {
    userId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    profiles?: UserProfileDto[] | null;
    responseType?: IncidentResponseType | null;
}

export class UserProfileDto implements IUserProfileDto {
    type?: ProfileType;
    role?: string | null;
    organizations?: string[] | null;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(item);
            }
            else {
                this.organizations = <any>null;
            }
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item);
        }
        return data;
    }

    clone(): UserProfileDto {
        const json = this.toJSON();
        let result = new UserProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileDto {
    type?: ProfileType;
    role?: string | null;
    organizations?: string[] | null;
}

export class GetIncidentResponseUsersResponse implements IGetIncidentResponseUsersResponse {
    users?: IncidentResponseProfileView[] | null;

    constructor(data?: IGetIncidentResponseUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(IncidentResponseProfileView.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): GetIncidentResponseUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncidentResponseUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetIncidentResponseUsersResponse {
        const json = this.toJSON();
        let result = new GetIncidentResponseUsersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetIncidentResponseUsersResponse {
    users?: IncidentResponseProfileView[] | null;
}

export class IncidentResponseProfileView implements IIncidentResponseProfileView {
    userId?: string | null;
    systemId?: string | null;
    name?: string | null;
    emailAddress?: string | null;
    role?: string | null;
    responseType?: IncidentResponseType | null;

    constructor(data?: IIncidentResponseProfileView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : <any>null;
        }
    }

    static fromJS(data: any): IncidentResponseProfileView {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentResponseProfileView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["responseType"] = this.responseType !== undefined ? this.responseType : <any>null;
        return data;
    }

    clone(): IncidentResponseProfileView {
        const json = this.toJSON();
        let result = new IncidentResponseProfileView();
        result.init(json);
        return result;
    }
}

export interface IIncidentResponseProfileView {
    userId?: string | null;
    systemId?: string | null;
    name?: string | null;
    emailAddress?: string | null;
    role?: string | null;
    responseType?: IncidentResponseType | null;
}

export class GetIncidentResponseUsersRequest implements IGetIncidentResponseUsersRequest {
    firstName?: string | null;
    lastName?: string | null;
    role?: string | null;
    responseType?: IncidentResponseType | null;
    emailAddress?: string | null;

    constructor(data?: IGetIncidentResponseUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
        }
    }

    static fromJS(data: any): GetIncidentResponseUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncidentResponseUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["responseType"] = this.responseType !== undefined ? this.responseType : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        return data;
    }

    clone(): GetIncidentResponseUsersRequest {
        const json = this.toJSON();
        let result = new GetIncidentResponseUsersRequest();
        result.init(json);
        return result;
    }
}

export interface IGetIncidentResponseUsersRequest {
    firstName?: string | null;
    lastName?: string | null;
    role?: string | null;
    responseType?: IncidentResponseType | null;
    emailAddress?: string | null;
}

export class SearchJotformSubmissionsResponse implements ISearchJotformSubmissionsResponse {
    previews?: JotformSubmissionsPreview[] | null;
    resultsLength?: number;

    constructor(data?: ISearchJotformSubmissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["previews"])) {
                this.previews = [] as any;
                for (let item of _data["previews"])
                    this.previews!.push(JotformSubmissionsPreview.fromJS(item));
            }
            else {
                this.previews = <any>null;
            }
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
        }
    }

    static fromJS(data: any): SearchJotformSubmissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchJotformSubmissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.previews)) {
            data["previews"] = [];
            for (let item of this.previews)
                data["previews"].push(item.toJSON());
        }
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        return data;
    }

    clone(): SearchJotformSubmissionsResponse {
        const json = this.toJSON();
        let result = new SearchJotformSubmissionsResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchJotformSubmissionsResponse {
    previews?: JotformSubmissionsPreview[] | null;
    resultsLength?: number;
}

export class JotformSubmissionsPreview implements IJotformSubmissionsPreview {
    id?: string | null;
    studentFullName?: string | null;
    parentFullName?: string | null;
    organizationName?: string | null;
    districtName?: string | null;
    birthDate?: Date | null;
    declined?: boolean;
    profileComplete?: boolean;
    studentEmailAddress?: string | null;
    dateSigned?: Date | null;
    pdfUrl?: string | null;
    lastSentEmailDate?: Date | null;

    constructor(data?: IJotformSubmissionsPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.studentFullName = _data["studentFullName"] !== undefined ? _data["studentFullName"] : <any>null;
            this.parentFullName = _data["parentFullName"] !== undefined ? _data["parentFullName"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.districtName = _data["districtName"] !== undefined ? _data["districtName"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.declined = _data["declined"] !== undefined ? _data["declined"] : <any>null;
            this.profileComplete = _data["profileComplete"] !== undefined ? _data["profileComplete"] : <any>null;
            this.studentEmailAddress = _data["studentEmailAddress"] !== undefined ? _data["studentEmailAddress"] : <any>null;
            this.dateSigned = _data["dateSigned"] ? new Date(_data["dateSigned"].toString()) : <any>null;
            this.pdfUrl = _data["pdfUrl"] !== undefined ? _data["pdfUrl"] : <any>null;
            this.lastSentEmailDate = _data["lastSentEmailDate"] ? new Date(_data["lastSentEmailDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): JotformSubmissionsPreview {
        data = typeof data === 'object' ? data : {};
        let result = new JotformSubmissionsPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["studentFullName"] = this.studentFullName !== undefined ? this.studentFullName : <any>null;
        data["parentFullName"] = this.parentFullName !== undefined ? this.parentFullName : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["districtName"] = this.districtName !== undefined ? this.districtName : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["declined"] = this.declined !== undefined ? this.declined : <any>null;
        data["profileComplete"] = this.profileComplete !== undefined ? this.profileComplete : <any>null;
        data["studentEmailAddress"] = this.studentEmailAddress !== undefined ? this.studentEmailAddress : <any>null;
        data["dateSigned"] = this.dateSigned ? this.dateSigned.toISOString() : <any>null;
        data["pdfUrl"] = this.pdfUrl !== undefined ? this.pdfUrl : <any>null;
        data["lastSentEmailDate"] = this.lastSentEmailDate ? this.lastSentEmailDate.toISOString() : <any>null;
        return data;
    }

    clone(): JotformSubmissionsPreview {
        const json = this.toJSON();
        let result = new JotformSubmissionsPreview();
        result.init(json);
        return result;
    }
}

export interface IJotformSubmissionsPreview {
    id?: string | null;
    studentFullName?: string | null;
    parentFullName?: string | null;
    organizationName?: string | null;
    districtName?: string | null;
    birthDate?: Date | null;
    declined?: boolean;
    profileComplete?: boolean;
    studentEmailAddress?: string | null;
    dateSigned?: Date | null;
    pdfUrl?: string | null;
    lastSentEmailDate?: Date | null;
}

export class SearchJotformSubmissionsRequest implements ISearchJotformSubmissionsRequest {
    firstName?: string | null;
    lastName?: string | null;
    assignedOrganizationIds?: string[] | null;
    assignedDistrictIds?: string[] | null;
    dateOfBirth?: string | null;
    emailAddress?: string | null;
    filteredOrganizationIds?: string[] | null;
    districtIds?: string[] | null;
    declined?: boolean | null;
    signupComplete?: boolean | null;

    constructor(data?: ISearchJotformSubmissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            if (Array.isArray(_data["assignedOrganizationIds"])) {
                this.assignedOrganizationIds = [] as any;
                for (let item of _data["assignedOrganizationIds"])
                    this.assignedOrganizationIds!.push(item);
            }
            else {
                this.assignedOrganizationIds = <any>null;
            }
            if (Array.isArray(_data["assignedDistrictIds"])) {
                this.assignedDistrictIds = [] as any;
                for (let item of _data["assignedDistrictIds"])
                    this.assignedDistrictIds!.push(item);
            }
            else {
                this.assignedDistrictIds = <any>null;
            }
            this.dateOfBirth = _data["dateOfBirth"] !== undefined ? _data["dateOfBirth"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            if (Array.isArray(_data["filteredOrganizationIds"])) {
                this.filteredOrganizationIds = [] as any;
                for (let item of _data["filteredOrganizationIds"])
                    this.filteredOrganizationIds!.push(item);
            }
            else {
                this.filteredOrganizationIds = <any>null;
            }
            if (Array.isArray(_data["districtIds"])) {
                this.districtIds = [] as any;
                for (let item of _data["districtIds"])
                    this.districtIds!.push(item);
            }
            else {
                this.districtIds = <any>null;
            }
            this.declined = _data["declined"] !== undefined ? _data["declined"] : <any>null;
            this.signupComplete = _data["signupComplete"] !== undefined ? _data["signupComplete"] : <any>null;
        }
    }

    static fromJS(data: any): SearchJotformSubmissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchJotformSubmissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        if (Array.isArray(this.assignedOrganizationIds)) {
            data["assignedOrganizationIds"] = [];
            for (let item of this.assignedOrganizationIds)
                data["assignedOrganizationIds"].push(item);
        }
        if (Array.isArray(this.assignedDistrictIds)) {
            data["assignedDistrictIds"] = [];
            for (let item of this.assignedDistrictIds)
                data["assignedDistrictIds"].push(item);
        }
        data["dateOfBirth"] = this.dateOfBirth !== undefined ? this.dateOfBirth : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        if (Array.isArray(this.filteredOrganizationIds)) {
            data["filteredOrganizationIds"] = [];
            for (let item of this.filteredOrganizationIds)
                data["filteredOrganizationIds"].push(item);
        }
        if (Array.isArray(this.districtIds)) {
            data["districtIds"] = [];
            for (let item of this.districtIds)
                data["districtIds"].push(item);
        }
        data["declined"] = this.declined !== undefined ? this.declined : <any>null;
        data["signupComplete"] = this.signupComplete !== undefined ? this.signupComplete : <any>null;
        return data;
    }

    clone(): SearchJotformSubmissionsRequest {
        const json = this.toJSON();
        let result = new SearchJotformSubmissionsRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchJotformSubmissionsRequest {
    firstName?: string | null;
    lastName?: string | null;
    assignedOrganizationIds?: string[] | null;
    assignedDistrictIds?: string[] | null;
    dateOfBirth?: string | null;
    emailAddress?: string | null;
    filteredOrganizationIds?: string[] | null;
    districtIds?: string[] | null;
    declined?: boolean | null;
    signupComplete?: boolean | null;
}

export class GetJotformSubmissionRawDataByIdResponse implements IGetJotformSubmissionRawDataByIdResponse {
    rawFormData?: string | null;

    constructor(data?: IGetJotformSubmissionRawDataByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawFormData = _data["rawFormData"] !== undefined ? _data["rawFormData"] : <any>null;
        }
    }

    static fromJS(data: any): GetJotformSubmissionRawDataByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJotformSubmissionRawDataByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawFormData"] = this.rawFormData !== undefined ? this.rawFormData : <any>null;
        return data;
    }

    clone(): GetJotformSubmissionRawDataByIdResponse {
        const json = this.toJSON();
        let result = new GetJotformSubmissionRawDataByIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetJotformSubmissionRawDataByIdResponse {
    rawFormData?: string | null;
}

export class Feature implements IFeature {
    name?: string | null;
    enabled?: boolean;

    constructor(data?: IFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
        }
    }

    static fromJS(data: any): Feature {
        data = typeof data === 'object' ? data : {};
        let result = new Feature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        return data;
    }

    clone(): Feature {
        const json = this.toJSON();
        let result = new Feature();
        result.init(json);
        return result;
    }
}

export interface IFeature {
    name?: string | null;
    enabled?: boolean;
}

export class GetSchoolDistrictsResponse implements IGetSchoolDistrictsResponse {
    districts?: DistrictViewModel[] | null;

    constructor(data?: IGetSchoolDistrictsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(DistrictViewModel.fromJS(item));
            }
            else {
                this.districts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSchoolDistrictsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSchoolDistrictsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetSchoolDistrictsResponse {
        const json = this.toJSON();
        let result = new GetSchoolDistrictsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSchoolDistrictsResponse {
    districts?: DistrictViewModel[] | null;
}

export class GetSchoolOrganizationsResponse implements IGetSchoolOrganizationsResponse {
    organizations?: OrganizationViewModel[] | null;

    constructor(data?: IGetSchoolOrganizationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationViewModel.fromJS(item));
            }
            else {
                this.organizations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSchoolOrganizationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSchoolOrganizationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetSchoolOrganizationsResponse {
        const json = this.toJSON();
        let result = new GetSchoolOrganizationsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSchoolOrganizationsResponse {
    organizations?: OrganizationViewModel[] | null;
}

export class GetDistrictsResponse2 implements IGetDistrictsResponse2 {
    districts?: DistrictViewModel[] | null;

    constructor(data?: IGetDistrictsResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(DistrictViewModel.fromJS(item));
            }
            else {
                this.districts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDistrictsResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistrictsResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDistrictsResponse2 {
        const json = this.toJSON();
        let result = new GetDistrictsResponse2();
        result.init(json);
        return result;
    }
}

export interface IGetDistrictsResponse2 {
    districts?: DistrictViewModel[] | null;
}

export class GetOrganizationsResponse2 implements IGetOrganizationsResponse2 {
    organizations?: OrganizationViewModel[] | null;

    constructor(data?: IGetOrganizationsResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationViewModel.fromJS(item));
            }
            else {
                this.organizations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetOrganizationsResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationsResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetOrganizationsResponse2 {
        const json = this.toJSON();
        let result = new GetOrganizationsResponse2();
        result.init(json);
        return result;
    }
}

export interface IGetOrganizationsResponse2 {
    organizations?: OrganizationViewModel[] | null;
}

export class SaveSecondaryAssessmentDataResponse implements ISaveSecondaryAssessmentDataResponse {
    secondaryAssessmentId?: string | null;

    constructor(data?: ISaveSecondaryAssessmentDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secondaryAssessmentId = _data["secondaryAssessmentId"] !== undefined ? _data["secondaryAssessmentId"] : <any>null;
        }
    }

    static fromJS(data: any): SaveSecondaryAssessmentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSecondaryAssessmentDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryAssessmentId"] = this.secondaryAssessmentId !== undefined ? this.secondaryAssessmentId : <any>null;
        return data;
    }

    clone(): SaveSecondaryAssessmentDataResponse {
        const json = this.toJSON();
        let result = new SaveSecondaryAssessmentDataResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveSecondaryAssessmentDataResponse {
    secondaryAssessmentId?: string | null;
}

export class SaveSecondaryAssessmentDataRequest implements ISaveSecondaryAssessmentDataRequest {
    assessmentResultId?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;

    constructor(data?: ISaveSecondaryAssessmentDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentResultId = _data["assessmentResultId"] !== undefined ? _data["assessmentResultId"] : <any>null;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : <any>null;
            this.priorityLevel = _data["priorityLevel"] !== undefined ? _data["priorityLevel"] : <any>null;
        }
    }

    static fromJS(data: any): SaveSecondaryAssessmentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSecondaryAssessmentDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentResultId"] = this.assessmentResultId !== undefined ? this.assessmentResultId : <any>null;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : <any>null;
        data["priorityLevel"] = this.priorityLevel !== undefined ? this.priorityLevel : <any>null;
        return data;
    }

    clone(): SaveSecondaryAssessmentDataRequest {
        const json = this.toJSON();
        let result = new SaveSecondaryAssessmentDataRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveSecondaryAssessmentDataRequest {
    assessmentResultId?: string | null;
    riskLevel?: string | null;
    priorityLevel?: string | null;
}

export class GetDemographicDataResponse implements IGetDemographicDataResponse {
    demographicData?: DemographicDataViewModel | null;

    constructor(data?: IGetDemographicDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.demographicData = _data["demographicData"] ? DemographicDataViewModel.fromJS(_data["demographicData"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDemographicDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDemographicDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["demographicData"] = this.demographicData ? this.demographicData.toJSON() : <any>null;
        return data;
    }

    clone(): GetDemographicDataResponse {
        const json = this.toJSON();
        let result = new GetDemographicDataResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDemographicDataResponse {
    demographicData?: DemographicDataViewModel | null;
}

export class GetAuthUserResponse implements IGetAuthUserResponse {
    authUser?: AuthUserViewModel | null;

    constructor(data?: IGetAuthUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authUser = _data["authUser"] ? AuthUserViewModel.fromJS(_data["authUser"]) : <any>null;
        }
    }

    static fromJS(data: any): GetAuthUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authUser"] = this.authUser ? this.authUser.toJSON() : <any>null;
        return data;
    }

    clone(): GetAuthUserResponse {
        const json = this.toJSON();
        let result = new GetAuthUserResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAuthUserResponse {
    authUser?: AuthUserViewModel | null;
}

export class AuthUserViewModel implements IAuthUserViewModel {
    userId?: string | null;
    email?: string | null;
    userName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    branchName?: string | null;
    roles?: string[] | null;
    permissions?: string[] | null;
    counselor?: CounselorViewModel | null;
    participant?: ParticipantDataViewModel | null;
    profileType?: ProfileType;
    branchIds?: string[] | null;
    userProfiles?: ProfileType[] | null;

    constructor(data?: IAuthUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            else {
                this.permissions = <any>null;
            }
            this.counselor = _data["counselor"] ? CounselorViewModel.fromJS(_data["counselor"]) : <any>null;
            this.participant = _data["participant"] ? ParticipantDataViewModel.fromJS(_data["participant"]) : <any>null;
            this.profileType = _data["profileType"] !== undefined ? _data["profileType"] : <any>null;
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            else {
                this.branchIds = <any>null;
            }
            if (Array.isArray(_data["userProfiles"])) {
                this.userProfiles = [] as any;
                for (let item of _data["userProfiles"])
                    this.userProfiles!.push(item);
            }
            else {
                this.userProfiles = <any>null;
            }
        }
    }

    static fromJS(data: any): AuthUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["branchName"] = this.branchName !== undefined ? this.branchName : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["counselor"] = this.counselor ? this.counselor.toJSON() : <any>null;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>null;
        data["profileType"] = this.profileType !== undefined ? this.profileType : <any>null;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        if (Array.isArray(this.userProfiles)) {
            data["userProfiles"] = [];
            for (let item of this.userProfiles)
                data["userProfiles"].push(item);
        }
        return data;
    }

    clone(): AuthUserViewModel {
        const json = this.toJSON();
        let result = new AuthUserViewModel();
        result.init(json);
        return result;
    }
}

export interface IAuthUserViewModel {
    userId?: string | null;
    email?: string | null;
    userName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    branchName?: string | null;
    roles?: string[] | null;
    permissions?: string[] | null;
    counselor?: CounselorViewModel | null;
    participant?: ParticipantDataViewModel | null;
    profileType?: ProfileType;
    branchIds?: string[] | null;
    userProfiles?: ProfileType[] | null;
}

export class CreatePlaceholderParticipantResponse implements ICreatePlaceholderParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;

    constructor(data?: ICreatePlaceholderParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alreadyExists = _data["alreadyExists"] !== undefined ? _data["alreadyExists"] : <any>null;
        }
    }

    static fromJS(data: any): CreatePlaceholderParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlaceholderParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alreadyExists"] = this.alreadyExists !== undefined ? this.alreadyExists : <any>null;
        return data;
    }

    clone(): CreatePlaceholderParticipantResponse {
        const json = this.toJSON();
        let result = new CreatePlaceholderParticipantResponse();
        result.init(json);
        return result;
    }
}

export interface ICreatePlaceholderParticipantResponse {
    id?: string | null;
    alreadyExists?: boolean;
}

export class CreatePlaceholderParticipantRequest implements ICreatePlaceholderParticipantRequest {
    email?: string | null;
    branch?: BranchName;
    linkedAssessmentIds?: string[] | null;

    constructor(data?: ICreatePlaceholderParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.branch = _data["branch"] !== undefined ? _data["branch"] : <any>null;
            if (Array.isArray(_data["linkedAssessmentIds"])) {
                this.linkedAssessmentIds = [] as any;
                for (let item of _data["linkedAssessmentIds"])
                    this.linkedAssessmentIds!.push(item);
            }
            else {
                this.linkedAssessmentIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CreatePlaceholderParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlaceholderParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["branch"] = this.branch !== undefined ? this.branch : <any>null;
        if (Array.isArray(this.linkedAssessmentIds)) {
            data["linkedAssessmentIds"] = [];
            for (let item of this.linkedAssessmentIds)
                data["linkedAssessmentIds"].push(item);
        }
        return data;
    }

    clone(): CreatePlaceholderParticipantRequest {
        const json = this.toJSON();
        let result = new CreatePlaceholderParticipantRequest();
        result.init(json);
        return result;
    }
}

export interface ICreatePlaceholderParticipantRequest {
    email?: string | null;
    branch?: BranchName;
    linkedAssessmentIds?: string[] | null;
}

export class LinkPlaceholderToUserResponse implements ILinkPlaceholderToUserResponse {
    alreadyAssignedUserId?: boolean;
    participantId?: string | null;
    linkSuccessful?: boolean;
    branchName?: BranchName | null;
    branchId?: string | null;
    authUser?: AuthUserViewModel | null;

    constructor(data?: ILinkPlaceholderToUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyAssignedUserId = _data["alreadyAssignedUserId"] !== undefined ? _data["alreadyAssignedUserId"] : <any>null;
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
            this.linkSuccessful = _data["linkSuccessful"] !== undefined ? _data["linkSuccessful"] : <any>null;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : <any>null;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.authUser = _data["authUser"] ? AuthUserViewModel.fromJS(_data["authUser"]) : <any>null;
        }
    }

    static fromJS(data: any): LinkPlaceholderToUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkPlaceholderToUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyAssignedUserId"] = this.alreadyAssignedUserId !== undefined ? this.alreadyAssignedUserId : <any>null;
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        data["linkSuccessful"] = this.linkSuccessful !== undefined ? this.linkSuccessful : <any>null;
        data["branchName"] = this.branchName !== undefined ? this.branchName : <any>null;
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["authUser"] = this.authUser ? this.authUser.toJSON() : <any>null;
        return data;
    }

    clone(): LinkPlaceholderToUserResponse {
        const json = this.toJSON();
        let result = new LinkPlaceholderToUserResponse();
        result.init(json);
        return result;
    }
}

export interface ILinkPlaceholderToUserResponse {
    alreadyAssignedUserId?: boolean;
    participantId?: string | null;
    linkSuccessful?: boolean;
    branchName?: BranchName | null;
    branchId?: string | null;
    authUser?: AuthUserViewModel | null;
}

export class LinkPlaceholderToUserRequest implements ILinkPlaceholderToUserRequest {
    email?: string | null;
    userId?: string | null;

    constructor(data?: ILinkPlaceholderToUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): LinkPlaceholderToUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkPlaceholderToUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }

    clone(): LinkPlaceholderToUserRequest {
        const json = this.toJSON();
        let result = new LinkPlaceholderToUserRequest();
        result.init(json);
        return result;
    }
}

export interface ILinkPlaceholderToUserRequest {
    email?: string | null;
    userId?: string | null;
}

export class GetDepartmentsResponse implements IGetDepartmentsResponse {
    departments?: OrganizationViewModel[] | null;

    constructor(data?: IGetDepartmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(OrganizationViewModel.fromJS(item));
            }
            else {
                this.departments = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDepartmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDepartmentsResponse {
        const json = this.toJSON();
        let result = new GetDepartmentsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDepartmentsResponse {
    departments?: OrganizationViewModel[] | null;
}

export class CheckIfUserEmailExistsResponse implements ICheckIfUserEmailExistsResponse {
    userExists?: boolean;

    constructor(data?: ICheckIfUserEmailExistsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userExists = _data["userExists"] !== undefined ? _data["userExists"] : <any>null;
        }
    }

    static fromJS(data: any): CheckIfUserEmailExistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIfUserEmailExistsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userExists"] = this.userExists !== undefined ? this.userExists : <any>null;
        return data;
    }

    clone(): CheckIfUserEmailExistsResponse {
        const json = this.toJSON();
        let result = new CheckIfUserEmailExistsResponse();
        result.init(json);
        return result;
    }
}

export interface ICheckIfUserEmailExistsResponse {
    userExists?: boolean;
}

export class GetAssessmentBranchResponse implements IGetAssessmentBranchResponse {
    branchId?: string | null;
    branchName?: BranchName;

    constructor(data?: IGetAssessmentBranchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : <any>null;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : <any>null;
        }
    }

    static fromJS(data: any): GetAssessmentBranchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssessmentBranchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId !== undefined ? this.branchId : <any>null;
        data["branchName"] = this.branchName !== undefined ? this.branchName : <any>null;
        return data;
    }

    clone(): GetAssessmentBranchResponse {
        const json = this.toJSON();
        let result = new GetAssessmentBranchResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAssessmentBranchResponse {
    branchId?: string | null;
    branchName?: BranchName;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}